//guuds_view 통합파일 20220823

var $win = $(window);
var $doc = $(document);
var $body = $('body'); 

Kakao.init('3a0fae3e22d3501229f2bc0684ce4a00');

function sendLink() {
	Kakao.Link.sendDefault({
		objectType: 'feed',
		content: {
			title: goodsView.goodItems.ITEM_NAME,
			description: goodsView.goodItems.SIMPLE_DESC_NO_TAG,
			imageUrl: jsdata.cImg,
			link: {
				mobileWebUrl: jsdata.urlDomain + '/shop/goodsView?itemId=' + jsdata.itemId,
				webUrl: jsdata.urlDomain + '/shop/goodsView?itemId=' + jsdata.itemId,
			},
		},
		social: {
			likeCount: 0,
			commentCount: 0,
			sharedCount: 0,
		},
		buttons: [
			{
				title: '자세히보기',
				link: {
					mobileWebUrl: jsdata.urlDomain + '/shop/goodsView?itemId=' + jsdata.itemId,
					webUrl: jsdata.urlDomain + '/shop/goodsView?itemId=' + jsdata.itemId,
				},
			},
		],
	});
}

function godvBtnScroll(moveScroll) {
	document.getElementById(moveScroll).scrollIntoView();
}

function scrollSet(viewYn) {
	// body 스크롤 X
	if (viewYn === 'Y') {
	  document.documentElement.style.overflow = 'hidden';
	  document.body.style.overflow = 'hidden';
	} else {
	  document.documentElement.style.overflow = '';
	  document.body.style.overflow = '';
	}
  }


var appDisc = function appDisc() {
	$doc.on('click', '.btn__question', function(e) {
		e.preventDefault();

		var $this = $(this);

		if ($this.hasClass('show')) $this.removeClass('show');
		else $this.addClass('show');
	});

	$doc.on('click', '.fb__layer__highDiscount .btn__close', function(e) {
		e.preventDefault();

		var $this = $('fb__layer__highDiscount');

		$('.btn__question').removeClass('show');
		$this.removeAttr('style');
	});

	$doc.on('click', '.fb__layer__highDiscount .btn__close', function(e) {
		e.preventDefault();

		var $this = $('fb__layer__highDiscount');

		$('.btn__question').removeClass('show');
		$this.removeAttr('style');
	});
};

/* SSG DAY 타임세일 노출용도 포멧팅 (MM/DD HH24:MI) */
var formatSsgDate = function formatSsgDate(inputDate) {
	  const date = new Date(inputDate);
	  
	  const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 월은 0부터 시작하므로 +1, 2자릿수 포맷
	  const day = date.getDate().toString().padStart(2, '0'); // 2자릿수 포맷
	  const hours = date.getHours().toString().padStart(2, '0'); // 2자릿수 포맷
	  const minutes = date.getMinutes().toString().padStart(2, '0'); // 2자릿수 포맷

	  const formattedDate = `${month}/${day} ${hours}:${minutes}`;

	  return formattedDate;
};

var unAreaDisc = function unAreaDisc() {
	$doc.on('click', '.unArea', function() {
		var $this = $(this);

		if ($this.hasClass('show')) {
			$this.removeClass('show');
			$('.fb__layer__unArea').hide();
		} else {
			$this.addClass('show');
			$('.fb__layer__unArea').show();
		}
	});

	$doc.on('click', '.fb__layer__unArea .btn__close', function(e) {
		e.preventDefault();

		var $this = $('.fb__layer__unArea');

		$('.unArea').removeClass('show');
		$this.removeAttr('style');
	});
};

var exhiView = function exhiView() {
	$doc.on('click', '.btn__displayAll', function(e) {
		e.preventDefault();

		var $this = $(this);

		if ($this.hasClass('show')) {
			$this.removeClass('show');
			$('.displayAll').removeClass('show');
		} else {
			$this.addClass('show');
			$('.displayAll').addClass('show');
		}

		$doc.on('mouseleave', '.right__detail__info', function() {
			$('.displayAll, .btn__displayAll').removeClass('show');
		});
	});
};

var etc = function etc() {
	// 상품 공유하기
	$doc.on('click', '.btn__share', function() {
		var $this = $(this);

		if ($this.hasClass('show')) $this.removeClass('show');
		else $this.addClass('show');
	});
};

var prodPic = function prodPic() {
	var mainListLength = document.querySelectorAll('.goodsView__pdImg__swiper').length;
	var pagerTotal = document.getElementById('pagerTotal');
	var pagerActive = document.getElementById('pagerActive');

	if (mainListLength > 1) {
		var prodPicThumbs = new Swiper('.thumbs.swiper-container', {
			slidesPerView: 'auto',
			navigation: {
				prevEl: '.thumbs__button.prev-btn',
				nextEl: '.thumbs__button.next-btn',
			},
		});

		var prodPicswiper = new Swiper('.goodsView__pdImg', {
			loop: false,
			navigation: {
				prevEl: '.goodsView__pdImg__button.prev-btn',
				nextEl: '.goodsView__pdImg__button.next-btn',
			},
			thumbs: {
				swiper: prodPicThumbs,
			},
			on: {
				slideChangeTransitionEnd() {
					if (goodsView.player['handstick--1']) {
						$('.content__video__play').removeClass('hide');
						$('.content__video__thumbnail').removeClass('hide');
						$('.goodsView__pdImg-thumbs').removeClass('hide');
						goodsView.player['handstick--1'].pause();
					}
				},
			},
		});
	}

	if (mainListLength <= 1) $('.goodsView__pdImg__button, .goodsView__pdImg__pagination, .goodsView__pdImg-thumbs').hide();
	if (mainListLength <= 7) $('.thumbs.swiper-container > ul').css('justify-content', 'center');
};

var morePd = function morePd() {
	var moreList = $('.morePd__swiper').length;

	var morePdswiper = new Swiper('.morePd .goodsViewComm__slider', {
		navigation: {
			prevEl: '.morePd-nav.prev-btn',
			nextEl: '.morePd-nav.next-btn',
		},
		slidesPerView: 4,
		spaceBetween: 20,
	});

	if (moreList <= 4)
		$('.morePd .goodsViewComm__slider')
			.next()
			.hide();
};

var samePd = function samePd() {
	var samePdList = $('.samePd__swiper').length;

	var samePdswiper = new Swiper('.samePd .goodsViewComm__slider', {
		navigation: {
			prevEl: '.samePd-nav.prev-btn',
			nextEl: '.samePd-nav.next-btn',
		},
		slidesPerView: 4,
		spaceBetween: 20,
	});

	if (samePdList <= 4)
		$('.samePd .goodsViewComm__slider')
			.next()
			.hide();
};

var categoryPd = function categoryPd() {
	var categoryPdList = $('.categoryPd__swiper').length;

	var categoryPdswiper = new Swiper('.categoryPd .goodsViewComm__slider', {
		navigation: {
			prevEl: '.categoryPd-nav.prev-btn',
			nextEl: '.categoryPd-nav.next-btn',
		},
		slidesPerView: 4,
		spaceBetween: 20,
	});

	if (categoryPdList <= 4)
		$('.categoryPd .goodsViewComm__slider')
			.next()
			.hide();
};

var buyPd = function buyPd() {
	var buyPdList = $('.buyPd__swiper').length;

	var buyPdswiper = new Swiper('.buyPd .goodsViewComm__slider', {
		slidesPerView: 4,
		spaceBetween: 20,
		navigation: {
			prevEl: '.buyPd-nav.prev-btn',
			nextEl: '.buyPd-nav.next-btn',
		},
	});

	if (buyPdList <= 4)
		$('.buyPd .goodsViewComm__slider')
			.next()
			.hide();
};

// alert
var cmtAlert = function cmtAlert(altTit, altCont) {
	var count = $('.fb__dim:visible').length;
	var altPop = '';

	if (count > 0) altPop += '<div class="alertPop__dim over">';
	else altPop += '<div class="alertPop__dim">';

	altPop += '  <div class="alertPop">';
	altPop += '    <h2 class="alertPop__header">' + altTit + '</h2>';
	altPop += '    <div class="alertPop__cont">';
	altPop += '      <p>' + altCont + '</p>';
	altPop += '    </div>';
	altPop += '    <div class="alertPop__btn">';
	altPop += '      <button>확인</button>';
	altPop += '    </div>';
	altPop += '  </div>';
	altPop += '</div>';
	$('.fb__goodsView').append(altPop);

	$doc.on('click', '.alertPop .alertPop__btn button', function() {
		$('.alertPop__dim').remove();
	});

	$doc.on('click', '.alertPop__dim', function(e) {
		if ($(e.target).hasClass('alertPop__dim')) $('.alertPop .alertPop__btn button').trigger('click');
	});
};

var winScroll = function winScroll() {
	var $this = $('.goodsView__right__btm');
	var $share = $('.priceCalc__etc');
	var $other = $('.goodsView__inner');
	var $moveH = $('.optsTotal');
	var over = 'goodsView__right__over';
	var end = 'goodsView__right__end';
	var fixed = $this.offset().top - $('.fb__header__wrap').height();
	var endPos = $other.next().offset().top - $this.height() - 170;
	var moveTop = $doc.scrollTop();
	var optH = $win.height() - 400;

	$win.on('scroll', function() {
		var st = $win.scrollTop();
		var targetOffset = $('.goodsView__right__top').offset().top + $('.goodsView__right__top').outerHeight(true);
		var innerTotal = $other.offset().top + $other.outerHeight(true);

		// 헤더 높이(55px)
		if (targetOffset - 55 <= st && innerTotal > st + $('.goodsView__right__btm').outerHeight(true) + 55) {
			$this.addClass(over).removeClass(end);
		} else if ($other.offset().top + $other.height() > st && targetOffset < st) {
			$this.removeClass(over).addClass(end);
		} else {
			$this.removeClass(over).removeClass(end);
		}
	});

	$moveH.css('max-height', optH + 'px');

	$win.scroll(function() {
		moveTop = $doc.scrollTop();
		var endPos = $other.next().offset().top - $this.height() - 170;
	});

	$win.resize(function() {
		optH = $win.height() - 400;
		$moveH.css('max-height', optH + 'px');
	});
};

var toSNS = function toSNS(sns, strTitle, strImg) {
	if (sns == 'kakao') {
		sendLink();
	} else if (sns == 'copyUrl') {
		copy_clip();
	} else {
		var snsArray = [];
		var strURL = window.location.href;

		snsArray['twitter'] = 'http://twitter.com/home?status=' + encodeURIComponent(strTitle) + ' ' + encodeURIComponent(strURL);
		snsArray['facebook'] = 'http://www.facebook.com/share.php?u=' + encodeURIComponent(strURL);
		snsArray['band'] = 'http://band.us/plugin/share?body=' + encodeURIComponent(strTitle) + '  ' + encodeURIComponent(strURL) + '&route=' + encodeURIComponent(strURL);
		snsArray['blog'] = 'http://blog.naver.com/openapi/share?url=' + encodeURIComponent(strURL) + '&title=' + encodeURIComponent(strTitle);
		snsArray['blogcafe'] = 'https://share.naver.com/web/shareView.nhn?url=' + encodeURIComponent(strURL) + '&title=' + encodeURIComponent(strTitle);
		snsArray['line'] = 'http://line.me/R/msg/text/?' + encodeURIComponent(strTitle) + ' ' + encodeURIComponent(strURL);
		snsArray['pholar'] = 'http://www.pholar.co/spi/rephol?url=' + encodeURIComponent(strURL) + '&title=' + encodeURIComponent(strTitle);
		snsArray['google'] = 'https://plus.google.com/share?url=' + encodeURIComponent(strURL) + '&t=' + encodeURIComponent(strTitle);
		window.open(snsArray[sns], 'snsPop', 'width=500, height=500, toolbar=0, scrollbars=0, status=0');
	}
};

const copy_clip = () => {
	var copyText = document.getElementById('ProdUrl');
	var strURL = window.location.href;
	//$("#ProdUrl").attr('value', strURL);
	copyText.select();
	document.execCommand('Copy');
	cmtAlert('URL복사', 'URL 복사가 되었습니다.');
};

/* 200316 스크롤 이벤트 추가 */
const tabScrollEvent = () => {
	$win.on('scroll', function() {
		const $this = $(this);
		const st = $this.scrollTop();

		if ($('.js__goods-detail').offset().top - 55 <= st && $('.js__goods-detail').offset().top + $('.js__goods-detail').height() - (55 + 73) > st) {
			$('.js__floating .js__floating__tab')
				.removeClass('absolute')
				.addClass('fixed');
		} else if ($('.js__goods-detail').offset().top + $('.js__goods-detail').height() - (55 + 73) < st) {
			$('.js__floating .js__floating__tab')
				.removeClass('fixed')
				.addClass('absolute');
		} else {
			$('.js__floating .js__floating__tab')
				.removeClass('fixed')
				.removeClass('absolute');
		}
	});
};
tabScrollEvent();

function distance(lat1, lon1, lat2, lon2, unit) {
	if (lat1 == lat2 && lon1 == lon2) {
		return 0;
	} else {
		var radlat1 = (Math.PI * lat1) / 180;
		var radlat2 = (Math.PI * lat2) / 180;
		var theta = lon1 - lon2;
		var radtheta = (Math.PI * theta) / 180;
		var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);

		if (dist > 1) {
			dist = 1;
		}

		dist = Math.acos(dist);
		dist = (dist * 180) / Math.PI;
		dist = dist * 60 * 1.1515;

		if (unit == 'K') dist = dist * 1.609344;
		if (unit == 'N') dist = dist * 0.8684;

		return dist;
	}
}

const addSelect = {
	name: 'add-select',
	mixins: [window.VueMixins.mixin],
	template: `
            <select name="" class="fb__custom-select cursor--pointer" @change="changeOption($event, parents, option)" v-model="option">
                <option value="">옵션선택</option>
                <template v-for="(option, subIndex) in options">
                    <template v-if="option.STATUS != 3 && option.STATUS != 7">
                        <template v-if="option.STOCK <= 0 || option.STATUS == '0'">
                            <option :value="option" disabled v-if="option.STATUS == '0'" :key="subIndex">[[option.OPTN_VAL1]] / [[option.PAID_PRICE | price]] / 일시품절</option>
                            <option :value="option" disabled v-else :key="subIndex">[[option.OPTN_VAL1]] / [[option.PAID_PRICE | price]] / 품절</option>
                        </template>
                        <template v-else>
                            <option :value="option" :key="subIndex">[[option.OPTN_VAL1]] / [[option.PAID_PRICE | price]] / [[option.STOCK]]개</option>
                        </template>
                    </template>
                </template>
            </select>
        `,
	props: {
		options: {
			type: Array | null,
			required: true,
		},

		parents: {
			type: Array | null,
			required: true,
		},

		parentsIndex: {
			type: Number | 0,
			required: true,
		},
	},
	data() {
		return {
			option: '',
		};
	},
	methods: {
		changeOption(e, parent, option) {
			this.$emit('option-select', {
				e,
				parent,
				option,
			});

			this.option = '';
		},
	},
};

const goodsView = new Vue({
	store: VueStore,
	el: '#vue-container',
	components: {
		'add-select': addSelect,
	},
	mixins: [window.VueMixins.mixin, window.VueMixins.mixinEventBus, window.VueMixins.mixinHistory],

	data() {
		return {
			styleObject: {
				margin: '5px 0',
				'line-height': '18px',
				'word-break': 'break-all',
			},
			selectedTest: null,
			imageRoot: null,
			//타이머
			timer: {
				hours: null,
				minutes: null,
				seconds: null,
				start: null,
			},

			requests: {
				viewItem: {
					IL_ITEM_ID: null,
					IL_BRAND_ID: null,
					IL_CTGRY_ID: null,
					SEARCH_TERM: null,
					CHNL_CD: null,
				},

				togetherItem: {
					IL_ITEM_ID: null,
				},

				wishItem: {
					ITEM_ID: null,
					ITEM_TYPE: 'I',
					OPTION: 'wishList',
				},

				sameSizeItem: {
					IL_ITEM_ID: null,
					VIEW_PAGE: 1,
					IL_CTGRY_ID: null,
					SEARCH_WIDTH: 0,
				},

				hashTagItem: {
					IL_ITEM_ID: null,
					VIEW_PAGE: 1,
					SEARCH_TAG: null,
				},

				feedbackItem: {
					IL_ITEM_ID: null,
					IL_ITEM_ID_GRP: [],
					VIEW_PAGE: 1,
					PHOTO_YN: 0,
					PHOTO_ONLY: 0,
					SORT_GUBUN: '1',
					PHOTO_LIMIT_VIEW: 4,
				},

				feedbackPopItem: {
					IL_ITEM_ID: null,
					IL_ITEM_ID_GRP: [],
					FB_FEEDBACK_ID: null,
					LIMIT_VIEW_PATE: 4,
				},

				couponItem: {
					IL_ITEM_ID: null,
					UR_USER_ID: null,
					PAID_PRICE: 0,
					DEVICE: 'USE_PC',
				},

				SAP_IF: {
					MATNR: null,
					STORECODE: [],
				},

				clickFeedBack: {
					IL_ITEM_ID: null,
					FEEDBACK_ID: null,
				},

				inWebCoupon: {
					IL_BRAND_ID: 0, //상품 브랜드 아이디
					IL_COMPANY_ID: 0, //상품 판매자 아이디 (보통 ur_company_id)
					IL_CTGRY_ID: 0, //상품 카테고리 아이디
					IL_ITEM_ID: 0, //상품 아이디
					ST_CLASSIFICATION_ID: 10487, //쿠폰 분류 구분
					PORTAL_CHANNEL: 0, // 채널
				},
			},

			totalSelectItem: {
				TOTAL_PAID_PRICE: 0,
				TOTAL_DETL_OPTN_QTY: 0,
				TOTAL_DETL_ADDOPTN_QTY: 0,
			},

			alert: {
				width: null,
				height: null,
				isBackgroundClose: false,
				isOpen: false,
				message: null,
			},

			confirm: {
				width: null,
				height: null,
				isBackgroundClose: false,
				isOpen: false,
				message: null,
				model: null,
				ok: null,
				cancel: null,
				rtnFunc: null,
			},

			modals: {
				loginModal: {
					isOpen: false,
					model: null,
					width: null,
					height: null,
					isBackgroundClose: false,
				},
				/*
				 * [렌탈/구독 서비스][김재성]로그인
				 */
				svcLoginModal: {
					isOpen: false,
					model: null,
					width: null,
					height: null,
					isBackgroundClose: false,
				},

				/*
				 * 성인인증 상품 로그인
				 */
				adultLoginModal: {
					isOpen: false,
					model: null,
					width: null,
					height: null,
					isBackgroundClose: false,
				},
			},

			fetches: {
				goodItemQnas: false,
				goodItemFeedback: false,
				callKakaoMap: false,
				goodItemTag: false,
				goodItemSize: false,
				goodItem: false,
				coupon: false,
			},

			pagination: {
				current: 0,
				rowCount: 0,
				total: 0,
				currentID: null,
			},

			paginations: {
				goodItemQnas: {
					id: 'goodItemQnas',
					IL_ITEM_ID: '',
					CS_CATEGORY_ID: '32',
					current: 1,
					rowCount: 10,
					total: 0,
					sPage: 1,
					ePage: 10,
				},
				goodItemFeedback: {
					id: 'goodItemFeedback',
					current: 1,
					rowCount: 10,
					total: 100,
					sPage: 1,
					ePage: 10,
				},

				dealPhotoMore: {
					id: 'dealPhotoMore',
					rowCount: 20,
					total: 0,
					resetSpage: 1,
					resetEpage: 20,
				},
			},

			qna: {
				HIDE_YN: false,
				Q_TYPE: null,
				Q_TITLE: '',
				QUESTION: '',
				SMS_YN: true,
				EMAIL_YN: true,
				CS_CATEGORY_ID: '32',
				STATUS: '1',
				IL_ITEM_ID: '',
				CS_QNA_ID: '',
				POST_ACTION: null,
			},

			titleMax: 20,
			titleMaxQuestion: 200,

			processes: {
				save: null,
				goodItemFeebackList: false,
				cardBenefit: false,
				cartIn: false,
				orderItem: false,
				mdReview: false,
				goodsViewBanner: false,
			},

			searchItemOption: '',
			searchItemAddOption: '',
			goodItemUser: null,
			exhibition: [],
			goodItems: [],
			goodBrand: [],
			goodItemPhotos: [],
			goodItemTags: [],
			goodItemTagsView: [],
			goodItemOptions: [],
			goodItemAddOptions: [],
			goodItemSelectOptions: [],
			goodItemAuths: [],
			goodItemSpecifics: [],
			goodItemShippingDesc: [],
			goodItemCategory: [],
			goodItemTogetherViewItems: [],
			goodItemTogetherItems: [],
			goodItemBrandItems: [],
			goodItemCateItems: [],
			goodItemSameSize: [],
			goodItHome: [],
			goodBannerList: [],
			goodItemDcInfo: [],
			goodItemViewDcInfo: [],
			goodItemSellerInfo: {},
			player: [],
			goodItemFeebackList: [],
			goodItemFeebackScoreList: [],
			goodItemFeebackPopList: [],
			goodItemFeebackPopInfo: null,
			goodItemFeebackPopOnlyList: [],
			goodItemQnas: [],
			goodFeedPhotoFour: [],
			goodItemCouponList: [],
			//상품상세 option값 및 row데이터
			goodItemTotalRow:[],
			// 상품 다운로드 쿠폰
			goodItemOneDownCouponList: null,
			goodItemListDownCouponList: [],
			naverDownCouponList: [],
			naverEpType:'',
			goodAddItem: null,
			wishItems: [],
			inventoryStoreList: [],
			inventoryStore: [],
			inventoryStoreSelected: null,
			togetherItem: null,
			// 상세 페이지 이미지 추가 20200924
			goodBrandDetailImg: null,
			goodBrandBannerImg: null,
			// 2차 삭제
			// itemDetailNoti: null,
			kakaoMapMarkerList: [],
			kakaoMapOverLayList: [],
			selectedMarker: null,
			goodItemFeedBaseInfo: {
				TOTAL_CNT: 0,
				ATTC_CNT: 0,
				AVG_SCORE: 0,
				AVG_SCORE_1: 0,
				AVG_SCORE_2: 0,
				AVG_SCORE_RATE_1: 0,
				AVG_SCORE_RATE_2: 0,
				CNT_SCORE_1: 0,
				CNT_SCORE_2: 0,
			},

			wishParam: {
				ITEM_ID: null,
				ITEM_TYPE: 'I',
				OPTION: 'wishList',
			},

			viewItemYn: 'N',
			viewIdx: '0',
			isShowOption: false,
			isOptionsVisible: {},
			viewItemaAddOptionSel: '0',
			viewCartName: '장바구니',
			viewOrderName: '바로 구매하기',
			guudClubViewOrderName: '혜택가로 구매하기',
			viewCartGoButton: false,
			addCartYN: 'N',
			addCartId: '',

			// 옵션중 최저가격정보
			viewPriceInfo: {
				priceDiffCnt: 0,
				viewDcPrice: null,
				viewMarketPrice: 0,
				viewDcRate: 0,
				viewStockStatus: '',
				viewItemStatus: '',
				rowPriceIdx: -1,
			},

			sameSizeModal: {
				viewSameSizeYn: 'N',
				viewButtonSizeYn: 'Y',
				viewItemNm: '',
				viewXsize: 0,
				viewYsize: 0,
				viewDsize: 0,
				viewSizeCnt: 0,
				viewYn: 'N',
				startItemIndex: -1,
				viewSizeListView: 0,
			},

			previewModal: {
				isOpen: false,
				goodBannerList: null,
				goodItems: null,
			},

			writeQnaModal: {
				viewWriteQnaYn: 'N',
				viewButtonSizeYn: 'Y',
				viewItemNm: '',
				viewXsize: 0,
				viewYsize: 0,
				viewDsize: 0,
				viewSizeCnt: 0,
				viewYn: 'N',
				startItemIndex: -1,
			},

			dlvDateModal: {
				viewDlvDateYn: 'N',
			},

			exhibitStoreModal: {
				viewExhibitStoreYn: 'N',
				viewButtonSizeYn: 'Y',
				viewItemNm: '',
				viewXsize: 0,
				viewYsize: 0,
				viewDsize: 0,
				viewSizeCnt: 0,
				viewYn: 'N',
				startItemIndex: -1,
			},

			hashTagModal: {
				viewHashTagViewYn: 'N',
				viewButtonTagYn: 'Y',
			},

			photoModal: {
				viewPhotoViewYn: 'N',
				viewButtonPhotogYn: 'Y',
				viewPhotoOnlyViewYn: 'N',
				photoTotalCnt: 0,
				photoCurrentCnt: 0,
			},

			maxDcModal: {
				viewMaxDcViewYn: 'N',
				viewMaxDcButtonViewYn: 'N',
				radio_value: -1,
				maxDcValue: 0,
			},

			cardBenefitModal: {
				viewcardBenefitModalYn: 'N',
			},

			vr3DView: {
				viewerModalYn: 'N',
			},

			location: null,
			location: {
				coords: {
					latitude: 37.555197,
					longitude: 126.970734,
				},
			},

			gettingLocation: false,
			map: null,
			viewThumbs: true,
			notiImgPop: 'display: none',
			cardInfo: {
				cardTab: '1',
				cardDate: null,
				cardList: null,
				cardSubList: null,
			},

			//추가구성상품
			isShowAddItem: false,
			goodsAddItemSave: [],
			totalAddItem: {
				TOTAL_PAID_PRICE: 0,
				TOTAL_DETL_OPTN_QTY: 0,
				TOTAL_DETL_ADDOPTN_QTY: 0,
			},

			// 인입쿠폰
			isPopupClose: true, // 팝업 노출/미노출
			isCookie: false, // 쿠키 체크
			isInWeb: null, // 포털 인입 경로
			coupons: null, // 쿠폰 리스트
			feedCount: 0,
			iscouponDown: false,
			miniShopYn: false,

			bestReview: {
				list: {
					data: [],
					isOpen: false,
				},
				view: {
					data: {},
					pager: { total: [], current: {} },
					isOpen: false,
				},
			},

			productList: {
				isOpen: false,
				selected: {
					imgSrc: '',
					desc: '전체상품보기',
					target: 'All',
				},
				data: [],
			},

			photoSwiper : null,

			/*
			 * [렌탈/구독 서비스][김재성]
			 * 	- '렌탈주문' 여부, 판매처제품코드(렌탈나우상품코드), 분납기간, 가격정책번호, 분납금1/2
			 */
			rentalPopup: false,
			isSvcOrder: false,
			isRentalAvlYn: false,
			installment: {
				term: 12,
				prcPlcNo: 0,
				prc1: 0,
				prc2: 0,
			},
			goodItemCardBenefit: {},
			isSession: null,
			likeFeedbackList: [],
			isInfoVisible: false,
			goodItemCardPayMaxAmt: {},
			reviewType: 1,			
			sortOption: '1',
			//isBtnVisible: false,

			//ai 추천
			resRecPrdInfo : null,

			//ai 추천_하단
			resRecPrdInfo_b : null,

			//ai 추천_찜상품
			resRecPrdInfo_like : null,

			// 성인인증 여부 체크
			isAdult: false,
			isAdultMsg: null,
			isAdultVc: null,
			isCertYN: null,
			isAdultYN: null,

			kmcisIframeSrc: "",

			// MD's Review
			mdReviewInfo: {
				TITLE: null,
				CONTENT: null,
				IMG: null,
				SIGNATURE_IMG: null,
			},
			// MD's TagList
			mdReviewTagList: null,

			// 상품상세 마케팅 배너 리스트
			goodsViewBannerList: null,

			//굳클럽 상품 여부
			benefitTargetYn : "N",
			//AI - 찜상품 추천 POPUP 노출 여부
			addWishGroobeePopOpenYn : "N"
		};
	},

	created() {
		const queryString = this.getQueryString();
		this.requests.viewItem.IL_ITEM_ID = queryString.get('itemId');
		this.requests.viewItem.IL_BRAND_ID = jsdata.brandId;
		this.requests.togetherItem.IL_ITEM_ID = queryString.get('itemId');
		this.requests.viewItem.CHNL_CD = queryString.get('chnlCd');
		this.isAdultVc = queryString.get('adultVc');
		this.isCertYN = queryString.get('cert');
		this.isAdultYN = queryString.get('years');

		const getURL = document.referrer;

		if (/naver|daum|google|login|goodsView/gi.test(getURL)) {
			if (/naver|daum|google/gi.test(document.referrer)) window.sessionStorage.setItem('referrer', document.referrer);

			if (window.sessionStorage.getItem('referrer') && window.sessionStorage.getItem('referrer').indexOf('naver') > 1) {
				this.requests.inWebCoupon.PORTAL_CHANNEL = 1;
				this.isInWeb = 'naver';
			} else if (window.sessionStorage.getItem('referrer') && window.sessionStorage.getItem('referrer').indexOf('daum') > 1) {
				this.requests.inWebCoupon.PORTAL_CHANNEL = 2;
				this.isInWeb = 'daum';
			} else if (window.sessionStorage.getItem('referrer') && window.sessionStorage.getItem('referrer').indexOf('google') > 1) {
				this.requests.inWebCoupon.PORTAL_CHANNEL = 3;
				this.isInWeb = 'google';
			}

			window.sessionStorage.setItem('inWeb', true);
		}

		// 인입 체크
		if (!window.sessionStorage.getItem('inWeb')) this.isPopupClose = false;
		// 오늘 하루 더 보기 쿠키 체크
		if (this.getCookie('todayCoupon') == '') this.isCookie = true;

		if (this.requests.viewItem.IL_ITEM_ID == null || this.requests.viewItem.IL_ITEM_ID == '') {
			this.requests.viewItem.IL_ITEM_ID = queryString.get('IL_ITEM_ID');
		}

		this.requests.viewItem.SEARCH_TERM = queryString.get('query');


	},

	mounted() {
		this.getGoodsView();

		this.$nextTick(function() {
			this.getUrlParams();
			this.getUrlCheck();
		});

		this.getMiniShopYn();
		this.getBestReviewList();

		// 할부혜택, 결제혜택 정보 가져오기
		this.cardBenefitAb();
		this.cardBenefitAsap();
		this.cardBenefit();

		//MD's Review 조회
		this.mdReview();

		//상품상세 배너 조회
		this.goodsViewBanner();
	},

	computed: {},

	watch: {
		goodItemSelectOptions: {
			handler(after, before) {
				this.goodItemSelectOptionsChange();
			},
			deep: true,
		},

		'cardInfo.cardTab': {
			handler(newValue, oldValue) {
				this.cardInfo.cardTab = newValue;
				this.cardInfo.cardDate = null;
				this.cardInfo.cardList = null;

				this.cardBenefit();
			},
		},
	},

	methods: {
		async openPopup() {
			if(this.kmcisIframeSrc == "") {
				this.kmcisIframeSrc = "/kmcis/step1"+"?itemId="+this.goodItems.IL_ITEM_ID;
			} else {
				$("#kmcisIframeSrc").get(0).contentDocument.location.reload();
			}
		},

		onPopupClosed() {
			console.log("Popup was closed. Perform any necessary actions here.");
			// For example, you might want to refresh data or update the UI
			this.fetchData();
		},

		fetchData() {
			// Example method to fetch data or update the UI after the popup closes
		},

		prodDtl() {
			appDisc(); // 적용된 할인
			unAreaDisc(); // 배송지역불가
			exhiView(); // 관련 기획전
			etc(); // 찜, 공유하기
			prodPic();
			winScroll();
		},

		//타임딜 시간계산
		getRemainTime(end) {
			const endTime = moment(end).format();
			const endTimestamp = new Date(endTime).getTime();
			const currentTimestamp = new Date().getTime();
			const remainTime = (endTimestamp - currentTimestamp) * 0.001;

			const day = Math.floor(remainTime / 86400);
			const hours = Math.floor((remainTime % 86400) / 60 / 60);
			const minutes = Math.floor((remainTime % 3600) / 60);
			const seconds = Math.floor((remainTime % 3600) % 60);

			this.timer.day = day > 0 ? day : null;
			this.timer.hours = hours > 0 ? (hours >= 10 ? hours : '0' + hours) : '00';
			this.timer.minutes = minutes > 0 ? (minutes >= 10 ? minutes : '0' + minutes) : '00';
			this.timer.seconds = seconds > 0 ? (seconds >= 10 ? seconds : '0' + seconds) : '00';

			if (this.timer.hours <= 0 && this.timer.minutes <= 0 && this.timer.seconds <= 0) clearInterval(this.timer.start);
		},

		//타임딜 종료됐는지체크
		isTimeout() {
			if (this.dealType == 3 && this.timer.day == null && this.timer.hours == '00' && this.timer.minutes == '00' && this.timer.seconds == '00') {
				return true;
			} else {
				return false;
			}
		},

		useCouponClick() {
			this.$refs.useCoupon.style.display = 'block';
			//console.log('coupon open');
		},

		useCouponClickClose() {
			this.$refs.useCoupon.style.display = 'none';
			//console.log('coupon close');
		},

		couponConf() {
			return;
			this.$refs.couponDownAlert.style.display = 'none';
		},
		couponDownClick() {
			let couponName = '쿠폰명';

			if (this.iscouponDown) {
				this.alert.message = "이미 쿠폰을 다운로드 받으셨습니다.";
			  	this.alert.isOpen = true;
				return;
			}

			this.iscouponDown = true;
			//alert(couponName + '\n다운로드 완료 되었습니다.');
			this.alert.message = "다운로드 완료 되었습니다.";
			this.alert.isOpen = true;
		},

		async getGoodsView() {
			const parameters = this.requests.viewItem;
			this.goodItemSelectOptions = [];
			this.totalSelectItem.TOTAL_PAID_PRICE = 0;
			this.fetches.goodItem = false;

			const response = await this.$store.dispatch('network/request', {
				method: 'post',
				url: '/biz/shop/getGoodsView',
				data: parameters,
			});

			const rows = response.rows;
			this.isSession		= response.isSession;
			if (response.RETURN_CODE == '999999999') {
				this.alert.message = response.RETURN_MSG;
				this.alert.isOpen = true;
				return;
			}

			const exhibition = response.exhibition;
			const goodItems = response.rows;
			const goodBrand = response.brand;
			const goodItemPhotos = response.addImg;
			const goodItemTags = response.tags;
			const goodItemOptions = response.options;
			const goodItemAddOptions = response.addOptions;

			this.goodItemTotalRow = Object.assign(goodItems, goodItemOptions);
			//console.log( this.goodItemTotalRow );

			const goodItemAuths = response.auths;
			const goodItemSpecifics = response.specifics;
			const goodItemShippingDesc = response.shippingDesc;
			const goodItemCategory = response.category;
			const itemSellerInfo = response.itemSellerInfo;
			const goodBannerList = response.bannerList;
			const detailImgInfo = response.detailImgInfo;
			const brandBannerImg = response.brandBannerImg;

			// 상품 다운로드 쿠폰
			const goodItemOneDownCouponList = response.itemCouponInfo.one;
			const goodItemListDownCouponList = response.itemCouponInfo.list;
			
			/* SSG DAY 최저가 타임세일 상품 객체 */
			var ssgProductReturnMap = response.ssgProductReturnMap;
			
			// 할인 혜택 최대개월 수 가져오는 객체
			let cardEventBenefit = response.cardEventBenefit;			

			// 결제 혜택 최대 금액 가져오는 객체
			let cardPayBenefitMaxAmt = response.cardPayBenefitMaxAmt;						

			this.$nextTick(() => {
				//타임딜인 경우
				// if (this.deal) {
				if (goodItems.GUUDDEAL_DAY == 0) {
					this.timer.start = setInterval(() => {
						this.getRemainTime(goodItems.GUUDDEAL_ENDDATE);
					}, 1000);
				}
				// }
			});

			this.exhibition = [];
			this.goodItems = [];
			this.goodBrand = [];
			this.goodItemPhotos = [];
			this.goodItemTags = [];
			this.goodItemOptions = [];
			this.goodItemAddOptions = [];
			this.goodItemAuths = [];
			this.goodItemSpecifics = [];
			this.goodItemShippingDesc = [];
			this.goodItemCategory = [];
			this.goodItemSellerInfo = {};
			this.goodItemUser = null;
			this.goodBannerList = [];
			this.goodBrandDetailImg = null;
			this.goodBrandBannerImg = null;
			this.goodItemOneDownCouponList = null;
			this.goodItemListDownCouponList = [];
			
			this.goodItemCardBenefit = {};
			this.goodItemCardPayMaxAmt = {};

			//추가구성상품
			if (response.ITEM_ADDS && response.ITEM_ADDS.itemAdds && response.ITEM_ADDS.itemAdds.length) {
				this.goodAddItem = response.ITEM_ADDS.itemAdds;
			}
		
			if (goodItems != null && goodItems.ITEM_NAME != '') {
				this.goodItems = goodItems;
				this.goodBrand = goodBrand;
				this.goodItemUser = response.user;
				this.viewItemYn = 'Y';
				this.exhibition = exhibition;
				this.goodItemPhotos = goodItemPhotos;
				this.goodItemTags = goodItemTags;
				this.goodItemOptions = goodItemOptions;
				/* SSG DAY 최저가 타임세일 상품 객체 바인딩 */
				if(ssgProductReturnMap != null && ssgProductReturnMap.IL_ITEM_ID != '') {
					this.ssgProductReturnMap = ssgProductReturnMap;
				}
				
				//상품리뷰
				this.goodItems.TOTAL_FEEDBACK_COUNT = this.goodItems.FEEDBACK_COUNT + this.goodItems.FEEDBACK_GRP_COUNT;

				//Q&A
				this.goodItems.TOTAL_QNA_COUNT = this.goodItems.QNA_COUNT;

				if (this.goodItems.ITEM_BADGE != null && this.goodItems.ITEM_BADGE != '') {
					var link = document.location.href;
					const eventDate = moment().format('YYYYMMDD');
					if (link.indexOf('stg2') > 0 || link.indexOf('dev2') > 0 || link.indexOf('localhost') > 0) {
						$('#payBackBanner').show();
					} else {
						if (eventDate >= '20201026' && eventDate <= '20201101') {
							$('#payBackBanner').show();
						}
					}
				}

				//추가구성상품이 없으면서 본상품이 단일옵션인 경우
				if (this.isNoSelectOption()) {
					this.goodItemSelectOptions.push({
						CONSTRUCTION_CNT: this.goodItemOptions[0].CONSTRUCTION_CNT,
						OPTN_DETL_TYPE: this.goodItemOptions[0].OPTN_DETL_TYPE,
						FULL_OPTN_VAL1: this.goodItemOptions[0].FULL_OPTN_VAL1,
						STOCK: this.goodItemOptions[0].STOCK,
						STATUS: this.goodItemOptions[0].STATUS,
						IL_ITEM_OPTN_DETL_ID: this.goodItemOptions[0].IL_ITEM_OPTN_DETL_ID,
						USER_DEF_CD: this.goodItemOptions[0].USER_DEF_CD,
						QTY: 1,
						TOTAL_DC_PRICE: this.goodItemOptions[0].TOTAL_DC_PRICE,
						MARKET_PRICE: this.goodItemOptions[0].MARKET_PRICE,
						TOTAL_EMPLOYEE_DC_PRICE: this.goodItemOptions[0].TOTAL_EMPLOYEE_DC_PRICE,
						DETL_OPTN_PRICE: this.goodItemOptions[0].DETL_OPTN_PRICE,
						IL_GOODS_CODE: this.goodItemOptions[0].IL_GOODS_CODE,
						ADD_PRICE: this.goodItemOptions[0].ADD_PRICE,
						PAID_PRICE: this.goodItemOptions[0].PAID_PRICE,
						PAID_SALE_TYPE: this.goodItemOptions[0].PAID_SALE_TYPE,
						TOTAL_DC_TEXT: this.goodItemOptions[0].TOTAL_DC_TEXT,
						OPTN_VAL1: this.goodItemOptions[0].OPTN_VAL1,
						SALE_PRICE: this.goodItemOptions[0].SALE_PRICE,

						// 								USER_LIMIT_TYPE: this.goodItems.USER_LIMIT_TYPE,
						// 								USER_LIMIT_YN: this.goodItems.USER_LIMIT_YN,
						// 								USER_LIMIT_CNT: this.goodItems.USER_LIMIT_CNT,

						IL_GOODS_ID: this.goodItemOptions[0].IL_GOODS_ID,
						/*
						 * [렌탈/구독 서비스][김재성]선택된 상품옵션의 모두렌탈가격정책번호세팅
						 */
						PRC_PLC_NO1: this.goodItemOptions[0].PRC_PLC_NO1,
						PRC_PLC_NO2: this.goodItemOptions[0].PRC_PLC_NO2,

						/* 상품구매수량 제한조건 추가 */
						LIMIT_YN: this.goodItems.LIMIT_YN,
						LIMIT_TYPE: this.goodItems.LIMIT_TYPE,
						LIMIT_CNT: this.goodItems.LIMIT_CNT,

						USER_LIMIT_YN: this.goodItems.USER_LIMIT_YN,
						USER_LIMIT_TYPE: this.goodItems.USER_LIMIT_TYPE,
						USER_LIMIT_CNT: this.goodItems.USER_LIMIT_CNT,
					});
					//this.goodItemSelectOptions.push(this.goodItemOptions[0]);
					/*
					 * [렌탈/구독 서비스][김재성]선택된 상품옵션의 분납금액
					 */
					this.installment.prc1 = this.goodItemOptions[0].INSTALLMENT_PRC1;
					this.installment.prc2 = this.goodItemOptions[0].INSTALLMENT_PRC2;
				}

				this.goodItemAddOptions = goodItemAddOptions;
				// 2차 삭제
				// this.itemDetailNoti = response.itemDetailNoti;
				this.checkSetEtc(); //품절 표시 및 팝업창 할인보기
				this.fetches.goodItem = true;
				this.goodItemAuths = goodItemAuths;
				this.goodItemSpecifics = goodItemSpecifics;
				this.goodItemShippingDesc = goodItemShippingDesc;
				this.goodItemCategory = goodItemCategory;
				this.goodItemSellerInfo = itemSellerInfo;
				this.goodBannerList = goodBannerList;
				this.goodBrandDetailImg = detailImgInfo;
				this.goodBrandBannerImg = brandBannerImg;
				this.goodItemOneDownCouponList = goodItemOneDownCouponList;
				this.goodItemListDownCouponList = goodItemListDownCouponList;
				
				//this.goodItemCardBenefit = cardEventBenefit;	//할부혜택 최대 개월 수
				if(cardEventBenefit && cardEventBenefit !== null){
					this.goodItemCardBenefit = cardEventBenefit;					
				} else {
					this.goodItemCardBenefit = null;					
				}
				this.goodItemCardPayMaxAmt = cardPayBenefitMaxAmt;	// 결제혜택 최대 금액 가져오기

				Object.freeze(this.goodItemAuths);
				Object.freeze(this.goodItemSpecifics);
				Object.freeze(this.goodItemShippingDesc);
				Object.freeze(this.goodItemCategory);
				Object.freeze(this.goodItemSellerInfo);
				// Object.freeze(this.itemDetailNoti);
				Object.freeze(this.goodBannerList);
				Object.freeze(this.goodBrandDetailImg);
				Object.freeze(this.goodBrandBannerImg);
				Object.freeze(this.goodItemOneDownCouponList);
				Object.freeze(this.goodItemListDownCouponList);

				/*
				 * [렌탈/구독 서비스][김재성]렌탈/구독 서비스 상품
				 * 	- 렌탈가능여부(RENT_AVL_YN), 판매처상품코드(ITEM_CODE), 가격정책번호9PRC_PLC_NO1,2) 조회
				 */
				if (this.goodItems.RENT_AVL_YN == 'Y' &&
					this.goodItemOptions[0].ITEM_CODE != null && this.goodItemOptions[0].ITEM_CODE != '' &&
					this.goodItemOptions[0].PRC_PLC_NO1 != null && this.goodItemOptions[0].PRC_PLC_NO1 != '' &&
					this.goodItemOptions[0].PRC_PLC_NO2 != null && this.goodItemOptions[0].PRC_PLC_NO2 != '') {
					// 렌탈가능여부
					this.isRentalAvlYn = true;
					// 모두렌탈가격정책번호 초기화 첫번째 옵션상품의 12개월 정책번호
					this.installment.prcPlcNo = this.goodItemOptions[0].PRC_PLC_NO1;
				}
				/* SSG DAY 최저가 타임세일 상품 여부 조회, /biz/shop/getGoodsView api에서 가져오고 있음 */
				//this.selSSGProductYn();
				
				// 네이버 ep 쿠폰
				const naverCouponInfo = response.naverCouponInfo;
				if(naverCouponInfo != null && naverCouponInfo != undefined){
					this.naverDownCouponList = response.naverCouponInfo.list;
					this.naverEpType = response.naverCouponInfo.OP_TYPE;
					
//					// 네이버 ep 쿠폰존재할때 팝업 표시
//					if(this.naverDownCouponList != null && this.naverDownCouponList !=''){
//						// 하루 보지 않기 체크
//						if (this.getCookie('naverCoupon') == '') comPopupOpen('popupNaverCoupon');
//					}
				}
				
			} else {
				this.alert.message = '상품이 존재 하지 않습니다.';
				this.alert.isOpen = true;
			}
			

			this.$nextTick(function() {
				this.prodDtl();
				this.getItemCouponInfo();
				this.goodsViewListSelect();
				this.feedBackSearch();

				if (this.isCookie) {
					this.requests.inWebCoupon.IL_BRAND_ID = rows.IL_BRAND_ID;
					this.requests.inWebCoupon.IL_COMPANY_ID = rows.UR_COMPANY_ID;
					this.requests.inWebCoupon.IL_CTGRY_ID = rows.IL_CTGRY_ID;
					this.requests.inWebCoupon.IL_ITEM_ID = rows.IL_ITEM_ID;

					this.requestCoupon();
				}
				
				// 네이버 ep 쿠폰존재할때 팝업 표시
				if(this.naverDownCouponList != null && this.naverDownCouponList !=''){
					// 하루 보지 않기 체크
					if (this.getCookie('naverCoupon') == '') comPopupOpen('popupNaverCoupon');
				}

				// 성인인증 완료 후 안내 팝업 표시
				if(this.isAdultVc === 'Y' && this.goodItems.ADULT_YN.trim() === 'Y' && this.isCertYN === 'Y') {
					this.alert.message = '인증이 완료되었습니다.<br>이제 성인인증 없이<br>모든 상품을 구매할 수 있습니다.';
					this.alert.isOpen = true;
				}

				// 성인인증 실패 완료 후 안내 팝업 표시
				if(this.isAdultVc === 'N' && this.goodItems.ADULT_YN.trim() === 'Y' && this.isCertYN === 'Y') {
					if(this.isAdultYN === 'N'){
						this.alert.message = '만19세 미만은<br>해당상품을 구매할 수 없습니다.';
						this.alert.isOpen = true;
					} else {
						this.alert.message = '인증이 실패되었습니다.<br>다시 성인인증 해주세요.';
						this.alert.isOpen = true;
					}
				}

				// 성인인증 실패 회원 정보 번호 불일치
				if((this.isAdultVc === 'N' || this.isAdultVc === 'Y') && this.goodItems.ADULT_YN.trim() === 'Y' && this.isCertYN === 'N') {
					if(this.isAdultYN === 'N'){
						this.alert.message = '만19세 미만은<br>해당상품을 구매할 수 없습니다.';
						this.alert.isOpen = true;
					} else {
						this.alert.message = '인증정보와 회원 전화번호가 다르니,<br>회원정보를 수정한 후 다시 인증해 주세요.';
						this.alert.isOpen = true;
					}
				}

				// 미성년자일 경우 얼럿 표시
				if(this.goodItems.ADULT_YN.trim() === 'Y' && this.isAdultVc === 'N' && this.isAdultYN === 'N') {
					this.alert.message = '만19세 미만은<br>해당상품을 구매할 수 없습니다.';
					this.alert.isOpen = true;
				}

				// picZommer 때문에 class index 재할당
				// 20200610 이우태 과장님 요청 주석처리
				for (let i = 0; i < $('.goodsView__pdImg .swiper-slide .picZoomer').length; i++) {
					$('.picZoomer')
						.eq(i)
						.addClass('picZoomer' + i);
					$('.picZoomer' + i).picZoomer();
				}

				// dev 조회용 (임시)
				this.benefitTargetYn = this.goodItems.BENEFIT_TARGET_YN;
				// console.log("benefitTargetYn", this.benefitTargetYn);
				if(this.benefitTargetYn == "N"){ //굳클럽 상품은 추천구좌 비노출처리 20241017
					if(!(/(guud.com)/ig.test(window.location.href))) {
						this.getGroobeeRecommend();
					} else {
						let tryCnt = 0, isExec = false;
						let _timer = setInterval(() => {
							if (tryCnt == 3 || isExec) {
								clearInterval(_timer);
								return;
							}
							tryCnt++;
							if (groobee.getGroobeeRecommend && typeof groobee.getGroobeeRecommend == 'function') {
								this.getGroobeeRecommend();
								clearInterval(_timer);
								isExec = true;
							}
						}, 500);
					}
				}
			});
		},
		
		/* SSG DAY 최저가 타임세일 상품 여부 조회 */
		selSSGProductYn() {
			/* 상품 ID */
			const IL_ITEM_ID = this.goodItems.IL_ITEM_ID;
			/* SSG DAY 타임세일 비교용도 시작일시 */
			var START_DATE; 	 		 			
			/* SSG DAY 타임세일 비교용도 종료일시 */
			var END_DATE;										
			/* SSG DAY 타임세일 노출용도 시작일시 */
			var FOMATTED_START_DATE;		
			/* SSG DAY 타임세일 노출용도 종료일시 */
			var FOMATTED_END_DATE;									
			
							
			$.ajax({
				type : 'GET',
				async : true,
				contentType : "application/x-www-form-urlencoded; charset=UTF-8",
				dataType : 'json',
				url: '/biz/event/getSSGProductYn',
				data: {
					IL_ITEM_ID: this.goodItems.IL_ITEM_ID
				},
				success : function(data) {
					 /* 현재 일시 */
					 const currentDate = new Date();
					 const year = currentDate.getFullYear();
					 const month = (currentDate.getMonth() + 1).toString().padStart(2, '0'); // 월은 0부터 시작하므로 +1
					 const day = currentDate.getDate().toString().padStart(2, '0');
					 const hours = currentDate.getHours().toString().padStart(2, '0');
					 const minutes = currentDate.getMinutes().toString().padStart(2, '0');
					 const seconds = currentDate.getSeconds().toString().padStart(2, '0');

					 /* 현재 일시 (format : YYYY-MM-DD HH24:MI:SS) */
					 const FOMATTED_DATE = "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(minutes, ":").concat(seconds);

					 /* SSG 이벤트 대상 상품인 경우에만 이벤트 발생 */
			         if (data.getSSGProductYn != null) {

			        	 /* 시작일시 (format : YYYY-MM-DD HH24:MI) */
			        	 START_DATE = data.getSSGProductYn.START_DATE;
			        	 /* 종료일시 (format : YYYY-MM-DD HH24:MI) */
			        	 END_DATE = data.getSSGProductYn.END_DATE;

			        	 /* 현재 일시 >= 등록된 상품의 타임세일 노출 시작일시 && 현재 일시 <= 등록된 상품의 타임세일 노출 종료일시 */
			             if(FOMATTED_DATE >= START_DATE && FOMATTED_DATE <= END_DATE) {

			            	/* SSG DAY 타임세일 노출용도 시작일시 (format : MM/DD HH24:MI) */
			            	FOMATTED_START_DATE = formatSsgDate(START_DATE);
			            	/* SSG DAY 타임세일 노출용도 종료일시 (format : MM/DD HH24:MI) */
			            	FOMATTED_END_DATE = formatSsgDate(END_DATE);

				            $('#priceCalc__div').hide();
			             }
			         }
				},
				error : function(e) {
					console.log('[selSSGProductYn] ERROR : ', e);
					
					return false;
				}
			});
		 },
		 
		//함께사면 할인상품
		async requestTogetherItem() {
			try {
				const parameter = this.requests.togetherItem;
				const response = await this.$store.dispatch('network/request', {
					method: 'post',
					url: '/biz/shop/getTogetherGoods',
					data: parameter,
				});

				const rows = response.rows;

				if (rows && rows.length) {
					this.togetherItem = rows;
				}

				this.$nextTick(() => {
					this.togetherSlider();
				});
			} catch (ex) {
				console.error(ex);
			}
		},

		async goodsViewListSelect() {
			this.requests.viewItem.IL_BRAND_ID = this.goodItems.IL_BRAND_ID;
			this.requests.viewItem.IL_CTGRY_ID = this.goodItems.IL_CTGRY_ID;

			const parameters = this.requests.viewItem;
			const response = await this.$store.dispatch('network/request', {
				method: 'post',
				url: '/biz/shop/goodsViewListSelect',
				data: parameters,
			});

			this.wishItems = [];
			this.goodItHome = response.itHome;

			Object.freeze(this.goodItHome);

			this.$nextTick(function() {
				//buyPd();
				//samePd();
				//categoryPd();
				//morePd();
				this.samePdSlider();
				this.buyPdSlider();
				this.categoryPdSlider();
				this.morePdSlider();
				this.itHomeSlider();
			});
		},

		async feedBackSearch() {
			const parameters = this.requests.viewItem;
			parameters.searchMainType = mainType;

			if (parameters.SEARCH_TERM != null && parameters.SEARCH_TERM != '') {
				const response = await this.$store.dispatch('network/request', {
					method: 'post',
					url: '/search/feedBackSearch',
					data: parameters,
				});
			}
		},

		selectedCategory(e, depth) {
			let goListUrl = null;

			switch (depth) {
				case 0:
					// 대카테고리
					goListUrl = '/shop/index?IL_CTGRY_ID=' + this.goodItemCategory[depth].IL_CTGRY_ID;
					break;

				case 1:
					// 중카테고리
					goListUrl = '/shop/goodsList?f_c=' + this.goodItemCategory[depth].IL_CTGRY_ID;
					break;

				case 2:
					// 소카테고리
					goListUrl = '/shop/goodsList?f_c=' + this.goodItemCategory[depth - 1].IL_CTGRY_ID + '&s_c=' + this.goodItemCategory[depth].IL_CTGRY_ID;
					break;

				default:
					goListUrl = '';
					break;
			}

			location.href = goListUrl;
		},

		checkSetEtc() {
			//상품정보 획득후 기타 작업 품절체크 및 팝업창 할인 표시
			this.viewPriceInfo.priceDiffCnt = 0;
			this.viewPriceInfo.viewDcPrice = 0;
			this.viewPriceInfo.viewMarketPrice = 0;
			this.viewPriceInfo.viewDcRate = 0;
			this.viewPriceInfo.viewStockStatus = '';
			this.viewPriceInfo.rowPriceIdx = -1;
			var vStockQtyChk = 0;
			let minDcPriceIdx = 0;
			
			/* 현재 일시 */
			
			var currentDate = new Date();
			var year = currentDate.getFullYear();
			var month = (currentDate.getMonth() + 1).toString().padStart(2, '0'); // 월은 0부터 시작하므로 +1
			var day = currentDate.getDate().toString().padStart(2, '0');
			var hours = currentDate.getHours().toString().padStart(2, '0');
			var minutes = currentDate.getMinutes().toString().padStart(2, '0');
			var seconds = currentDate.getSeconds().toString().padStart(2, '0');
			
			 
			/* 현재 일시 (format : YYYY-MM-DD HH24:MI:SS) */
			var FOMATTED_DATE = "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(minutes, ":").concat(seconds);
			 

			if (this.goodItemOptions && this.goodItemOptions.length > 0) {
				this.viewPriceInfo.viewDcPrice = this.goodItemOptions[0].PAID_PRICE;
				this.viewPriceInfo.viewMarketPrice = this.goodItemOptions[0].MARKET_PRICE;

				//옵션의 재고가 없거나 상태가 일시품절이면 품절체크
				if (this.goodItemOptions[0].STOCK <= 0 || this.goodItemOptions[0].STATUS == 0) {
					vStockQtyChk++;
				}

				this.changeSizeWidth(-1);

				if (this.viewPriceInfo.viewMarketPrice != this.viewPriceInfo.viewDcPrice && this.viewPriceInfo.viewMarketPrice != 0) {
					this.viewPriceInfo.viewDcRate = Math.floor((this.viewPriceInfo.viewDcPrice / this.viewPriceInfo.viewMarketPrice) * 100) == 0 ? '100' : Math.floor(((this.viewPriceInfo.viewMarketPrice - this.viewPriceInfo.viewDcPrice) / this.viewPriceInfo.viewMarketPrice) * 100);
				} else {
					this.viewPriceInfo.viewDcRate = 0;
				}

				//팝업창 할인리스트표시및 재고 체크
				for (let i = 1; i < this.goodItemOptions.length; i++) {
					// 옵션의 재고가 없거나 상태가 일시품절이면 품절체크
					if (this.goodItemOptions[i].STOCK <= 0 || this.goodItemOptions[i].STATUS == 0) {
						vStockQtyChk++;
					}

					if (this.viewPriceInfo.viewDcPrice > this.goodItemOptions[i].PAID_PRICE) {
						//this.viewPriceInfo.priceDiffCnt = this.viewPriceInfo.priceDiffCnt + 1;
						this.viewPriceInfo.viewDcPrice = this.goodItemOptions[i].PAID_PRICE;
						this.viewPriceInfo.viewMarketPrice = this.goodItemOptions[i].MARKET_PRICE;
						minDcPriceIdx = i;
					} else if (this.viewPriceInfo.viewDcPrice == this.goodItemOptions[i].PAID_PRICE) {
						this.viewPriceInfo.viewDcPrice = this.goodItemOptions[i].PAID_PRICE;

						if (this.viewPriceInfo.viewMarketPrice > this.goodItemOptions[i].MARKET_PRICE) {
							this.viewPriceInfo.viewMarketPrice = this.viewPriceInfo.viewMarketPrice;
						} else {
							this.viewPriceInfo.viewMarketPrice = this.goodItemOptions[i].MARKET_PRICE;
							minDcPriceIdx = i;
						}
					}

					if (this.viewPriceInfo.viewMarketPrice != this.viewPriceInfo.viewDcPrice && this.viewPriceInfo.viewMarketPrice != 0) {
						this.viewPriceInfo.viewDcRate = Math.floor((this.viewPriceInfo.viewDcPrice / this.viewPriceInfo.viewMarketPrice) * 100) == 0 ? '100' : Math.floor(((this.viewPriceInfo.viewMarketPrice - this.viewPriceInfo.viewDcPrice) / this.viewPriceInfo.viewMarketPrice) * 100);
					} else {
						this.viewPriceInfo.viewDcRate = 0;
					}

					// if (this.viewPriceInfo.viewDcPrice != this.goodItemOptions[i].PAID_PRICE) {
					// 	this.viewPriceInfo.priceDiffCnt = this.viewPriceInfo.priceDiffCnt + 1; //화면에 ~ 표시위해

					// 	if (this.viewPriceInfo.viewDcPrice > this.goodItemOptions[i].PAID_PRICE) { //제일금액이 작은것표시위해
					// 		minDcPriceIdx = i;
					// 		this.viewPriceInfo.viewDcPrice = this.goodItemOptions[i].PAID_PRICE;
					// 		this.viewPriceInfo.viewMarketPrice = this.goodItemOptions[i].MARKET_PRICE;

					// 		if (this.viewPriceInfo.viewMarketPrice!=this.viewPriceInfo.viewDcPrice && this.viewPriceInfo.viewMarketPrice != 0) {
					// 			this.viewPriceInfo.viewDcRate = Math.floor(this.viewPriceInfo.viewDcPrice / this.viewPriceInfo.viewMarketPrice * 100) == 0 ? "100" : Math.floor( (this.viewPriceInfo.viewMarketPrice - this.viewPriceInfo.viewDcPrice) / this.viewPriceInfo.viewMarketPrice * 100);
					// 		}
					// 		else{
					// 			this.viewPriceInfo.viewDcRate = 0;
					// 		}
					// 	}
					// }
				}

				for (let j = 0; j < this.goodItemOptions.length; j++) { 
					this.goodItemOptions[j].OPTN_ADD_PRICE = this.goodItemOptions[j].PAID_PRICE - this.viewPriceInfo.viewDcPrice;
				}

				if(this.goodAddItem){
					for (let j = 0; j < this.goodAddItem.length; j++) {
						for(let k = 0 ; k < this.goodAddItem[j].options.length;k++){
							this.goodAddItem[j].options[k].OPTN_ADD_PRICE = Number(this.goodAddItem[j].options[k].PAID_PRICE) - Number(this.goodAddItem[j].PAID_PRICE);
						}
					}
				}

				this.viewPriceInfo.rowPriceIdx = minDcPriceIdx;
				this.pushDcInfo(minDcPriceIdx); //특정상품하나만 표시

				// 본사 상품이고 재고연동이 Y가 아니면 viewOrderName = "예약 구매하기"
				//if (this.goodItems.SAP_INV_YN != 'Y' && this.goodItems.UR_COMPANY_ID == '1') {
				//this.viewOrderName = "예약 구매하기";
				//}
				if (this.goodItems.TARGET_USER != '1') {
					this.viewOrderName = '바로 구매하기';
				}

				if (this.goodItemOptions.length == 1 && (this.goodItemOptions[0].STATUS == '0' || this.goodItemOptions[0].STOCK <= 0)) {
					this.viewPriceInfo.viewStockStatus = 'TEMPSTOP';
					this.viewOrderName = '일시품절';
				} else if (vStockQtyChk == this.goodItemOptions.length) {
					this.viewPriceInfo.viewStockStatus = 'ALLSTOP';
					this.viewOrderName = '일시품절';
				} else if (this.goodItems.STATUS == '0') {
					this.viewPriceInfo.viewStockStatus = 'TEMPSTOP';
					this.viewOrderName = '일시품절';
				} 
				
				/* 상품이 SSG DAY 최저가 타임세일 상품인 경우 */
				else if(this.ssgProductReturnMap != null && this.ssgProductReturnMap.IL_ITEM_ID != null) {
									
					/* SSG DAY 타임세일 변수 */
					/* 상품 ID */
					var SSG_IL_ITEM_ID = this.ssgProductReturnMap.IL_ITEM_ID; 
					/* 상품 오픈 시작일 */
					var START_DATE = this.ssgProductReturnMap.START_DATE;
					/* 상품 오픈 종료일 */
					var END_DATE = this.ssgProductReturnMap.END_DATE;
					/* 상품 오픈 시작일 (노출 용도) */
					var FORMAT_START_DATE = this.ssgProductReturnMap.FORMAT_START_DATE;
					/* 상품 오픈 종료일 (노출 용도) */
					var FORMAT_END_DATE = this.ssgProductReturnMap.FORMAT_END_DATE;
					/* 현재 일시 */
					var CURR_DATE = this.ssgProductReturnMap.CURR_DATE;
										
					/* 현재 일시가 노출 일시인 경우 */
					/* if(FOMATTED_DATE >= START_DATE && FOMATTED_DATE <= END_DATE) { */
					if(CURR_DATE >= START_DATE && CURR_DATE <= END_DATE) {
		            	this.viewPriceInfo.viewStockStatus = 'SSG_GOODS_DISPLAY';
		            	this.viewOrderName = '바로 구매하기';

		            /* 현재 일시가 노출 일시가 아닌 경우 */ 
		            } else {
		            	this.viewPriceInfo.viewStockStatus = 'SSG_GOODS_NON_DISPLAY';
		            	this.viewOrderName = FORMAT_START_DATE.substring(5, 16) + ' ~ ' + FORMAT_END_DATE.substring(5, 16);
		            }
		            	            	            
		            /* SSG DAY 최저가 타임세일 상품인 경우 로그인 필수 */
		            if (this.goodItemUser.UR_USER_ID != '') {
		            	
		            /* 로그인 하지 않은 경우 */
		            } else {
						this.alert.message = "본 상품을 확인하기 위해서는 로그인이 필요합니다.";
			  			this.alert.isOpen = true;
		            	window.location.href = '/member/login?reurl=/shop/goodsView?itemId=' + SSG_IL_ITEM_ID;
					}
				}
			}
		},

		pushDcInfo(idx) {
			const target = this.goodItemOptions[idx];

			//@TODO: 할인 정보가 있으면 이 안에 주석들 삭제 필요 나중에 더해야하면 주석풀기
			if (target.DC_LIST && target.DC_LIST.length) {
				// let totalDiscount = 0;
				this.goodItemDcInfo = this.goodItemDcInfo.concat(target.DC_LIST);

				// this.goodItemDcInfo.forEach(v => {
				// 	totalDiscount += v.TOTAL_DC_PRICE;
				// })

				// this.viewPriceInfo.TOTAL_DISCOUNT = totalDiscount;
			}
		},

		checkWishItem() {
			if (this.goodItems.PRODUCT_FLAG == 'T') return true;
			else return false;
		},

		chgWish(event, itemId, pgubun, mgubun) {
			var target = event.target;
			const confirm = this.confirm;

			if (this.goodItemUser.UR_USER_ID != '') {
				this.requests.wishItem.ITEM_ID = itemId;

				if (target.className.indexOf('on') < 0) {
					this.addWish(target, pgubun, mgubun);
				} else {
					this.deleteWish(target, pgubun);
				}
			} else {
				confirm.message = '로그인이 필요합니다.<br/>로그인 하시겠습니까?';
				confirm.model = 'login';
				confirm.isOpen = true;
			}
		},

		closePopup() {
			this.confirm.isOpen = false;
			this.confirm.closePopup = false;
		},

		async addWish(target, pgubun, mgubun) {
			try {
				const confirm = this.confirm;
				const parameter = this.requests.wishItem;
				const response = await this.$store.dispatch('network/request', {
					method: 'post',
					url: '/biz/mypage/wishlist/addProductList',
					data: parameter,
				});

				if (response.RETURN_CODE !== '999999999') {
					target.classList.add('on');

					// Adjust event adjustAddProduct start

					var eventToken;
					if (isPrd) {
						eventToken = 'f2awfw';
					} else {
						eventToken = 'fbw5pt';
					}

					Adjust.trackEvent({
						eventToken: eventToken, //'adjustAddProduct',
						callbackParams: [{ key: 'item_id', value: String(this.requests.wishItem.ITEM_ID) }],
					});

					// Adjust event adjustAddProduct end

					/*rtbhouse 광고 스크립트 추가 20240709*/
					(rtbhEvents = window.rtbhEvents || []).push(
						{
						 eventType: 'wishlist',
						 offerId: String(this.requests.wishItem.ITEM_ID)
						},
						{
							eventType: 'uid',
							id : userId
						}
					);

					if (pgubun == 'M') {
						// == "T"로 되어있어서 = 으로 바꿈 200514 이슈있으면 롤백
						this.goodItems.PRODUCT_FLAG = 'T';
						this.goodItems.WISH_ITEM_CNT = this.goodItems.WISH_ITEM_CNT + 1;
					} else {
						if (this.wishItems.length == 0 || this.wishItems.indexOf(this.requests.wishItem.ITEM_ID) < 0) {
							this.wishItems.push(this.requests.wishItem.ITEM_ID);
						}
					}

					//console.log('------------ wish list add ------------');
					//GA4 전자상거래
					dataLayer.push({
						"event" : "add_to_wishlist",
						"ecommerce" : {
							"currency" : "KRW",
							"items" : [{
								"item_id" : String(this.goodItems.IL_ITEM_ID),
								"item_name" : String(this.goodItems.ITEM_NAME),
								"price" : String(this.goodItems.SALE_PRICE)
							}]
						}
					});

					/* 242455 찜상품 ai 추천 */
					this.addWishGroobeePopOpenYn = "Y";
					if(this.resRecPrdInfo_like != null && this.resRecPrdInfo_like.length > 6 && mgubun == 'M') {
						this.aiPopOpen();
						this.addWishGroobeePopOpenYn = "N";
					}
					$(".like[data-id='"+parameter.ITEM_ID+"']").addClass("on");

					// this.alert.message = '관심 상품으로 등록되었습니다.';
					// this.alert.isOpen = true;
				}
			} catch (ex) {
				console.error('addWish exception.. ', ex);
			}
		},
		async aiPopOpen(){
			$(".save_ai_recommand_sec").css('display', 'block');
			$(".ai_recommand_pop").css('display', 'block').animate({ bottom: '0px' }, 300);
			if(!$(".save_ai_recommand_sec .swiper-pagination").hasClass("swiper-pagination-bullets")) {
				this.aiRecommandSlider('like');

				const close = $(".add_save .close");
				const maskDimd = $(".save_ai_recommand_sec .mask");
				const ai_recommand2 = $(".save_ai_recommand_sec");
				const ai_recommand3 = $(".ai_recommand_pop");
				close.click(function () {
					ai_recommand2.css('display', 'none');
					ai_recommand3.css('display', 'none').animate({bottom: '-520px'}, 300);
				});
				maskDimd.click(function () {
					ai_recommand2.css('display', 'none');
					ai_recommand3.css('display', 'none').animate({bottom: '-520px'}, 300);
				});
			}
		},
		async deleteWish(target, pgubun) {
			try {
				const parameter = this.requests.wishItem;
				const response = await this.$store.dispatch('network/request', {
					method: 'post',
					url: '/biz/mypage/wishlist/delProductList',
					data: parameter,
				});

				if (response.RETURN_CODE !== '999999999') {
					target.classList.remove('on');

					if (pgubun == 'M') {
						this.goodItems.PRODUCT_FLAG = 'F';

						if (this.goodItems.WISH_ITEM_CNT > 0) {
							this.goodItems.WISH_ITEM_CNT = this.goodItems.WISH_ITEM_CNT - 1;
						}
					} else {
						if (this.wishItems != null && this.wishItems.length > 0) {
							this.wishItems.splice(this.wishItems.indexOf(this.requests.wishItem.ITEM_ID), 1);
						}
					}

					this.addWishGroobeePopOpenYn = "N";
					$(".like[data-id='"+parameter.ITEM_ID+"']").removeClass("on");
					// this.alert.message = '관심 상품 목록에서 해제되었습니다';
					// this.alert.isOpen = true;
				}
			} catch (ex) {
				console.error('deleteWish exception.. ', ex);
			}
		},

		closeConfirm(payload) {
			var confirm = this.confirm;
			var e = payload.e,
				value = payload.value;

			switch (confirm.model) {
				case 'login':
					if (value){
						var locationUrl = '/member/login?reurl=/shop/goodsView?itemId=' + this.goodItems.IL_ITEM_ID;
						if(this.requests.viewItem.CHNL_CD != ''){
							locationUrl = '/member/login?reurl=/shop/goodsView?itemId=' + this.goodItems.IL_ITEM_ID+"&chnlCd="+this.requests.viewItem.CHNL_CD;
						}
						window.location.href = locationUrl;
					}
					break;

				case 'qnaDel':
					if (value) {
					} else {
						this.qna.CS_QNA_ID = '';
						this.qna.POST_ACTION = '';
					}
					break;

				case 'orderItem':
					confirm.ok = null;
					confirm.cancel = null;

					if (value) {
						location.href = '/member/login?reurl=/shop/cart';
						this.addCartId = '';
					} else {
						location.href = '/shop/infoinput?cartIds=' + this.addCartId;
						this.addCartId = '';
					}
					break;
				/*
				 * [렌탈/구독 서비스][김재성]화면 '닫기'시에 일반주문으로 변경 및 초기화
				 */
				case 'rental':
					if (value) {
						this.isSvcOrder = false;
						this.rentalPopup = false;
					}
					break;
				case 'feedbackLike':
					if(value) {

						var locationUrl = '/member/login?reurl=/shop/goodsView?itemId=' + this.requests.viewItem.IL_ITEM_ID;
						if(this.requests.viewItem.CHNL_CD != ''){
							locationUrl = '/member/login?reurl=/shop/goodsView?itemId=' + this.requests.viewItem.IL_ITEM_ID+"&chnlCd="+this.requests.viewItem.CHNL_CD;
						}
						location.href = locationUrl;

					}
					break;
				default:
					break;
			}

			confirm.isOpen = false;
		},

		toSnsSend(e, sns, cimg) {
			toSNS(sns, this.goodItems.ITEM_NAME, cimg);
			this.$refs['btnShare'].classList.remove('show');
		},


		async getSameItemList() {
			try {
				const parameter = this.requests.viewItem;
				const response = await this.$store.dispatch('network/request', {
					method: 'post',
					url: '/biz/shop/getSameItemList',
					data: parameter,
				});
			} catch (ex) {
				console.error('addWish exception.. ', ex);
			}
		},

		async tabDetailView(idx) {
			try {
				this.viewIdx = idx;
				this.$refs['ref_tab1'].classList.remove('active');
				this.$refs['ref_tab2'].classList.remove('active');
				this.$refs['ref_tab3'].classList.remove('active');
				this.$refs['ref_tab4'].classList.remove('active');

				if (idx == 0) {
					this.$refs['ref_tab1'].classList.add('active');
					godvBtnScroll('dvTabmain');
				} else if (idx == 1) {
					this.requests.feedbackItem.VIEW_PAGE = 1;
					if (this.goodItems.FEEDBACK_GRP_COUNT > 0) {
						// 구매후기그룹 상품의 리뷰가 있을 경우에만 상품 조회
						await this.getFeedBackGrpItem();
					}
					this.getFeedBack('All');
					this.getLikeFeedback();
					this.$refs['ref_tab2'].classList.add('active');
				} else if (idx == 2) {
					this.$refs['ref_tab3'].classList.add('active');
					this.requestQnas();
				} else if (idx == 3) {
					this.$refs['ref_tab4'].classList.add('active');
					godvBtnScroll('dvTabmain');
				}
			} catch (ex) {
				console.error('tabDetailView.. ', ex);
			}
		},

		//단일상품여부
		isNoSelectOption() {
			/*
                    추가구성상품이 있는 경우 : 본상품 옵션 단건 / 다건 무조건 선택
                    추가구성상품이 없는 경우 : 본상품 옵션 단건은 선택 x / 다건은 선택
                */
			if (!this.goodAddItem && this.goodItemOptions && this.goodItemOptions.length == 1) {
				return true;
			} else {
				return false;
			}
		},

		//추가구성상품 각각의 옵션 전체 품절여부 > 해당 상품만 비노출처리
		isNotAllSoldOut(options, index) {
			let checkSoldout = false;

			options.forEach((v) => {
				if (v.STATUS != 0 && v.STOCK > 0 && v.STATUS != 3 && v.STATUS != 7) {
					//일시품절
					checkSoldout = true;
				}
			});
			/*
                    정상상품이 있으면 true > 보여줘야함
                    모든 옵션이 다 품절이면 false
                */
			this.goodAddItem[index].ALL_SOLD_OUT = !checkSoldout;

			return checkSoldout;
		},

		//추가구성상품 전체 옵션 품절여부 > 아예 추가구성상품영역 비노출처리
		hasOptionList() {
			let hasStock = false;

			this.goodAddItem.forEach((item) => {
				if (item.STATUS == 1) {
					item.options.forEach((option) => {
						if (option.STATUS != 0 && option.STOCK > 0 && option.STATUS != 3 && option.STATUS != 7) {
							//일시품절
							hasStock = true;
						}
					});
				}
			});

			if (hasStock) return true;
			else return false;
		},

		// 옵션선택
		selectItemOptions(idx) {
			const alert = this.alert;
			const parent = this.goodItems;
			const option = this.goodItemOptions[idx];

			if (parent && option) {
				if (option.PAID_PRICE <= 0) {
					alert.message = '판매금액이 0 인 상품은 구매할 수 없습니다.';
					alert.isOpen = true;
				} else {
					if (this.goodItemSelectOptions.length > 0) {
						//이미 선택한 옵션인지 체크
						const ilItemOptionDetlId = option.IL_ITEM_OPTN_DETL_ID;
						const searchIdx = this.goodItemSelectOptions.findIndex(function(item) {
							return item.IL_ITEM_OPTN_DETL_ID === ilItemOptionDetlId;
						});

						//이미 담은 옵션이면
						if (searchIdx >= 0) {
							const alreadySelected = this.goodItemSelectOptions[searchIdx];
							if (
								alreadySelected.USER_LIMIT_YN == 'Y' && //최대수량 체크 id당
								alreadySelected.USER_LIMIT_TYPE == 'A' &&
								alreadySelected.USER_LIMIT_CNT < alreadySelected.QTY + 1
							) {
								//alert.message = '최대 구매개수는 ' + alreadySelected.USER_LIMIT_CNT + '개 입니다.';
								alert.message = '회원 당 구매수량 ' + alreadySelected.USER_LIMIT_CNT + '개까지 구매 가능합니다.';
								alert.isOpen = true;
								alreadySelected.QTY = alreadySelected.USER_LIMIT_CNT;
							} else if (
								alreadySelected.LIMIT_YN == 'Y' && //최대수량 체크 1회당
								alreadySelected.LIMIT_TYPE == 'A' &&
								alreadySelected.LIMIT_CNT < alreadySelected.QTY + 1
							) {
								//alert.message = '최대 구매개수는 ' + alreadySelected.LIMIT_CNT + '개 입니다.';
								alert.message = '최대 구매수량 ' + alreadySelected.LIMIT_CNT + '개까지 구매 가능합니다.';
								alert.isOpen = true;
								alreadySelected.QTY = alreadySelected.LIMIT_CNT;
							} else {
								//이미 선택한 옵션이면 수량만 +
								alreadySelected.QTY = alreadySelected.QTY + 1;
							}

							return;
						}
					}

					this.goodItemSelectOptions.unshift({
						//parents
						ITEM_NAME: parent.ITEM_NAME,
						LIMIT_YN: parent.LIMIT_YN,
						LIMIT_TYPE: parent.LIMIT_TYPE,
						LIMIT_CNT: parent.LIMIT_CNT,

						USER_LIMIT_YN: parent.USER_LIMIT_YN,
						USER_LIMIT_TYPE: parent.USER_LIMIT_TYPE,
						USER_LIMIT_CNT: parent.USER_LIMIT_CNT,

						//option
						CONSTRUCTION_CNT: option.CONSTRUCTION_CNT,
						OPTN_VAL1: option.OPTN_VAL1,
						OPTN_DETL_TYPE: option.OPTN_DETL_TYPE,
						FULL_OPTN_VAL1: option.FULL_OPTN_VAL1,
						STOCK: option.STOCK,
						STATUS: option.STATUS,
						IL_ITEM_OPTN_DETL_ID: option.IL_ITEM_OPTN_DETL_ID,
						USER_DEF_CD: option.USER_DEF_CD,
						QTY: parent.LIMIT_YN === 'Y' && parent.LIMIT_TYPE === 'I' ? parent.LIMIT_CNT : 1,
						TOTAL_DC_PRICE: option.TOTAL_DC_PRICE,
						MARKET_PRICE: option.MARKET_PRICE,
						TOTAL_EMPLOYEE_DC_PRICE: option.TOTAL_EMPLOYEE_DC_PRICE,
						DETL_OPTN_PRICE: option.DETL_OPTN_PRICE,
						IL_GOODS_CODE: option.IL_GOODS_CODE,
						ADD_PRICE: option.ADD_PRICE,
						PAID_PRICE: option.PAID_PRICE,
						PAID_SALE_TYPE: option.PAID_SALE_TYPE,
						TOTAL_DC_TEXT: option.TOTAL_DC_TEXT,
						SALE_PRICE: option.SALE_PRICE,
						IL_GOODS_ID: option.IL_GOODS_ID,
						/*
						 * [렌탈/구독 서비스][김재성]선택된 상품옵션의 모두렌탈가격정책번호세팅
						 */
						PRC_PLC_NO1: option.PRC_PLC_NO1,
						PRC_PLC_NO2: option.PRC_PLC_NO2,
					});

					this.isShowOption = false;

					/*
					 * [렌탈/구독 서비스][김재성]선택된 상품옵션의 분납금액
					 */
					this.installment.prc1 = option.INSTALLMENT_PRC1;
					this.installment.prc2 = option.INSTALLMENT_PRC2;
				}
			}

			this.isShowOption = false; //옵션창 닫기
		},

		//추가구성상품 선택
		addOptionSelect(e, list, optIdx, prtIdx) {
			const alert = this.alert;
			/*
                    다건: e
                    단건: list
                */
			let parent, option;
		    if(optIdx !== undefined && typeof optIdx === 'number') {
				parent = this.goodAddItem[prtIdx];
				option = this.goodAddItem[prtIdx].options[optIdx];
			} else {
				parent = list ? list : e.parent;
				option = e.option ? e.option : parent.options[0];
			}

			// 레이어 닫기
			this.isShowAddItem = false;
			this.isOptionsVisible = {};

			if (parent && option) {
				if (parent.PAID_PRICE <= 0) {
					alert.message = '판매금액이 0 인 상품은 구매할 수 없습니다.';
					alert.isOpen = true;
				} else {
					if (this.goodItemSelectOptions.length) {
						//이미 선택한 옵션인지 체크
						const searchIdx = this.goodItemSelectOptions.findIndex(function(item) {
							return item.IL_ITEM_OPTN_DETL_ID === option.IL_ITEM_OPTN_DETL_ID;
						});

						if (searchIdx >= 0) {
							const alreadySelected = this.goodItemSelectOptions[searchIdx];
							if (
								alreadySelected.USER_LIMIT_YN == 'Y' && //최대수량 체크
								alreadySelected.USER_LIMIT_TYPE == 'A' &&
								alreadySelected.USER_LIMIT_CNT < alreadySelected.QTY + 1
							) {
								//alert.message = '최대 구매개수는 ' + alreadySelected.USER_LIMIT_CNT + '개 입니다.';
								alert.message = '회원 당 구매수량  ' + alreadySelected.USER_LIMIT_CNT + '개까지 구매 가능합니다.';
								alert.isOpen = true;
								alreadySelected.QTY = alreadySelected.USER_LIMIT_CNT;
							} else if (
								alreadySelected.LIMIT_YN == 'Y' && //최대수량 체크
								alreadySelected.LIMIT_TYPE == 'A' &&
								alreadySelected.LIMIT_CNT < alreadySelected.QTY + 1
							) {
								//alert.message = '최대 구매개수는 ' + alreadySelected.LIMIT_CNT + '개 입니다.';
								alert.message = '최대 구매수량 ' + alreadySelected.LIMIT_CNT + '개까지 구매 가능합니다.';
								alert.isOpen = true;
								alreadySelected.QTY = alreadySelected.LIMIT_CNT;
							} else {
								//이미 선택한 옵션이면 수량만 +
								alreadySelected.QTY = alreadySelected.QTY + 1;
							}
							return;
						}
					}

					this.goodItemSelectOptions.unshift({
						//parents
						ITEM_NAME: parent.ITEM_NAME,
						LIMIT_YN: parent.LIMIT_YN,
						LIMIT_TYPE: parent.LIMIT_TYPE,
						LIMIT_CNT: parent.LIMIT_CNT,

						USER_LIMIT_YN: parent.USER_LIMIT_YN,
						USER_LIMIT_TYPE: parent.USER_LIMIT_TYPE,
						USER_LIMIT_CNT: parent.USER_LIMIT_CNT,

						IS_ADD_OPTION: true,

						//option
						CONSTRUCTION_CNT: option.CONSTRUCTION_CNT,
						OPTN_DETL_TYPE: option.OPTN_DETL_TYPE,
						OPTN_VAL1: option.OPTN_VAL1,
						FULL_OPTN_VAL1: option.FULL_OPTN_VAL1,
						STOCK: option.STOCK,
						STATUS: option.STATUS,
						IL_ITEM_OPTN_DETL_ID: option.IL_ITEM_OPTN_DETL_ID,
						USER_DEF_CD: option.USER_DEF_CD,
						QTY: parent.LIMIT_YN === 'Y' && parent.LIMIT_TYPE === 'I' ? parent.LIMIT_CNT : 1,
						MARKET_PRICE: option.MARKET_PRICE,
						DETL_OPTN_PRICE: option.DETL_OPTN_PRICE,
						IL_GOODS_CODE: option.IL_GOODS_CODE,
						IL_GOODS_ID: option.IL_GOODS_ID,
						ADD_PRICE: option.ADD_PRICE,
						SALE_PRICE: option.SALE_PRICE,
						PAID_PRICE: option.PAID_PRICE,
						/*
						 * [렌탈/구독 서비스][김재성]선택된 상품옵션의 모두렌탈가격정책번호세팅
						 */
						PRC_PLC_NO1: option.PRC_PLC_NO1,
						PRC_PLC_NO2: option.PRC_PLC_NO2,
					});

					/*
					 * [렌탈/구독 서비스][김재성]선택된 상품옵션의 분납금액
					 */
					this.installment.prc1 = option.INSTALLMENT_PRC1;
					this.installment.prc2 = option.INSTALLMENT_PRC2;
				}
			}
		},

		showOption(type) {
			if (type == 'addOption') {
				this.isShowOption = false;
				this.isOptionsVisible = {};
				this.isShowAddItem = true;
			} else {
				this.isShowOption = true;
				this.isShowAddItem = false;
			}
		},

		toggleOptions(index) {
			this.$set(this.isOptionsVisible, index, !this.isOptionsVisible[index]);
		  },

		deleteItemOptions(idx) {
			if (idx >= 0 && this.goodItemSelectOptions.length > 0) {
				var addOptionCnt = 1;
				var stopIdxYn = 'N';

				for (var i = idx + 1; i < this.goodItemSelectOptions.length; i++) {
					if (stopIdxYn == 'N') {
						if (this.goodItemSelectOptions[i].OPTN_DETL_TYPE == 'B' || this.goodItemSelectOptions[i].OPTN_DETL_TYPE == 'S') {
							stopIdxYn = 'Y';
							break;
						} else {
							addOptionCnt++;
						}
					}
				}

				this.goodItemSelectOptions.splice(idx, addOptionCnt);
			}
		},

		addItemOptionsQty(idx) {
			const alert = this.alert;
			const selectedGroup = this.goodItemSelectOptions;

			if (idx < selectedGroup.length) {
				const target = selectedGroup[idx];

				if (target.QTY >= target.STOCK) {
					if (target.STOCK >= 1000) {
						target.QTY = 999;
					} else {
						target.QTY = target.STOCK;
					}

					alert.message = '재고수량보다 많이 등록할 수 없습니다.';
					alert.isOpen = true;
				} else if (target.QTY >= 1000) {
					target.QTY = 999;
					alert.message = '1,000개 이상 구매할 수 없습니다.';
					alert.isOpen = true;
				} else if (target.USER_LIMIT_YN === 'Y' && target.USER_LIMIT_TYPE === 'A' && target.USER_LIMIT_CNT < target.QTY + 1) {
					target.QTY = target.USER_LIMIT_CNT;
					//alert.message = '최대 구매개수는 ' + target.USER_LIMIT_CNT + '개 입니다.';
					alert.message = '회원 당 구매수량 ' + target.USER_LIMIT_CNT + '개까지 구매 가능합니다.';
					alert.isOpen = true;
				} else if (target.LIMIT_YN === 'Y' && target.LIMIT_TYPE === 'A' && target.LIMIT_CNT < target.QTY + 1) {
					target.QTY = target.LIMIT_CNT;
					//alert.message = '최대 구매개수는 ' + target.LIMIT_CNT + '개 입니다.';
					alert.message = '최대 구매수량 ' + target.LIMIT_CNT + '개까지 구매 가능합니다.';
					alert.isOpen = true;
				} else {
					target.QTY = parseInt(target.QTY) + 1;
				}
			}
		},

		minusItemOptionsQty(idx) {
			const alert = this.alert;
			const selectedGroup = this.goodItemSelectOptions;

			if (idx < selectedGroup.length) {
				const target = selectedGroup[idx];
				if (target.USER_LIMIT_YN === 'Y' && target.USER_LIMIT_TYPE === 'I' && target.USER_LIMIT_CNT > --target.QTY) {
					target.QTY = target.USER_LIMIT_CNT;
					alert.message = '회원 당 최소 구매수량 ' + target.USER_LIMIT_CNT + '개부터 구매 가능합니다.';
					alert.isOpen = true;
				} else if (target.LIMIT_YN === 'Y' && target.LIMIT_TYPE === 'I' && target.LIMIT_CNT > --target.QTY) {
					target.QTY = target.LIMIT_CNT;
					alert.message = '최소 구매수량 ' + target.LIMIT_CNT + '개부터 구매 가능합니다.';
					alert.isOpen = true;
				}else{
					if (target.QTY > 1) {
						target.QTY = parseInt(target.QTY) - 1;
					}
				}
			}
		},

		inputQty(event, idx, type) {
			//개수 선택 시 숫자만 입력 체크
			const selectedArr = type == 'options' ? this.goodItemSelectOptions[idx] : this.goodsAddItemSave[idx];
			const numReg = /^[\d]+$/g;

			if (!numReg.test(selectedArr.QTY)) {
				selectedArr.QTY = selectedArr.QTY.replace(/[^\d]/g, '');
			}
		},

		itemQtyChangeCheck(event, idx, type) {
			alert("itemQtyChangeCheck");
			// 선택한 옵션 및 추가옵션 수량 체크 수기로 변경 시
			const selectedArr = type == 'options' ? this.goodItemSelectOptions[idx] : this.goodsAddItemSave[idx];
			const qtyValue = selectedArr.QTY; //event.target.value;
			const numReg = /^[\d]+$/g;

			if (!numReg.test(qtyValue)) {
				//문자 입력 시
				selectedArr.QTY = 1;
			} else {
				//숫자 입력 시 validation 체크
				this.validationQty(idx, selectedArr);
			}
		},

		validationQty(idx, target) {
			const alert = this.alert;
			const _qty = Number(target.QTY);
			const _stock = Number(target.STOCK);

			if (_qty == 0) {
				target.QTY = 1;
				alert.message = '수량을 0으로 등록할 수 없습니다.';
				alert.isOpen = true;
			} else if (_qty > _stock) {
				if (_stock >= 1000) target.QTY = 999;
				else target.QTY = _stock;
				alert.message = '남은 재고수량 '+_stock+'개까지 구매 가능합니다.';
				alert.isOpen = true;
			} else if (target.USER_LIMIT_YN === 'Y' && target.USER_LIMIT_TYPE === 'A' && target.USER_LIMIT_CNT < _qty) {
				target.QTY = target.USER_LIMIT_CNT;
				alert.message = '회원 당 구매수량 ' + target.USER_LIMIT_CNT + '개까지 구매 가능합니다.';
				alert.isOpen = true;
			} else if (target.LIMIT_YN === 'Y' && target.LIMIT_TYPE === 'A' && target.LIMIT_CNT < _qty) {
				target.QTY = target.LIMIT_CNT;
				alert.message = '최대 구매수량 ' + target.LIMIT_CNT + '개까지 구매 가능합니다.';
				alert.isOpen = true;
			} else if (target.LIMIT_YN === 'Y' && target.LIMIT_TYPE === 'I' && target.LIMIT_CNT > _qty) {
				target.QTY = target.LIMIT_CNT;
				alert.message = '최소 구매수량 ' + target.LIMIT_CNT + '개부터 구매 가능합니다.';
				alert.isOpen = true;
			} else if (_qty >= 1000) {
				target.QTY = 999;

				alert.message = '1,000개 이상 구매할 수 없습니다.';
				alert.isOpen = true;
			}
		},

		goodItemSelectOptionsChange() {
			const totalSelectItem = this.totalSelectItem;
			const selectedGroup = this.goodItemSelectOptions;

			totalSelectItem.TOTAL_PAID_PRICE = 0;
			totalSelectItem.TOTAL_DETL_OPTN_QTY = 0;

			for (let i = 0; i < selectedGroup.length; i++) {
				let price = selectedGroup[i].PAID_PRICE ? selectedGroup[i].PAID_PRICE : selectedGroup[i].SALE_PRICE;
				let qty = selectedGroup[i].QTY;

				totalSelectItem.TOTAL_PAID_PRICE = parseInt(totalSelectItem.TOTAL_PAID_PRICE) + parseInt(price) * parseInt(qty);

				if (selectedGroup[i].OPTN_DETL_TYPE == 'B' || selectedGroup[i].OPTN_DETL_TYPE == 'S') {
					//필수 선택 여부체크를위해
					totalSelectItem.TOTAL_DETL_OPTN_QTY = parseInt(totalSelectItem.TOTAL_DETL_OPTN_QTY) + parseInt(qty);
				}
			}
		},

		// 인입쿠폰
		async requestCoupon() {
			const parameter = this.requests.inWebCoupon;
			const response = await this.$store.dispatch('network/request', {
				method: 'post',
				url: '/event/couponZone/getCouponList',
				data: parameter,
				dupAllow : true,
			});

			const rows = response.cp_list;

			if (rows && rows.length) this.coupons = response.cp_list;

			this.fetches.coupon = true;

			this.$nextTick(function() {
				this.couponSlider();
			});
		},

		parePrice(type) {
			if (type.indexOf('%') >= 0) {
				if (/[0-9]/.test(type)) return 'percent';
				else return 'free';
			} else {
				return 'price';
			}
		},

		couponSlider() {
			const el = this.$refs['couponSlider'];

			if (this.coupons && this.coupons.length > 1) {
				new Swiper(el, {
					navigation: {
						nextEl: '.goodsCoupon__controller__btn.next',
						prevEl: '.goodsCoupon__controller__btn.prev',
					},
					pagination: {
						el: '.goodsCoupon__controller__paging',
						type: 'progressbar',
					},
				});
			}
		},

		async couponDown(couponOb, noDim, popupId) {
			const alert = this.alert;
			const confirm = this.confirm;

			var response = "";

			try {
				// 네이버 팝업일경우 팝업 닫기
				if(popupId == 'popupNaverCoupon'){
					comPopupClose(popupId);
				}

				if(couponOb.length > 1) {
					for (let i = 0; i < couponOb.length; i++) {
						const coupon = couponOb[i];

						response = await this.$store.dispatch('network/request', {
							method: 'post',
							url: '/event/couponZone/getCouponBookDownCheck',
							data: {
								PM_COUPON_ID: coupon.PM_COUPON_ID,
							},
						    dupAllow : true,
						});

						if(response.data.ISSUE_LIMIT_CHK != 'N' && response.data.LOGIN_CHECK_YN != 'N'
							&& response.data.PERIOD_CHEK_YN != 'N') {
								this.couponDownSuccess(coupon);
						}
						if (response.data.LOGIN_CHECK_YN == 'N') {
							confirm.message = '로그인이 필요합니다.<br>로그인 하시겠습니까?';
							confirm.isOpen = true;
							confirm.model = 'login';
							return false;
						}
						if(response.data.PERIOD_CHEK_YN == 'N') {
							alert.message = '쿠폰 다운로드 기간이 지났습니다.';
							alert.isOpen = true;
							return false;
						}

						if(popupId == 'popupNaverCoupon' && response.data.ISSUE_LIMIT_CHK == 'N'){
							alert.message = '이미 쿠폰을 다운로드 받으셨습니다.';
							alert.isOpen = true;
							return false;
					  }
					}
				} else {
					// 단건 쿠폰 다운로드 시
					response = await this.$store.dispatch('network/request', {
					method: 'post',
					url: '/event/couponZone/getCouponBookDownCheck',
					data: {
						PM_COUPON_ID: couponOb.PM_COUPON_ID,
					},
				});

				if (response.data.LOGIN_CHECK_YN == 'N') {
					confirm.message = '로그인이 필요합니다.<br>로그인 하시겠습니까?';
					confirm.isOpen = true;
					confirm.model = 'login';
					return false;
				} else if (response.data.PERIOD_CHEK_YN == 'N') {
					alert.message = '쿠폰 다운로드 기간이 지났습니다.';
					alert.isOpen = true;
					return false;
				} else if (response.data.ISSUE_LIMIT_CHK == 'N') {
					alert.message = '이미 쿠폰을 다운로드 받으셨습니다.';
					alert.isOpen = true;
					return false;
				} else {
					this.couponDownSuccess(couponOb);
				}
				}
			} catch (ex) {
				console.error(ex);
			}
		},

		async couponDownSuccess(id) {
			const alert = this.alert;

			try {
				const response = await this.$store.dispatch('network/request', {
					method: 'post',
					url: '/event/couponZone/downloadCoupon',
					data: {
						PM_COUPON_ID: id.PM_COUPON_ID,
					},
				    dupAllow : true,
				});

				if (response.RETURN_CODE == '000000000') {
					//alert.message = "'" + id.SALE_NAME + "'<br>다운로드 완료 되었습니다.";
					alert.message = "다운로드 완료 되었습니다.";
					alert.isOpen = true;
					alert.coupon = true;
					this.requestCoupon();
				}
			} catch (ex) {
				console.error(ex);
			}
		},

		isAbleDownload(coupon) {
			let isPass = false;
			const limitYN = coupon.ISSUE_LIMIT_YN; // 발급제한 N: 미사용, Y: 사용
			const limitCount = coupon.ISSUE_LIMIT_COUNT; // 발행제한 개수
			const limitType = coupon.ISSUE_LIMIT_TYPE; // 발급타입 1: 일괄, 2 : 사용 후 재다운로드
			const downCount = coupon.DOWN_CNT; // 다운로드 개수
			const useCount = coupon.USE_CNT; // 사용한 개수

			if (limitYN == 'N' && downCount == 0) {
				// 미사용 && 다운로드 안받은 경우
				isPass = true;
			} else if (limitYN == 'Y' && limitType == 1 && limitCount == 0) {
				// 사용 && 일괄 && 무제한
				isPass = true;
			} else if (limitYN == 'Y' && limitType == 1 && limitCount != 0 && downCount < limitCount) {
				// 사용 && 일괄 && 개수 제한 && 개수 제한 < 다운로드 횟수
				isPass = true;
			} else if (limitYN == 'Y' && limitType == 2 && limitCount == 0 && downCount == 0) {
				// 사용 && 사용 후 재다운로드 && 무제한 && 최초 다운로드
				isPass = true;
			} else if (limitYN == 'Y' && limitType == 2 && limitCount == 0 && downCount != 0 && downCount == useCount) {
				// 사용 && 사용 후 재다운로드 && 무제한 && 재다운로드 && 개수 제한 < 다운로드 횟수(쿠폰 사용여부)
				isPass = true;
			} else if (limitYN == 'Y' && limitType == 2 && limitCount != 0 && downCount == 0 && downCount < limitCount) {
				isPass = true;
			} else if (limitYN == 'Y' && limitType == 2 && limitCount != 0 && downCount != 0 && downCount < limitCount && downCount == useCount) {
				// 사용 && 사용 후 재다운로드 && 개수 제한 && 재다운로드 && 개수 제한 < 다운로드 횟수(쿠폰 사용여부)
				isPass = true;
			} else {
				isPass = false;
			}

			coupon.DOWNLOAD_ABLE = isPass;
			return isPass;
		},

		// 장바구니 validation체크
		checkCartIn(event) {
			const alert = this.alert;
			const selectedGroup = this.goodItemSelectOptions;
			const selectedQty = parseInt(this.totalSelectItem.TOTAL_DETL_OPTN_QTY);

			if (!selectedGroup.length) {
				alert.message = '장바구니에 담을 상품을 선택해 주시기 바랍니다.';
				alert.isOpen = true;
			} else if (this.totalSelectItem.TOTAL_PAID_PRICE <= 0) {
				alert.message = '구매금액을 0원으로 장바구니에 담을 수 없습니다.';
				alert.isOpen = true;
			} else if (this.processes.cartIn === true) {
				alert.message = '장바구니에 상품을 담는 중입니다. 잠시 후 다시 담아주시기 바랍니다.';
				alert.isOpen = true;
			} else if (this.goodItems.ADULT_YN.trim() === 'Y' && this.isAdult === false) {
				// 로그인 유무 체크 하기
				if (this.goodItemUser.UR_USER_ID != '') {
					// 성인인증 체크하기
					this.requestAdultChk("C");
				} else {
					this.modals.adultLoginModal.isOpen = true;
				}
			} else {
				//제한수량이 있는 경우
				let limitCheck = true;
				if (this.goodItems.USER_LIMIT_YN == 'Y') {
					if (this.goodItems.USER_LIMIT_TYPE == 'A' && (selectedQty > this.goodItems.USER_LIMIT_CNT)) {
						//최대구매수량제한
						alert.message = '회원 당 구매수량 최대 ' + this.goodItems.USER_LIMIT_CNT + '개까지</br> 구매 가능합니다.';
						limitCheck = false;
					}
				} else if (this.goodItems.LIMIT_YN == 'Y') {
					// if (this.goodItems.LIMIT_TYPE == 'I' && (selectedQty < this.goodItems.LIMIT_CNT)){
					//   //최소구매수량제한
					//   limitCheck = false;
					//   alert.message = '최소 구매수량 '+this.goodItems.LIMIT_CNT+'개부터 구매 가능합니다.';
					// }else
					if(this.goodItems.LIMIT_TYPE == 'A' && (selectedQty > this.goodItems.LIMIT_CNT)){
					  //최대구매수량제한
						limitCheck = false;
					  alert.message = '최대 구매수량 '+this.goodItems.LIMIT_CNT+'개까지 구매 가능합니다.';
					}
				}

				if (!limitCheck) {
					alert.isOpen = true;
				} else {
					//validation 통과 시
					this.requestCartIn(selectedGroup);
				}
			}
		},

		//장바구니 연동
		async requestCartIn(selectedGroup) {
			const alert = this.alert;
			const cartDataArr = [];
			this.processes.cartIn = true;
			let sendParameter = '';
			let cartPrice = 0;

			try {
				for (let i = 0; i < selectedGroup.length; i++) {
					let eachItem = selectedGroup[i];

					if (i != 0) {
						if (eachItem.OPTN_DETL_TYPE == 'A') sendParameter = sendParameter + '!';
						else sendParameter = sendParameter + '@N,';
					}

					sendParameter = sendParameter + eachItem.OPTN_DETL_TYPE + ':' + eachItem.IL_ITEM_OPTN_DETL_ID + ':' + eachItem.QTY + ':' + eachItem.PAID_PRICE * eachItem.QTY;
					cartPrice = cartPrice + eachItem.PAID_PRICE * eachItem.QTY;
					cartDataArr.push({
						productID: eachItem.IL_ITEM_OPTN_DETL_ID,
						unit: eachItem.QTY,
						price: eachItem.SALE_PRICE * eachItem.QTY,
					});
				}

				const response = await this.$store.dispatch('network/request', {
					method: 'get',
					url: '/biz/cs/cart/inserItemInCart?cartList=N,' + sendParameter,
				});

				const result = response.result;

				if (result && result.resultCode == '0' && result.cartId && result.cartId.length) {
					result.cartId[0];
					this.viewCartGoButton = true;
					// AceCounter eCommerce Product_Detail
					try {
						AW_PRODUCT(this.totalSelectItem.TOTAL_DETL_OPTN_QTY);
					} catch (e) {
						console.log(e);
					}

					setTimeout(() => {
						this.viewHiddennGoCartButton();
					}, 3000);

					this.requestCartCount();
					this.setAddCartAppierScript(cartDataArr);
					this.setAddCartAdjustScript(cartDataArr);
					this.setAddCartMetaPixel(cartDataArr)

					//GA4 전자상거래
					dataLayer.push({
						"event" : "add_to_cart",
						"ecommerce" : {
							"currency" : "KRW",
							"items" : [{
								"item_id" : String(this.goodItems.IL_ITEM_ID),
								"item_name" : String(this.goodItems.ITEM_NAME),
								"price" : String(this.goodItems.SALE_PRICE)
							}]
						}
					});

					/*rtbhouse 광고 스크립트 추가 20240711*/
					(rtbhEvents = window.rtbhEvents || []).push(
						{
							eventType: 'basketadd',
							offerId: String(this.goodItems.IL_ITEM_ID)
						},
						{
							eventType: 'uid',
							id: userId
					});
				} else {
					alert.message = '장바구니에 상품을 담을수 없습니다.';
					alert.isOpen = true;
				}

				this.processes.cartIn = false;
			} catch (ex) {
				console.error('requestCartIn exception.. ', ex);
			}
		},

		// 구매하기 validation
		/*
		 * [렌탈/구독 서비스][김재성]주문생성, 렌탈주문의 경우 총금액 '0' 처리
		 *  - 총구매금액('totalPrice') 체크 시 '!this.isSvcOrder' 조건 추가
		 */
		checkOrderItem() {
			const alert = this.alert;
			const totalPrice = this.totalSelectItem.TOTAL_PAID_PRICE;
			const selectedGroup = this.goodItemSelectOptions;

			if (this.viewPriceInfo.viewStockStatus == 'ALLSTOP') {
				alert.message = '품절상품은 구매할 수 없습니다.';
				alert.isOpen = true;
			} else if (this.viewPriceInfo.viewStockStatus == 'TEMPSTOP') {
				alert.message = '일시품절 상품은 구매할 수 없습니다.';
				alert.isOpen = true;
			} else if (selectedGroup.length == 0) {
				alert.message = '구매할 상품을 선택해주시기 바랍니다.';
				alert.isOpen = true;
			} else if (totalPrice <= 0 && !this.isSvcOrder) {
				alert.message = '구매금액을 0원으로 구매할 수 없습니다.';
				alert.isOpen = true;
			} else if (this.goodItems.ADULT_YN.trim() === 'Y' && this.isAdult === false) {
				// 로그인 유무 체크 하기
				if (this.goodItemUser.UR_USER_ID != '') {
					// 성인인증 체크하기
					this.requestAdultChk("O");
				}  else {
					this.modals.adultLoginModal.isOpen = true;
				}
			} else {
				const selectedQty = parseInt(this.totalSelectItem.TOTAL_DETL_OPTN_QTY);
				let limitCheck = true;

				//제한수량이 있는 경우
				if (this.goodItems.USER_LIMIT_YN === 'Y') {
					if (
						this.goodItems.USER_LIMIT_TYPE === 'A' &&
						selectedQty > this.goodItems.USER_LIMIT_CNT //최대구매수량제한
					) {
						  alert.message = '회원 당 구매수량 ' + this.goodItems.USER_LIMIT_CNT + '개까지</br> 구매 가능합니다.';
						limitCheck = false;
					}
				} else if (this.goodItems.LIMIT_YN === 'Y') {
					//   if ((this.goodItems.LIMIT_TYPE === 'I' && selectedQty < this.goodItems.LIMIT_CNT)){
					// 	//최소구매수량제한
					// 	limitCheck = false;
					// 	alert.message = '최소 구매수량 '+this.goodItems.LIMIT_CNT+'개부터 구매 가능합니다.';
					//   }else
					  if(this.goodItems.LIMIT_TYPE === 'A' && selectedQty > this.goodItems.LIMIT_CNT){
						//최대구매수량제한
						limitCheck = false;
						alert.message = '최대 구매수량 '+this.goodItems.LIMIT_CNT+'개까지 구매 가능합니다.';
					}
				}

				if (!limitCheck) {
					alert.isOpen = true;
					this.processes.cartIn = false;
				} else if (this.processes.orderItem === true) {
					alert.message = '상품을 구매중입니다.';
					alert.isOpen = true;
				} else {
					this.requestOrderItem(selectedGroup);
				}
			}
		},

		//구매하기 연동
		async requestOrderItem(selectedGroup) {
			const alert = this.alert;
			this.processes.orderItem = true;
			let tmpChk = true;

			try {
				let sendParameter = '';
				let userLimitYn = 'N';

				for (let i = 0; i < selectedGroup.length; i++) {
					let eachItem = selectedGroup[i];

					if (i != 0) {
						if (eachItem.OPTN_DETL_TYPE == 'A') sendParameter = sendParameter + '!';
						else sendParameter = sendParameter + '@Y,';
					}
					userLimitYn = eachItem.USER_LIMIT_YN;
					sendParameter = sendParameter + eachItem.OPTN_DETL_TYPE + ':' + eachItem.IL_ITEM_OPTN_DETL_ID + ':' + eachItem.QTY + ':' + eachItem.PAID_PRICE;
					/*
					 * [렌탈/구독 서비스][김재성]PRC_PLC_NO(가격정책번호), INSTALLMENT_TERM(분납기간) 데이터 추가 생성
					 */
					if (this.isSvcOrder) {
						sendParameter = sendParameter + ':' + this.installment.prcPlcNo;
						sendParameter = sendParameter + ':' + this.installment.term;
					}
				}

				// 카트에 넣기전에 limit_yn이 y이면 살수있는지 먼저 체크하기!
				if (userLimitYn == 'Y') {
					const response = await this.$store.dispatch('network/request', {
						method: 'get',
						url: '/biz/shop/validateUserLimitItem?IL_ITEM_ID=' + this.requests.viewItem.IL_ITEM_ID,
					});

					const result = response.RETURN_CODE;
					if (result == 'F') {
						tmpChk = false;
						alert.message = '상품을 구매할 수 없습니다.';
						alert.isOpen = true;
					}

					// 구매제한 상품일 경우 비회원 구매불가
					if (this.goodItemUser.UR_USER_ID == '') {
						tmpChk = false;
						var confirm = this.confirm;
						confirm.message = '이 상품은 굳닷컴 회원 전용 상품입니다.<br/>회원가입 또는 로그인 후 구매 가능합니다.';
						confirm.model = 'login';
						confirm.isOpen = true;
					}
				}

				if (tmpChk) {
					const response = await this.$store.dispatch('network/request', {
						method: 'get',
						url: '/biz/cs/cart/inserItemInCart?cartList=Y,' + sendParameter,
					});

					const result = response.result;

					if (result && result.resultCode == '0' && result.cartId.length) {
						this.addCartId = '';
						// AceCounter eCommerce Product_Detail
						try {
							AW_PRODUCT(this.totalSelectItem.TOTAL_DETL_OPTN_QTY);
						} catch (e) {
							console.log(e);
						}

						for (let i = 0; i < result.cartId.length; i++) {
							if (i != 0) this.addCartId += ',' + result.cartId[i];
							else this.addCartId += result.cartId[i];
						}

						if (this.goodItemUser.UR_USER_ID != '') {
							/*
							 * [렌탈/구독 서비스][김재성]
							 *  - '렌탈주문' 선택에 따라 렌탈나우 상담신청 페이지로 이동
							 */
							if (!this.isSvcOrder) {
								// 일반주문
								location.href = '/shop/infoinput?cartIds=' + this.addCartId;
							}
							else {
								// 장기할부플렌 신청하기 페이지 종료
								this.rentalPopup = false;
								// 장기할부플렌 신청하기 초기화
								this.isSvcOrder = false;

								// 임시주문(OD_ORDER.USE_YN='N')생성
								$.ajax({
									method: 'post',
									url: '/biz/shop/addSvcOrder',
									data: {
										SELECT_CART_ID: this.addCartId,
									},
									success : function (data){
										//console.log('data to pass to modu => ', data);
										if (data.RETURN_CODE == '000000000') {
											/**
											 * [렌탈/구독 서비스][김재성] 렌탈나우 '계약신청' 페이지 호출
											 * 	prcPlcNo	모두렌탈 가격정책번호(AES)
											 *  authKey		제휴사 Key(AES)
											 *  returnUrl	계약결과를 리턴받을 제휴사 랜딩페이지 URL
											 *  prcCode		모두렌탈 품목코드 - 사용보류
											 *  timeStamp	YYYYMMDDhhmmss로 표현된 호출 시점의 시간 - 사용보류
											 *  clientKey	제휴사 고객 Key(AES) - 사용보류
											 *  hashData	hash("sha512", timstamp.authKey.clientKey) 로 구성, 변조데이터 구분 - 사용보류
											 *
											 *  인증키(authKey) 파랴미터에 대해서 별도의 urlEncode 요청 적용
											 */
											let height = 800;
											let width = 1320;
											let left = ( screen.width - width ) / 2;
											let top = ( screen.height - height ) / 2;
											let authKey = "&authKey=" + encodeURIComponent(data.AUTH_KEY);
											let returnUrl = "&returnUrl=" + encodeURIComponent(window.location.origin + '/shop/svcOrderResult?ODID=' + data.ODID + '&OD_ORDER_ID=' + data.OD_ORDER_ID
												+ "&SELECT_CART_ID=" + data.SELECT_CART_ID);
											let windowSize = "scrollbars=yes,resizable=yes,width=" + width + ",height=" + height + ",scrollbars=no,top=" + top + ",left=" + left;

											window.open( data.RENTAL_LINKED_URL + returnUrl + authKey, "_blank", windowSize);
										}
										else {
											if (data.RETURN_CODE == '900000030') {
												// '상품의 재고가 모두 소진되어 서비스 신청이 불가합니다. 관리자에게 문의해 주시기 바랍니다.'
												alert.message = data.RETURN_MSG;
											}
											else {
												// 임시주문(OD_ORDER.USE_YN='N')생성 오류 메시지 노출
												alert.message = '계약신청 시 오류가 발생했습니다. 관리자에게 문의하세요.';
											}
											alert.isOpen = true;
										}
									},
									error : function(xhr, status, strError){
										//console.log("카테고리 메뉴 로딩 실패");
									}
								});
							}
						}
						else {
							if (!this.isSvcOrder) {
								this.modals.loginModal.isOpen = true;
							}
							else {
								this.modals.svcLoginModal.isOpen = true;
							}
						}
					} else {
						alert.message = '상품을 구매할 수 없습니다.';
						alert.isOpen = true;
					}
				}

				this.processes.orderItem = false;
			} catch (ex) {
				console.error('addCartItem exception.. ', ex);
			}
		},

		setAddCartAppierScript(cartDataArr) {
			//에피어 카트담기 수집 스크립트 20200511

			if (cartDataArr) {
				var appierRtAddToCart = cartDataArr;

				window.appier_q = window.appier_q || [];
				window.appier_q.push(
					{
						t: 'register',
						content: { id: 'f1ac', site: 'guud.com' },
					},
					{
						t: 'type_addcart',
						itemList: appierRtAddToCart,
					}
				);
			}
		},

		setAddCartAdjustScript(cartDataArr) {
			// Adjust start
			// adjustAddCart
			if (cartDataArr) {
				let adjust_qty = 0;
				let adjust_price = 0;
				for (let i = 0; i < cartDataArr.length; i++) {
					let eachItem = cartDataArr[i];

					adjust_qty = adjust_qty + eachItem.unit;
					adjust_price = adjust_price + eachItem.price;
				}

				const il_item_id = String(this.goodItems.IL_ITEM_ID);
				const il_ctgry_id = String(this.goodItems.IL_CTGRY_ID);
				adjust_qty = String(adjust_qty);
				adjust_price = String(adjust_price);

				var eventToken, adjustAppToken;

				if (isPrd) {
					eventToken = 'brgpea';
				} else {
					eventToken = '3nrhw2';
				}

				// adjust
				Adjust.trackEvent({
					eventToken: eventToken,
					callbackParams: [{ key: 'item_id', value: il_item_id }, { key: 'ctgry_id', value: il_ctgry_id }, { key: 'qty', value: adjust_qty }, { key: 'price', value: adjust_price }],
				});
			}
		},

		setAddCartMetaPixel(cartDataArr) {
			// Meta Pixel Code 페이스북 메타 픽셀 이벤트
			if (cartDataArr) {
				let meta_qty = 0;
				let meta_price = 0;
				for (let i = 0; i < cartDataArr.length; i++) {
					let eachItem = cartDataArr[i];

					meta_qty = meta_qty + eachItem.unit;
					meta_price = meta_price + eachItem.price;
				}

				const il_item_name = String(this.goodItems.ITEM_NAME);
				const il_item_id = String(this.goodItems.IL_ITEM_ID);
				meta_qty = String(meta_qty);
				meta_price = String(meta_price);

				//페이스북(메타) 픽셀 이벤트 - 장바구니 담기
				fbq('track', 'AddToCart', {
				      content_name : il_item_name ,
				      content_type : 'product',
				      contents : [{
				        'id' : il_item_id,
				        'quantity' : meta_qty}],
				      currency : 'KRW',
				      value : meta_price
				  });

			}
		},

		viewHiddennGoCartButton() {
			this.viewCartGoButton = false;
		},

		changeSizeWidth(idx) {
			if (idx == -1) {
				this.sameSizeModal.startItemIndex = -1;

				for (let i = 0; i < this.goodItemOptions.length; i++) {
					if (this.goodItemOptions[i].WIDTH > 0) {
						if (this.sameSizeModal.viewYn == 'N') {
							this.requests.sameSizeItem.SEARCH_WIDTH = this.goodItemOptions[i].WIDTH;
							this.sameSizeModal.viewYn = 'Y';
							this.sameSizeModal.startItemIndex = i;
							this.viewSetSize(this.goodItemOptions[i].OPTN_VAL1, this.goodItemOptions[i].WIDTH, this.goodItemOptions[i].HEIGHT, this.goodItemOptions[i].DEPTH);
						}

						this.sameSizeModal.viewSizeCnt = this.sameSizeModal.viewSizeCnt + 1;
					}
				}
			} else {
				this.requests.sameSizeItem.SEARCH_WIDTH = this.goodItemOptions[idx].WIDTH;
			}
		},

		async viewSameSizeItem() {
			this.sameSizeModal.viewSameSizeYn = 'Y';
			this.sameSizeModal.viewButtonSizeYn = 'Y';
			this.fetches.goodItemSize = false;

			try {
				this.requests.sameSizeItem.IL_ITEM_ID = this.goodItems.IL_ITEM_ID;
				this.requests.sameSizeItem.IL_CTGRY_ID = this.goodItems.IL_CTGRY_ID;
				const parameter = this.requests.sameSizeItem;
				const response = await this.$store.dispatch('network/request', {
					method: 'post',
					url: '/biz/shop/getGoodsSameSizeView',
					data: parameter,
				});

				if (response) {
					const goodItemSameSizeList = response.goodItemSameSizeList;

					for (let i = 0; i < goodItemSameSizeList.length; i++) {
						this.goodItemSameSize.push(goodItemSameSizeList[i]);
					}

					if (goodItemSameSizeList.length == 0) {
						this.requests.sameSizeItem.VIEW_PAGE = 1;
						this.sameSizeModal.viewButtonSizeYn = 'N';
					} else {
						this.requests.sameSizeItem.VIEW_PAGE = goodItemSameSizeList[0].VIEW_PAGE;

						if (this.requests.sameSizeItem.VIEW_PAGE == goodItemSameSizeList[0].LAST_PAGE) {
							this.sameSizeModal.viewButtonSizeYn = 'N';
						}
					}

					this.fetches.goodItemSize = true;
				}
			} catch (ex) {
				console.error('viewSameSizeItem exception.. ', ex);
			}
		},

		sameNextSizeView() {
			this.requests.sameSizeItem.VIEW_PAGE = parseInt(this.requests.sameSizeItem.VIEW_PAGE) + 1;
			this.viewSameSizeItem();
		},

		sameSizeView(viewYn) {
			this.sameSizeModal.viewSameSizeYn = viewYn;

			if (viewYn == 'N') {
				this.goodItemSameSize = [];
				this.requests.sameSizeItem.VIEW_PAGE = 1;
			}
		},

		async viewHashTagItem() {
			this.hashTagModal.viewButtonTagYn = 'Y';
			this.fetches.goodItemTag = false;

			try {
				this.requests.hashTagItem.IL_ITEM_ID = this.goodItems.IL_ITEM_ID;
				const parameter = this.requests.hashTagItem;

				const response = await this.$store.dispatch('network/request', {
					method: 'post',
					url: '/biz/shop/getGoodsHashTagView',
					data: parameter,
				});

				if (response) {
					const goodItemTagsList = response.goodItemTagsList;

					for (let i = 0; i < goodItemTagsList.length; i++) {
						this.goodItemTagsView.push(goodItemTagsList[i]);
					}

					if (goodItemTagsList.length == 0) {
						this.requests.hashTagItem.VIEW_PAGE = 1;
						this.hashTagModal.viewButtonTagYn = 'N';
					} else {
						this.requests.hashTagItem.VIEW_PAGE = goodItemTagsList[0].VIEW_PAGE;

						if (this.requests.hashTagItem.VIEW_PAGE == goodItemTagsList[0].LAST_PAGE) {
							this.hashTagModal.viewButtonTagYn = 'N';
						}
					}

					this.fetches.goodItemTag = true;
				}
			} catch (ex) {
				console.error('viewHashTagItem exception.. ', ex);
			}
		},

		hashNextTagView() {
			this.requests.hashTagItem.VIEW_PAGE = parseInt(this.requests.hashTagItem.VIEW_PAGE) + 1;
			this.viewHashTagItem();
		},

		hashTagView(vTitle) {
			this.hashTagModal.viewHashTagViewYn = 'Y';
			this.requests.hashTagItem.SEARCH_TAG = vTitle;
			this.viewHashTagItem();
		},

		openPhotoOnlyView(photoBestReviewYn) {
			this.photoModal.viewPhotoOnlyViewYn = 'Y';
			this.photoModal.viewPhotoViewYn = 'N';

			if(photoBestReviewYn){
				if(photoBestReviewYn == 'Y'){
					this.requests.feedbackItem.SORT_GUBUN = 1;
				}else {
					this.requests.feedbackItem.SORT_GUBUN = this.sortOption;
				}
			}
			this.viewPopFeedbackOnlyPhotoList();
			scrollSet('Y');
		},

		closePhotoOnlyView() {
			this.photoModal.viewPhotoOnlyViewYn = 'N';
			scrollSet('N');
		},

		closeHashTagView() {
			this.hashTagModal.viewHashTagViewYn = 'N';
			this.goodItemTagsView = [];
			this.requests.hashTagItem.VIEW_PAGE = 1;
		},

		closeModal(modalPop, payload) {
			modalPop.isOpen = false;
			scrollSet('N');
		},

		viewSetSize(viewItemNm, xSize, ySize, dSize) {
			this.requests.sameSizeItem.SEARCH_WIDTH = xSize;
			this.sameSizeModal.viewItemNm = viewItemNm;
			this.sameSizeModal.viewXsize = xSize;
			this.sameSizeModal.viewYsize = ySize;
			this.sameSizeModal.viewDsize = dSize;
			this.sameSizeModal.viewSizeListView = 0;
		},

		splitText(text){
			if (!text) return;

			const splitText = /(.*)(;)(.*)/;
			const returnValue = text.split(splitText);

			if (returnValue.length > 1) {
				//return `<span>${returnValue[1]}</span><span class="small">${returnValue[3]}</span>`;
				return `<span>${returnValue[1]} ${returnValue[3]}</span>`;
			} else {
				return `<span>${returnValue[0]}</span>`;
			}
		},

		htmlVideo(value, id, gubun) {
			if (gubun == '2') {
				this.$nextTick(function() {
					this.$set(this.player, id, null);

					this.player[id] = new Player(id, {
						id: value,
						width: 400,
						height: 300,
					});
				});
			} else {
				this.$nextTick(function() {
					this.$set(this.player, id, null);

					this.player[id] = new Player(id, {
						id: value,
						width: this.$refs['refVideo'].clientWidth,
						height: this.$refs['refVideo'].clientHeight,
					});
				});
			}
		},

		videoMainPlay(e, id, gubun) {
			const player = this.player[id];

			if (gubun == 'STOP') {
				player.isPlay = false;
				player.pause();
				$('.content__video__play').removeClass('hide');
				$('.content__video__thumbnail').removeClass('hide');
				$('.goodsView__pdImg-thumbs').removeClass('hide');
			} else {
				player.isPlay = true;
				player.play();
				$('.content__video__play').addClass('hide');
				$('.content__video__thumbnail').addClass('hide');
				$('.goodsView__pdImg-thumbs').addClass('hide');
			}
		},

		videoPlay(e, i, id) {
			if (i == 'play') {
				this.player[id].play();
				e.target.classList.remove('hide');
				let thref = this.$refs['th_' + id];

				if (thref.length) thref[0].classList.remove('hide');
				else thref.classList.remove('hide');
			} else {
				this.player[id].pause();
				e.target.classList.add('hide');
				let thref = this.$refs['th_' + id];

				if (thref.length) thref[0].classList.add('hide');
				else thref.classList.add('hide');
			}
		},

		async getFeedBackGrpItem() {
			try {
				const parameter = this.requests.viewItem;
				const response = await this.$store.dispatch('network/request', {
					method: 'post',
					url: '/biz/shop/getFeedBackGrpItem',
					data: parameter,
				});

				if (response) {
					// 전체상품보기
					const allItem = {};
					allItem.imgSrc = '';
					allItem.desc = '전체상품보기';
					allItem.target = 'All';
					this.productList.data[0] = allItem;

					// 본 상품(해당 상품상세화면의 상품)의 상품리뷰 개수가 0개라도 노출함
					const thisItem = {};
					thisItem.imgSrc = this.goodItems.S_IMG;
					thisItem.desc = this.goodItems.ITEM_NAME;
					thisItem.target = this.goodItems.IL_ITEM_ID;
					this.productList.data[1] = thisItem;

					let feedBackGrpItem = response.getFeedBackGrpItem;
					for (let i = 0; i < feedBackGrpItem.length; i++) {
						const el = {};
						el.imgSrc = feedBackGrpItem[i].S_IMG;
						el.desc = feedBackGrpItem[i].ITEM_NAME;
						el.target = feedBackGrpItem[i].IL_ITEM_ID;
						this.productList.data[i+2] = el;
					}
				}

			} catch (ex) {
				console.error('getFeedBackGrpItem exception.. ', ex);
			}

		},

		async getFeedBack(type) {
			this.processes.goodItemFeebackList = true;

			try {
				this.requests.feedbackItem.IL_ITEM_ID = this.requests.viewItem.IL_ITEM_ID;
				if (type){ // 후기 초기 조회('All')와 후기그룹의 상품 변경시(IL_ITEM_ID)에만 IL_ITEM_ID_LIST 변경 및 페이징 초기화
					this.requests.feedbackItem.IL_ITEM_ID_GRP = [];
					this.requests.feedbackItem.VIEW_PAGE = 1;
					if (type == 'All') {
						const productList = this.productList.data;
						if (productList.length > 0){
							// 전체 조회시 구매후기그룹 상품이 있는 경우에만 IL_ITEM_ID_GRP 셋팅
							for (let i = 1; i < productList.length; i++) {
								this.requests.feedbackItem.IL_ITEM_ID_GRP.push(productList[i].target);
							}
						}
					} else {
						// 구매후기그룹 내 상품 개별 조회시
						this.requests.feedbackItem.IL_ITEM_ID_GRP.push(type);
					}
				}
				var reviewListOn = this.$refs['reviewList'];

				if (reviewListOn) {
					for (let i = 0; i < reviewListOn.length; i++) {
						reviewListOn[i].removeAttribute('open');
					}
				}

				const parameter = this.requests.feedbackItem;
				const response = await this.$store.dispatch('network/request', {
					method: 'post',
					url: '/biz/shop/getFeedbackList',
					data: parameter,
				});

				this.imageRoot = response.IMAGE_SERVER_HOST;

				if (response) {
					const getFeedbackList = response.getFeedbackList;
					const getFeedbackScoreList = response.getFeedbackScoreList;
					const getFeedBaseInfo = response.getFeedBaseInfo;
					const getFeedPhotoFour = response.getFeedPhotoFour;

					this.goodItemFeebackList = getFeedbackList;
					this.goodItemFeebackScoreList = getFeedbackScoreList;
					this.goodItemFeedBaseInfo = getFeedBaseInfo;
					this.goodFeedPhotoFour = getFeedPhotoFour;
					this.paginations.goodItemFeedback.current = 1;

					if (this.goodItemFeebackList.length > 0) {
						this.paginations.goodItemFeedback.total = this.goodItemFeebackList[0].TOTAL_COUNT;
						this.paginations.goodItemFeedback.current = this.goodItemFeebackList[0].CURRENT_PAGE;
					} else {
						this.paginations.goodItemFeedback.total = 0;
						this.paginations.goodItemFeedback.current = 1;
					}

					let bestFeedback = null;

					if (getFeedbackScoreList && getFeedbackScoreList.length) {
						for (let i = 0; i < getFeedbackScoreList.length; i++) {
							for (let j = 0; j < getFeedbackScoreList[i].ATTR_SCORE_LIST.length; j++) {
								if (j == 0) {
									bestFeedback = getFeedbackScoreList[i].ATTR_SCORE_LIST[j];
								} else {
									if (bestFeedback < getFeedbackScoreList[i].ATTR_SCORE_LIST[j].FEEDBACK_DETL_CNT) bestFeedback = getFeedbackScoreList[i].ATTR_SCORE_LIST[j];
								}
							}

							if (bestFeedback) {
								bestFeedback.BEST_CHECK = true;
								bestFeedback = null;
							}
						}
					}

					this.pagination.current = this.paginations.goodItemFeedback.current;
					this.pagination.rowCount = this.paginations.goodItemFeedback.rowCount;
					this.pagination.total = this.paginations.goodItemFeedback.total;
					this.pagination.currentID = 'goodItemFeedback';

					this.$nextTick(function() {
						godvBtnScroll('dvTabmain');
					});
				}

				this.fetches.goodItemFeedback = true;
			} catch (ex) {
				console.error('getFeedBack exception.. ', ex);
				this.fetches.goodItemFeedback = 'error';
			} finally {
				this.processes.goodItemFeebackList = false;
			}
		},

		moveFeedbackPage(payload) {
			var id = payload.id;
			var page = payload.page;
			var beforePage = this.paginations[id].current;

			try {
				this.paginations.goodItemFeedback.current = page;
				this.requests.feedbackItem.VIEW_PAGE = page;
				// 페이징 공통모듈 위한 처리
				this.pagination.current = this.paginations.goodItemFeedback.current;
				this.pagination.rowCount = this.paginations.goodItemFeedback.rowCount;
				this.pagination.total = this.paginations.goodItemFeedback.total;
				this.pagination.currentID = 'goodItemFeedback';
				this.getFeedBack();
			} catch (ex) {
				console.error('moveFeedbackPage exception.. ', ex);
			}
		},

		async chgQna(event, itemId) {
			var target = event.target;

			// 로그인 세션 체크 로직 변경
			const response = await this.$store.dispatch('network/request', {
				method: 'post',
				url: '/biz/ur/sessionCheck',

			});

			const ssFlag = response.SS_FLAG;

			if (ssFlag == 'Y') {
				this.initBoardData();
				this.viewWriteQnaForm();
			} else {
				var confirm = this.confirm;
				confirm.message = '로그인이 필요합니다.<br/>로그인 하시겠습니까?';
				confirm.model = 'login';
				confirm.isOpen = true;
			}
		},

		async requestQnas() {
			try {
				this.paginations.goodItemQnas.IL_ITEM_ID = this.requests.viewItem.IL_ITEM_ID;
				const parameters = this.paginations.goodItemQnas;

				var qnaViewListOn = this.$refs['qnaViewList'];

				if (qnaViewListOn) {
					for (var i = 0; i < qnaViewListOn.length; i++) {
						qnaViewListOn[i].removeAttribute('open');
					}
				}

				const response = await this.$store.dispatch('network/request', {
					method: 'post',
					url: '/biz/cs/qna/getGoodsQnaList',
					data: parameters,
				});

				const rows = response.rows;

				if (rows && rows.length) {
					//this.paginations.goodItemQnas.total = response.total;
					this.goodItemQnas = rows;
					this.goodItems.TOTAL_QNA_COUNT = rows[0].TOTAL_COUNT;

					this.$nextTick(() => {
						this.paginations.goodItemQnas.total = rows[0].TOTAL_COUNT;
						// 페이징 공통모듈 위한 처리
						this.pagination.current = this.paginations.goodItemQnas.current;
						this.pagination.rowCount = this.paginations.goodItemQnas.rowCount;
						this.pagination.total = this.paginations.goodItemQnas.total;
						this.pagination.currentID = 'goodItemQnas';
						godvBtnScroll('dvTabmain');
					});
				} else {
					this.paginations.goodItemQnas.total = 0;
					godvBtnScroll('dvTabmain');
				}

				this.fetches.goodItemQnas = true;
			} catch (ex) {
				console.error('requestQnas exception.. ', ex);
			}
		},

		movePage(payload) {
			var id = payload.id;
			var page = payload.page;
			var beforePage = this.paginations[id].current;

			try {
				this.paginations[id].current = page;
				this.paginations[id].sPage = 1 == page ? 1 : (page - 1) * this.paginations[id].rowCount + 1;
				this.paginations[id].ePage = page * this.paginations[id].rowCount;
				// 페이징 공통모듈 위한 처리
				this.pagination.current = this.paginations[id].current;
				this.pagination.rowCount = this.paginations[id].rowCount;
				this.pagination.total = this.paginations[id].total;
				this.pagination.currentID = 'goodItemQnas';
				this.fetches.goodItemQnas = false;
				this.requestQnas();
			} catch (ex) {
				console.error('movePage exception.. ', ex); // 더보기의 경우 request 오류 시 이전 페이지로 다시 변경이 필요합니다.
			}
		},

		async viewWriteQnaForm() {
			try {
				// 초기값 설정
				this.qna.HIDE_YN = false;
				this.qna.Q_TYPE = 39;
				this.writeQnaModal.viewWriteQnaYn = 'Y';
				this.writeQnaModal.viewButtonSizeYn = 'Y';
			} catch (ex) {
				console.error('viewSameSizeItem exception.. ', ex);
			}
		},

		writeQnaView(viewYn) {
			this.writeQnaModal.viewWriteQnaYn = viewYn;
		},

		isVerifications() {
			var alert = this.alert;
			var qna = this.qna;
			var unfinished = null;

			try {
				// if (!qna.HIDE_YN) {
				// 	unfinished = 'hide';
				// } else
				if (!qna.Q_TITLE) {
					unfinished = 'title';
				} else if (!qna.Q_TYPE || qna.Q_TYPE ==null) {
					unfinished = 'qtype';
				} else if (!qna.QUESTION) {
					unfinished = 'content';
				} else if (qna.QUESTION.length > 200) {
					unfinished = 'maxcontent';
				} else if (qna.SMS_YN && (this.goodItemUser.MOBILE_USE_YN == 'N' || this.goodItemUser.MOBILE_USE_YN == '')) {
					unfinished = 'nomobile';
				} else if (qna.EMAIL_YN && (this.goodItemUser.EMAIL_USE_YN == 'N' || this.goodItemUser.EMAIL_USE_YN == '')) {
					unfinished = 'noemail';
				}

				switch (unfinished) {
					// case 'hide':
					// 	alert.message = '공개여부를 선택해 주세요.';
					// 	alert.isOpen = true;
					// 	return false;
					// 	break;

					case 'title':
						alert.message = '제목을 입력해 주세요.';
						alert.isOpen = true;
						return false;
						break;

					case 'qtype':
						alert.message = '문의 종류를 선택해 주세요.';
						alert.isOpen = true;
						return false;
						break;

					case 'content':
						alert.message = '내용을 입력해 주세요.';
						alert.isOpen = true;
						return false;
						break;

					case 'maxcontent':
						alert.message = '내용을 200자 이하로 입력해 주세요.';
						alert.isOpen = true;
						return false;
						break;

					case 'noemail':
						alert.message = '이메일 정보가 없습니다 MyPage 에서 이메일 등록후 이메일 체크하시기 바랍니다.';
						alert.isOpen = true;
						return false;
						break;

					case 'nomobile':
						alert.message = 'HP 번호 정보가 없습니다 MyPage 에서 HP 번호 등록후 SMS 체크하시기 바랍니다.';
						alert.isOpen = true;
						return false;
						break;

					default:
						return true;
						break;
				}
			} catch (ex) {
				console.error('isVerifications exception... ', ex);
				return false;
			}
		},

		async requestSave() {
			const alert = this.alert;
			this.processes.save = true;
			this.qna.IL_ITEM_ID = this.goodItems.IL_ITEM_ID;
			this.qna.POST_ACTION = 'I';

			try {
				//const changeEnter = { QUESTION: this.qna.QUESTION.replace(/(\n|\r\n)/g, '&lt;br/&gt;'), SMS_YN: (this.qna.SMS_YN) ? 'Y' : 'N', EMAIL_YN: (this.qna.EMAIL_YN) ? 'Y' : 'N' };

				const changeEnter = {
					SMS_YN: this.qna.SMS_YN ? 'Y' : 'N',
					EMAIL_YN: this.qna.EMAIL_YN ? 'Y' : 'N',
				    HIDE_YN: (this.qna.HIDE_YN) ? 'Y' : 'N'
				};

				const parameters = Object.assign({}, this.qna, changeEnter);
				const response = await this.$store.dispatch('network/request', {
					method: 'post',
					url: '/biz/cs/qna/putGoodsQna',
					data: parameters,
				});

				if ('000000000' == response.RETURN_CODE) {
					//alert.model.isBack = true;
					alert.isBackgroundClose = false;
					alert.message = '등록 되었습니다.';
					this.initBoardData();
					this.writeQnaView('N');
					this.requestQnas();
				} else {
					alert.message = '오류가 발생하였습니다.';
				}

				alert.isOpen = true;
			} catch (ex) {
				console.error('requestSave exception...', ex);
				alert.message = ex.message || '오류가 발생하였습니다.';
				alert.isOpen = true;
			} finally {
				this.processes.save = false;
			}
		},

		qnaSave(e) {
			if (this.qna.CS_QNA_ID == '') {
				if (this.isVerifications()) this.requestSave();
			} else {
				if (this.isVerifications()) {
					//this.editQnaPost(this.qna.CS_QNA_ID, 'M');
				}
			}
		},

		searchPhotoFeedBack() {
			if (this.requests.feedbackItem.PHOTO_YN) this.requests.feedbackItem.PHOTO_ONLY = 1;
			else this.requests.feedbackItem.PHOTO_ONLY = 0;

			this.requests.feedbackItem.VIEW_PAGE = 1;
			this.getFeedBack();
		},

		searchFeedBackSort(idx) {
			this.sortOption = idx;
			this.requests.feedbackItem.VIEW_PAGE = 1;
			this.requests.feedbackItem.SORT_GUBUN = idx;
			this.getFeedBack();
		},

		async viewPopFeedbackList(viewYn, paramFbFeedBackId, paramFbItemId, paramRowNum, photoBestReviewYn) {
			this.photoModal.viewPhotoViewYn = viewYn;
			scrollSet(viewYn);

			if(photoBestReviewYn){
				if(photoBestReviewYn == 'Y'){
					this.requests.feedbackItem.SORT_GUBUN = 1;
				}else {
					this.requests.feedbackItem.SORT_GUBUN = this.sortOption;
				}
			}

			if (viewYn == 'Y') {
				this.requests.feedbackPopItem.IL_ITEM_ID = paramFbItemId;
				this.requests.feedbackPopItem.FB_FEEDBACK_ID = paramFbFeedBackId;

				this.requests.feedbackPopItem.IL_ITEM_ID_GRP = [];
				this.requests.feedbackPopItem.IL_ITEM_ID_GRP = this.requests.feedbackItem.IL_ITEM_ID_GRP;

				this.requests.feedbackPopItem.SORT_GUBUN = this.requests.feedbackItem.SORT_GUBUN;

				const parameters = this.requests.feedbackPopItem;
				const response = await this.$store.dispatch('network/request', {
					method: 'post',
					url: '/biz/shop/getFeedbackPopPhotoList',
					data: parameters,
				});

				const getFeebackPopList = response.getFeebackPopList;
				const getFeebackInfo = response.getFeebackInfo;

				this.goodItemFeebackPopList = getFeebackPopList;
				this.goodItemFeebackPopInfo = getFeebackInfo;

				if (this.goodItemFeebackPopList && this.goodItemFeebackPopList.length) {
					this.photoModal.photoTotalCnt = this.goodItemFeebackPopList[0].TOTAL;
					this.photoModal.photoCurrentCnt = this.goodItemFeebackPopList[0].RN;
				}

				this.viewFeedBackCntInsert(paramFbFeedBackId, paramFbItemId);

				//클릭한 리뷰 위치값으로 이동
				this.$nextTick(function () {
					var itemArrayTop = [];
					var reviewItems = document.querySelectorAll('.review__item');

					this.feedbackPhoto();

					reviewItems.forEach(function(item, index) {
						var className = 'review__item__' + index;
						var element = document.querySelector('.' + className);
						var offsetTop = element.offsetTop;
						itemArrayTop[index] = offsetTop - 100;

						//console.log(itemArrayTop[index]);
				});
					itemArrayTop[0] = 0;

					//console.log("paramRowNum::::::::::::", paramRowNum, itemArrayTop[0])

					//document.querySelector('.review .pdModal__inner').scrollTop = itemArrayTop[index];
					document.querySelector('.fb__photoReview .modalBest__container').scrollTop = itemArrayTop[paramRowNum - 1];

					//스크롤에 따른 포토리뷰 넘버링
					function handleScroll() {
						var scrollTop = document.querySelector('.fb__photoReview .modalBest__container').scrollTop;
						var photoCurrentCnt = 0;

						for (var i = 0; i < itemArrayTop.length; i++) {
							if (scrollTop >= itemArrayTop[itemArrayTop.length - 1]) {
								photoCurrentCnt = itemArrayTop.length;
								break;
							}
							if (scrollTop >= itemArrayTop[i] && scrollTop < itemArrayTop[i + 1]) {
								photoCurrentCnt = i + 1;
								break;
							}
						}
						goodsView.photoModal.photoCurrentCnt = photoCurrentCnt;
					}
					//console.log("goodsView.photoModal.photoCurrentCnt:" + goodsView.photoModal.photoCurrentCnt);

					document.querySelector('.fb__photoReview .modalBest__container').addEventListener('scroll', handleScroll);
				});
			}
		},

		feedbackPhoto() {
			//this.$nextTick( ()=>{} );
			// if(this.goodItemFeebackPopInfo.acctList.length > 1){
			if( this.photoSwiper != null){
				//console.log("2:", this.photoSwiper);
				//this.photoSwiper.destroy();
				this.photoSwiper = null;

				//console.log("1:", this.photoSwiper);
			}

			//console.log("this.goodItemFeebackPopInfo.acctList.length", this.goodItemFeebackPopInfo.acctList.length);
			if(this.goodItemFeebackPopInfo.acctList.length > 1){
				this.photoSwiper = new Swiper(this.$refs['reviewPhoto'], {
					slidesPerView: 'auto',
					centeredSlides: false,
					loop: false,
					navigation: {
						nextEl: this.$refs['photo__next'],
						prevEl: this.$refs['photo__prev'],
					},
				});
			}
			if (this.goodItemFeebackPopList.length > 6) {
				new Swiper(this.$refs['photoList'], {
					slidesPerView: 'auto',
					centeredSlides: false,
					loop: false,
					navigation: {
						nextEl: this.$refs['pager__next'],
						prevEl: this.$refs['pager__prev'],
					},
				});
			}
		},

		viewPhotoSelect(paramFbFeedBackId, paramFbItemId) {
			// <div class="photo-pager" v-if="false"> 기능 미구현으로 사용하지 않는것으로 보임
			// 추후에 사용하게 될 시 구매후기그룹 반영하여 IL_ITEM_ID param 수정해줘야 함  (paramFbItemId)
			this.viewPhotoSelectPost(paramFbFeedBackId, paramFbItemId);
		},

		async viewPhotoSelectPost(paramFbFeedBackId, paramFbItemId) {
			//this.requests.feedbackPopItem.IL_ITEM_ID = this.goodItems.IL_ITEM_ID;
			this.requests.feedbackPopItem.FB_FEEDBACK_ID = paramFbFeedBackId;

			const parameters = this.requests.feedbackPopItem;
			const response = await this.$store.dispatch('network/request', {
				method: 'post',
				url: '/biz/shop/getFeedbackPopPhotoInfo',
				data: parameters,
			});

			const getFeebackInfo = response.getFeebackInfo;

			this.goodItemFeebackPopInfo = getFeebackInfo;
			this.viewFeedBackCntInsert(paramFbFeedBackId, paramFbItemId);	// 추후에 사용하게 될 시 구매후기그룹 반영하여 IL_ITEM_ID param 수정해줘야 함
		},

		async viewPopFeedbackOnlyPhotoList() {
			this.requests.feedbackPopItem.IL_ITEM_ID = this.goodItems.IL_ITEM_ID;

			if (this.productList.data.length > 0) {
				// 구매후기그룹 상품이 있을경우
				this.requests.feedbackPopItem.IL_ITEM_ID_GRP = [];
				if (this.productList.selected.target == 'All') {
					// 구매후기그룹상품이고, '전체상품'으로 선택되어있을경우 IL_ITEM_ID_GRP에 상품리스트 셋팅
					for (let i = 1; i < this.productList.data.length; i++) {
						this.requests.feedbackPopItem.IL_ITEM_ID_GRP.push(this.productList.data[i].target);
					}
				} else {
					// 구매후기그룹 내 개별상품 선택되어 있을 경우
					this.requests.feedbackPopItem.IL_ITEM_ID_GRP.push(this.productList.selected.target);
				}
			}
			this.requests.feedbackPopItem.SORT_GUBUN = this.requests.feedbackItem.SORT_GUBUN;

			const parameters = this.requests.feedbackPopItem;
			const response = await this.$store.dispatch('network/request', {
				method: 'post',
				url: '/biz/shop/getFeedbackPopOnlyPhotoList',
				data: parameters,
			});

			const getFeebackPopOnlyList = response.getFeebackPopOnlyList;
			this.goodItemFeebackPopOnlyList = getFeebackPopOnlyList;
		},

		viewDetailPhotoPop(paramFbFeedBackId, paramFbItemId, paramRowNum) {
			this.photoModal.viewPhotoOnlyViewYn = 'N';
			this.viewPopFeedbackList('Y', paramFbFeedBackId, paramFbItemId, paramRowNum);
		},

		async getItemCouponInfo() {
			//보유쿠폰가져오기
			this.requests.couponItem.IL_ITEM_ID = this.goodItems.IL_ITEM_ID;
			this.requests.couponItem.PAID_PRICE = this.viewPriceInfo.viewMarketPrice;

			if (this.goodItemUser.UR_USER_ID != '') this.requests.couponItem.UR_USER_ID = this.goodItemUser.UR_USER_ID;
			else this.requests.couponItem.UR_USER_ID = '';

			const parameters = this.requests.couponItem;
			const response = await this.$store.dispatch('network/request', {
				method: 'post',
				url: '/biz/shop/getItemCouponList',
				data: parameters,
			});

			this.goodItemCouponList = [];
			this.goodItemViewDcInfo = [];
			const getItemCouponList = response.getItemCouponList;
			this.goodItemCouponList = getItemCouponList;

			var maxCpDcPrice = 0;
			var maxCpDcIdx = -1;
			var rowMarketPrice = this.viewPriceInfo.rowPriceIdx;

			if (this.goodItemCouponList && this.goodItemCouponList.length > 0) {
				for (let i = 0; i < this.goodItemCouponList.length; i++) {
					if (this.goodItemCouponList[i].couponPrice != null) {
						if (maxCpDcPrice < this.goodItemCouponList[i].couponPrice.DC_PRICE) {
							maxCpDcPrice = this.goodItemCouponList[i].couponPrice.DC_PRICE;
							maxCpDcIdx = i;
						}
					}
				}

				var empDcPrice = 0;

				if (this.goodItemUser.EMP_YN == 'Y' && this.goodItems.ACTIVE_TYPE == '3' && this.goodItems.EMP_ADD_DC_RATE > 0) {
					var orgSalePrice = this.goodItemOptions[this.viewPriceInfo.rowPriceIdx].SALE_PRICE;
					var marketPrice = this.goodItemOptions[this.viewPriceInfo.rowPriceIdx].MARKET_PRICE;
					var empAddDcRate = this.goodItems.EMP_ADD_DC_RATE;
					var empDcPrice = (parseInt(marketPrice) - parseInt(maxCpDcPrice)) / parseInt(empAddDcRate); //임직원할인차감가격

					if (parseInt(marketPrice) - parseInt(empDcPrice) - parseInt(maxCpDcPrice) <= 0) empDcPrice = 0;
				}

				var noCuponDcPrice = 0;

				if (this.goodItemDcInfo && this.goodItemDcInfo.length > 0) {
					for (let i = 0; i < this.goodItemDcInfo.length; i++) {
						noCuponDcPrice = noCuponDcPrice + this.goodItemDcInfo[i].DC_VALUE;
					}
				}

				if (parseInt(empDcPrice) + parseInt(maxCpDcPrice) > parseInt(noCuponDcPrice)) {
					var cpName = this.goodItemCouponList[maxCpDcIdx].couponPrice.CP_NAME;

					this.goodItemViewDcInfo.push({
						DC_KEY: '쿠폰할인',
						DC_VALUE: '0',
						DC_TITLE: '0',
					});

					this.goodItemViewDcInfo.push({
						DC_KEY: cpName,
						DC_VALUE: maxCpDcPrice,
						DC_TITLE: '1',
					});

					if (empDcPrice > 0) {
						this.goodItemViewDcInfo.push({
							DC_KEY: '임직원할인',
							DC_VALUE: empDcPrice,
							DC_TITLE: '2',
						});
					}

					this.maxDcModal.maxDcValue = parseInt(maxCpDcPrice) + parseInt(empDcPrice);
					this.maxDcModal.viewMaxDcButtonViewYn = 'Y';
				} else {
					var noCpMaxDcValue = 0;

					if (this.goodItemDcInfo && this.goodItemDcInfo.length > 0) {
						for (let i = 0; i < this.goodItemDcInfo.length; i++) {
							this.goodItemViewDcInfo.push({
								DC_KEY: this.goodItemDcInfo[i].DC_KEY,
								DC_VALUE: this.goodItemDcInfo[i].DC_VALUE,
								DC_TITLE: '2',
							});

							noCpMaxDcValue = noCpMaxDcValue + this.goodItemDcInfo[i].DC_VALUE;
						}
					}
					this.maxDcModal.maxDcValue = parseInt(noCpMaxDcValue);
					this.maxDcModal.viewMaxDcButtonViewYn = 'N';
				}
			} else {
				var noCpMaxDcValue = 0;

				if (this.goodItemDcInfo && this.goodItemDcInfo.length > 0) {
					for (let i = 0; i < this.goodItemDcInfo.length; i++) {
						this.goodItemViewDcInfo.push({
							DC_KEY: this.goodItemDcInfo[i].DC_KEY,
							DC_VALUE: this.goodItemDcInfo[i].DC_VALUE,
							DC_TITLE: '2',
						});

						noCpMaxDcValue = noCpMaxDcValue + this.goodItemDcInfo[i].DC_VALUE;
					}
				}

				this.maxDcModal.maxDcValue = parseInt(noCpMaxDcValue);
				this.maxDcModal.viewMaxDcButtonViewYn = 'N';
			}
		},

		viewMaxDcPrice(viewYn) {
			if (this.goodItemUser.UR_USER_ID != '') {
				this.maxDcModal.viewMaxDcViewYn = viewYn;
				//this.getItemCouponInfo();
			} else {
				const confirm = this.confirm;
				confirm.message = '로그인이 필요합니다.<br/>로그인 하시겠습니까?';
				confirm.model = 'login';
				confirm.isOpen = true;
			}
		},

		maxdcChangeValue(idx, dcValue) {
			this.maxDcModal.radio_value = idx;
			this.maxDcModal.maxDcValue = dcValue;
		},

		cardHTViewYn(viewYn) {
			this.cardBenefitModal.viewcardBenefitModalYn = viewYn;

			if (viewYn == 'Y') {
				this.cardBenefit();
			} else {
				this.cardInfo.cardTab = 1;
				this.cardInfo.cardDate = null;
				this.cardInfo.cardList = null;
			}
		},

		//3D Viewer
		vr3DViewerYn(domain,item) {
			var vr3DviewPopUrl = domain + 'view?productCode=' + item;
			//this.vr3DView.viewerModalYn = viewYn;
			window.open(vr3DviewPopUrl, '3DViewer', 'width=1400, height=800, top=130, left=200, toolbar=0, scrollbars=0, location=0');
		},

		async cardBenefit() {
			this.processes.cardBenefit = true;

			try {
				const type = this.cardInfo.cardTab;

				const response = await this.$store.dispatch('network/request', {
					method: 'post',
					url: '/shop/cardEvent/getCardEvent',
					data: {
						SUB_TYPE: type,
						USER_TYPE: 'front',
					},
				});

				const rows = response.rows;
				const cardList = response.detail;

				if (rows) {
					rows.EVENT_START_DT = rows.EVENT_START_DT.split(' ')[0];
					rows.EVENT_END_DT = rows.EVENT_END_DT.split(' ')[0];
					this.cardInfo.cardDate = rows;
				}
				if (cardList && cardList.length) this.cardInfo.cardList = cardList;

				this.processes.cardBenefit = false;
			} catch (ex) {
				console.error(ex);
			}
		},

		// MD's Review
		async mdReview() {
			this.processes.mdReview = true;
			// admin 미리보기
			const queryString = this.getQueryString();
			var mdReviewPreivewYn = queryString.get('MD_REVIEW_PREVIEW');
			var ilItemMdReviewId = queryString.get('IL_ITEM_MD_REVIEW_ID');
			if(mdReviewPreivewYn!=null&&ilItemMdReviewId!=null){
				this.requests.viewItem.MD_REVIEW_PREVIEW = mdReviewPreivewYn;
				this.requests.viewItem.IL_ITEM_MD_REVIEW_ID = ilItemMdReviewId;
			}

			const parameter = this.requests.viewItem;
			try {
				const response = await this.$store.dispatch('network/request', {
					method: 'post',
					url: '/shop/mdReview/getMdReview',
					data: parameter,
				});

				const rows = response.rows;
				const tagList = response.tagList;
				if (rows) {
					this.mdReviewInfo = rows;
				}

				if(tagList) {
					this.mdReviewTagList = tagList;
				}
				this.processes.mdReview = false;
			} catch (ex) {
				console.error(ex);
			}
		},

		// 상품상세 배너
		async goodsViewBanner() {
			this.processes.goodsViewBanner = true;
			const queryString = this.getQueryString();
			this.requests.viewItem.IL_ITEM_ID = queryString.get('itemId');
			try {
				const response = await this.$store.dispatch('network/request', {
					method: 'post',
					url: '/shop/mdReview/getGoodsViewBanner',
					data: {
						IL_ITEM_ID: this.requests.viewItem.IL_ITEM_ID
					},
				});

				const rows = response.rows;
				if (rows) {
					this.goodsViewBannerList = rows;
				}

				this.processes.goodsViewBanner = false;
			} catch (ex) {
				console.error(ex);
			}
		},

		/**부분 무이자 할인 혜택 조회**/
		async cardBenefitAb() {
			this.processes.cardBenefitAb = true;

			try {
				var response = await this.$store.dispatch('network/request', {
					method: 'post',
					url: '/shop/cardEvent/getCardEvent',
					data: {
						SUB_TYPE: '4',
						USER_TYPE: 'front',
					},
				});

				var rows = response.rows;
				var cardListAb = response.detail;

				if (rows) {
					rows.EVENT_START_DT = rows.EVENT_START_DT.split(' ')[0];
					rows.EVENT_END_DT = rows.EVENT_END_DT.split(' ')[0];
					this.cardInfo.cardDate = rows;
				}
				if (cardListAb && cardListAb.length) this.cardInfo.cardListAb = cardListAb;

				this.processes.cardBenefitAb = false;
			} catch (ex) {
				console.error(ex);
			}
		},

		/**결제 혜택 할인(즉시할인) 조회**/
		async cardBenefitAsap() {

			this.processes.cardBenefitAsap = true;

			try {
				var response = await this.$store.dispatch('network/request', {
					method: 'post',
					url: '/shop/cardEvent/getCardEvent',
					data: {
						SUB_TYPE: '3',
						USER_TYPE: 'front',
					},
				});

				var cardListAsap = response.detail;

				if (cardListAsap && cardListAsap.length) this.cardInfo.cardListAsap = cardListAsap;

				// 중복된 값을 그룹화하고 각 그룹 내에서 가장 큰 sale_amt 선택
				var groupedListAsap = cardListAsap.reduce(function (acc, current) {
				if (!acc[current.EVENT_CARD_NM] || acc[current.EVENT_CARD_NM].EVENT_SALE_AMT < current.EVENT_SALE_AMT) {
	  				 acc[current.EVENT_CARD_NM] = current;
					}
					return acc;
  				}, {});

				// groupedRows 객체에 각 그룹 내에서 가장 큰 값이 저장됨
				//console.log(Object.values(groupedListAsap)); // 결과 출력

				this.cardInfo.cardListAsap = groupedListAsap;

				this.processes.cardListAsap = false;
			} catch (ex) {
				console.error(ex);
			}
		},

		viewSizeListViewYn() {
			if (this.sameSizeModal.viewSizeListView == 0) this.sameSizeModal.viewSizeListView = 1;
			else this.sameSizeModal.viewSizeListView = 0;
		},

		soldItemOptions(idx) {
			this.alert.message = '품절 또는 일시품절 상품은 선택할 수 없습니다.';
			this.alert.isOpen = true;
		},

		checkWishItemList(itemId) {
			if (this.wishItems == null || this.wishItems.length == 0) return false;
			else return this.wishItems.indexOf(parseInt(itemId)) < 0 ? false : true;
		},
		async viewExhibitStore() {
			var alert = this.alert;

			try {
				this.requests.SAP_IF.MATNR = this.goodItemOptions[0].IL_GOODS_CODE;
				// TODO - SAP I/F test 값 고정 - 추후 반드시 삭제 할 것
				//this.requests.SAP_IF.MATNR = "5200017";
				const parameters = this.requests.SAP_IF;
				const response = await this.$store.dispatch('network/request', {
					method: 'post',
					url: '/sap/sd023/stock',
					data: parameters,
				});

				const rows = response.row;

				this.requests.SAP_IF.STORECODE = [];

				if (rows.ZTIF_SD023_2) {
					if (rows.ZTIF_SD023_2.length) {
						for (let i = 0; i < rows.ZTIF_SD023_2.length; i++) {
							this.requests.SAP_IF.STORECODE.push(rows.ZTIF_SD023_2[i].StoreCode);
						}
					} else {
						this.requests.SAP_IF.STORECODE.push(rows.ZTIF_SD023_2.StoreCode);
					}

					this.$nextTick(function() {
						if ('geolocation' in navigator) {
							navigator.geolocation.getCurrentPosition(
								(pos) => {
									this.gettingLocation = true;
									this.location = pos;
									//if(this.map==null){
									this.callKakaoMap();
									//}else{
									//this.goMapCenter('0');
									//}
								},
								(err) => {
									this.gettingLocation = false;
								}
							);
						} else {
							this.gettingLocation = false;
						}

						if (!this.gettingLocation) {
							this.location.coords.latitude = 37.555197;
							this.location.coords.longitude = 126.970734;
							this.callKakaoMap();
						}

						this.exhibitStoreModal.viewExhibitStoreYn = 'Y';
						this.exhibitStoreModal.viewButtonSizeYn = 'Y';
					});
				} else {
					alert.message = '재고를 보유한 점포가 없습니다.';
					alert.isOpen = true;
				}
			} catch (ex) {
				console.error('viewExhibitStore exception.. ', ex);
			}
		},

		exhibitStoreView(viewYn) {
			this.exhibitStoreModal.viewExhibitStoreYn = viewYn;
			this.kakaoMapMarkerListClear();
			this.kakaoMapOverLayListClear();
		},

		displayMarker(map, locPosition, message, idxCenter) {
			var marker = new kakao.maps.Marker({
				map: map,
				position: locPosition,
			});

			var infowindow = new kakao.maps.InfoWindow({
				content: message,
				removable: false,
			});

			infowindow.open(map, marker);

			if (idxCenter) {
				map.setCenter(locPosition);
			}
		},

		kakaoMapMarkerListClear() {
			for (let i = 0; i < this.kakaoMapMarkerList.length; i++) {
				this.kakaoMapMarkerList[i].setMap(null);
			}
		},

		kakaoMapOverLayListClear() {
			for (let i = 0; i < this.kakaoMapOverLayList.length; i++) {
				this.kakaoMapOverLayList[i].setMap(null);
			}
		},

		async callKakaoMap() {
			const parameters = this.requests.SAP_IF;
			const response = await this.$store.dispatch('network/request', {
				method: 'post',
				url: '/biz/shop/getInventoryStoreList',
				data: parameters,
			});

			const rows = response.row.LIST;
			this.inventoryStoreList = rows;

			this.$nextTick(function() {
				this.kakaoMapMarker(this.inventoryStoreList);
			});
		},

		kakaoMapMarker() {
			const _this = this;
			this.kakaoMapMarkerListClear();
			this.kakaoMapOverLayListClear();
			this.kakaoMapMarkerList = [];
			this.kakaoMapOverLayList = [];

			var mapContainer = this.$refs['map'];
			var mapOption = {
				center: new kakao.maps.LatLng(this.location.coords.latitude, this.location.coords.longitude),
				level: 3,
			};

			if (this.map == null) {
				this.map = new kakao.maps.Map(mapContainer, mapOption);
			}

			if (this.inventoryStoreList && this.inventoryStoreList.length > 0) {
				for (let i = 0; i < this.inventoryStoreList.length; i++) {
					this.inventoryStoreList[i].distance = distance(this.location.coords.latitude, this.location.coords.longitude, this.inventoryStoreList[i].LATITUDE, this.inventoryStoreList[i].LONGITUDE, 'K');
					this.inventoryStoreList[i].latlng = new kakao.maps.LatLng(this.inventoryStoreList[i].LATITUDE, this.inventoryStoreList[i].LONGITUDE);
				}

				var sortField = 'distance';

				this.inventoryStoreList.sort(function(a, b) {
					return a[sortField] - b[sortField];
				});

				this.fetches.callKakaoMap = true;
				this.inventoryStoreSelected = this.inventoryStoreList[0].ID;

				const imageSize = new kakao.maps.Size(28, 40);
				const images = ['/pc/assets/images/common/icon-map.png', '/pc/assets/images/common/icon-map_all.png', '/pc/assets/images/common/icon-map_all.png', '/pc/assets/images/common/icon-map_all.png'];

				for (let i = 0; i < this.inventoryStoreList.length; i++) {
					var markerImage = new kakao.maps.MarkerImage(images[this.inventoryStoreList[i].CLASS_M], imageSize);

					const marker = new kakao.maps.Marker({
						map: this.map,
						position: this.inventoryStoreList[i].latlng,
						title: this.inventoryStoreList[i].SHOP_NAME,
						image: markerImage,
					});

					this.kakaoMapMarkerList.push(marker);

					var content = '<div class="mapBox">';
					content += '<div class="mapBox__inner">';
					content += '<a href="/lineup/minishop?IL_BRAND_ID="' + this.inventoryStoreList[i].IL_BRAND_ID + '>';
					content += this.inventoryStoreList[i].SHOP_NAME + '<img src="/mobile/assets/images/common/ico_map_arrow.png" alt="">';
					content += '</a>';
					content += '</div>';
					content += '</div>';

					const overlay = new kakao.maps.CustomOverlay({
						content: content,
						map: this.map,
						position: marker.getPosition(),
					});

					overlay.setVisible(false);
					this.kakaoMapOverLayList.push(overlay);

					kakao.maps.event.addListener(marker, 'click', function() {
						if (_this.selectedMarker != null && _this.selectedMarker != overlay) {
							_this.selectedMarker.setVisible(false);
						}

						_this.selectedMarker = overlay;

						if (overlay.getVisible()) {
							overlay.setVisible(false);
						} else {
							overlay.setVisible(true);
						}
					});
				}

				if (this.gettingLocation) {
					var lat = this.location.coords.latitude,
						lon = this.location.coords.longitude;
					var locPosition = new kakao.maps.LatLng(lat, lon);

					this.map.setCenter(locPosition);
				} else {
					var locPosition = new kakao.maps.LatLng(this.location.coords.latitude, this.location.coords.longitude);
					this.map.setCenter(locPosition);
				}

				this.changeShop();
			} else {
				this.alert.message = '재고를 보유한 점포가 없습니다.';
				this.alert.isOpen = true;
				this.exhibitStoreModal.viewExhibitStoreYn = 'N';
				this.exhibitStoreModal.viewButtonSizeYn = 'N';
			}
		},

		goMapCenter(id) {
			var moveLatLon;

			if (id == '0') moveLatLon = new kakao.maps.LatLng(this.location.coords.latitude, this.location.coords.longitude);
			else moveLatLon = new kakao.maps.LatLng(this.inventoryStore.LATITUDE, this.inventoryStore.LONGITUDE);

			this.map.setLevel(7);
			this.map.panTo(moveLatLon);
		},

		changeShop() {
			for (let i = 0; i < this.inventoryStoreList.length; i++) {
				if (this.inventoryStoreSelected == this.inventoryStoreList[i].ID) {
					this.inventoryStore = this.inventoryStoreList[i];
				}
			}

			this.goMapCenter(this.inventoryStore.ID);
		},

		openMiniShop() {
			if (this.inventoryStore.IL_BRAND_ID != '') {
				// TODO - DB URL 경로에 따라 수정 필요
				//window.open("https://www.guud.com/" + this.inventoryStore.SHOP_URL);
				location.href = '/lineup/minishop?IL_BRAND_ID=' + this.inventoryStore.IL_BRAND_ID;
			} else {
				this.alert.message = "준비중입니다.";
			  	this.alert.isOpen = true;
			}
		},

		goWishUrl() {
			location.href = '/mypage/wishlist/productList';
		},

		goDisplayUrl(idx) {
			location.href = '/event/goodsEventDetail?DP_DISPLAY_ID=' + this.exhibition[idx].DP_DISPLAY_ID + '&TYPE=3&SUB_TYPE=4';
		},

		goKcCertifiUrl(vType, vContent) {
			if (vType == '1') {
				window.open('http://www.safetykorea.kr/search/searchPop?certNum=' + vContent, '_blank');
			} else if (vType == '2') {
				window.open('http://www.safetykorea.kr/search/searchPop?certNum=' + vContent, '_blank');
			} else if (vType == '3') {
				window.open('https://www.rra.go.kr/ko/license/A_b_popup_keyno.do?key_no=' + vContent, '_blank');
			} else if (vType == '4') {
				window.open('http://ecolife.me.go.kr/ecolife/sntryAid/index', '_blank');
			}
		},

		async viewFeedBackCntInsert(paramFbFeedBackId, paramFbItemId) {
			this.requests.clickFeedBack.IL_ITEM_ID = paramFbItemId;
			this.requests.clickFeedBack.FB_FEEDBACK_ID = paramFbFeedBackId;

			const parameters = this.requests.clickFeedBack;
			const response = this.$store.dispatch('network/request', {
				method: 'post',
				url: '/biz/shop/updateFeedbackViewCnt',
				data: parameters,
			});
		},

		async viewModifyQnaForm(idx) {
			try {
				// 초기값 설정
				this.qna.CS_QNA_ID = idx;

				for (let i = 0; i < this.goodItemQnas.length; i++) {
					if (this.qna.CS_QNA_ID == this.goodItemQnas[i].ID) {
						this.qna.HIDE_YN = this.goodItemQnas[i].HIDE_YN_REAL;
						this.qna.Q_TYPE = this.goodItemQnas[i].Q_TYPE;
						this.qna.Q_TITLE = this.goodItemQnas[i].Q_TITLE;
						this.qna.QUESTION = this.goodItemQnas[i].QUESTION;
						this.qna.SMS_YN = this.goodItemQnas[i].SMS_YN == 'N' ? false : true;
						this.qna.EMAIL_YN = this.goodItemQnas[i].EMAIL_YN == 'N' ? false : true;
					}
				}

				this.writeQnaModal.viewWriteQnaYn = 'Y';
				this.writeQnaModal.viewButtonSizeYn = 'Y';
			} catch (ex) {
				console.error('viewModifyQnaForm exception.. ', ex);
			}
		},

		initBoardData() {
			this.qna.HIDE_YN = false;
			this.qna.Q_TYPE = null;
			this.qna.Q_TITLE = '';
			this.qna.QUESTION = '';
			this.qna.SMS_YN = true;
			this.qna.EMAIL_YN = true;
			this.qna.CS_CATEGORY_ID = '32';
			this.qna.STATUS = '1';
			this.qna.CS_QNA_ID = '';
			this.qna.POST_ACTION = '';
		},

		editQna(idx, act) {
			this.qna.CS_QNA_ID = idx;
			this.qna.POST_ACTION = act;
			var confirm = this.confirm;

			confirm.message = '삭제하시겠습니까?';
			confirm.model = 'qnaDel';
			confirm.isOpen = true;
		},

		goItHome(DP_DISPLAY_ID) {
			location.href = '/ithome/detail?DP_DISPLAY_ID=' + DP_DISPLAY_ID;
		},

		goIthomeTag(tagName) {
			location.href = '/ithome/index?keyword=' + tagName;
		},

		itHomeSlider() {
			var itHomeList = $('.itHome li').length;

			new Swiper(this.$refs['itHome'], {
				slidesPerView: 'auto',
				centeredSlides: false,
				spaceBetween: 20,
				navigation: {
					prevEl: '.itHome__button.prev-btn',
					nextEl: '.itHome__button.next-btn',
				},
			});

			if (itHomeList <= 4) $('.itHome__button').hide();
		},

		aiRecommandSlider(gbn) {
			let aiRecommand = $(".ai_recommand_sec--" + gbn).find(".comm__goods__list > li").length;
			let slider = $(".ai_recommand_sec--" + gbn).find(".aiRecommand__slider");
			if (aiRecommand >= 5) {
				var slidesPerViewCnt = 4;
				var slidesPerGroupCnt = 4;
				if (gbn == "like") {
					slidesPerViewCnt = 6;
					slidesPerGroupCnt = 6;
				}
				new Swiper(slider, {
					slidesPerView: slidesPerViewCnt,
					slidesPerGroup: slidesPerGroupCnt,
					centeredSlides: false,
					spaceBetween: 10,
					pagination: {
						el: '.ai_recommand_sec--' + gbn + ' .ai-swiper-pagination',
						clickable: true,
					},
				});
			}
		},

		morePdSlider() {
			var morePdList = $('.morePd li').length;

			new Swiper(this.$refs['morePd'], {
				navigation: {
					prevEl: '.morePd-nav.prev-btn',
					nextEl: '.morePd-nav.next-btn',
				},
				slidesPerView: 4,
				spaceBetween: 20,
			});

			if (morePdList <= 4)
				$('.morePd .goodsViewComm__slider')
					.next()
					.hide();
		},

		buyPdSlider() {
			var buyPdList = $('.buyPd li').length;

			new Swiper(this.$refs['buyPd'], {
				slidesPerView: 4,
				spaceBetween: 20,
				navigation: {
					prevEl: '.buyPd-nav.prev-btn',
					nextEl: '.buyPd-nav.next-btn',
				},
			});

			if (buyPdList <= 4)
				$('.buyPd .goodsViewComm__slider')
					.next()
					.hide();
		},

		//함께사면 할인상품 슬라이드
		togetherSlider() {
			if (this.togetherItem && this.togetherItem.length > 4) {
				new Swiper(this.$refs['togetherSwiper'], {
					slidesPerView: 4,
					spaceBetween: 20,
					navigation: {
						prevEl: '.together-nav.prev-btn',
						nextEl: '.together-nav.next-btn',
					},
				});
			}
		},

		categoryPdSlider() {
			var categoryPdList = $('.categoryPd li').length;

			new Swiper(this.$refs['categoryPd'], {
				slidesPerView: 4,
				spaceBetween: 20,
				navigation: {
					prevEl: '.categoryPd-nav.prev-btn',
					nextEl: '.categoryPd-nav.next-btn',
				},
			});

			if (categoryPdList <= 4)
				$('.categoryPd .goodsViewComm__slider')
					.next()
					.hide();
		},

		samePdSlider() {
			var samePdList = $('.samePd li').length;

			new Swiper(this.$refs['samePd'], {
				slidesPerView: 4,
				spaceBetween: 20,
				navigation: {
					prevEl: '.samePd-nav.prev-btn',
					nextEl: '.samePd-nav.next-btn',
				},
			});

			if (samePdList <= 4)
				$('.samePd .goodsViewComm__slider')
					.next()
					.hide();
		},

		couponPopClose() {
			// this.notiImgPop = "display: none";
			this.isPopupClose = false;
		},

		closeToday(event, cookieNameValue) {
			this.couponPopClose();
			this.setCookie(cookieNameValue, 'todayCoupon', 1);
		},

		closeNaverToday(event, cookieNameValue) {
			comPopupClose('popupNaverCoupon');
			this.setCookie(cookieNameValue, 'naverCoupon', 1);

		},

		goPopNotiUrl() {
			// if (this.itemDetailNotiBanner.URL != "") {
			// 	if (this.itemDetailNotiBanner.TARGET == "1") location.href=this.itemDetailNotiBanner.URL;
			// 	else window.open(this.itemDetailNotiBanner.URL);
			// }
		},

		goPopBannerUrl(vtarget, vurl) {
			if (vurl != '') {
				if (vtarget == '1') location.href = vurl;
				else window.open(vurl);
			}
		},

		setCookie(name, value, expiredays) {
			const todayDate = new Date();

			todayDate.setDate(todayDate.getDate() + expiredays);
			document.cookie = name + '=' + escape(value) + '; path=/; expires=' + todayDate.toGMTString() + ';';
		},

		getCookie(name) {
			var nameOfCookie = name + '=';
			var x = 0;
			let endOfCookie;

			while (x <= document.cookie.length) {
				var y = x + nameOfCookie.length;

				if (document.cookie.substring(x, y) == nameOfCookie) {
					if ((endOfCookie = document.cookie.indexOf(';', y)) == -1) endOfCookie = document.cookie.length;
					return unescape(document.cookie.substring(y, endOfCookie));
				}

				x = document.cookie.indexOf(' ', x) + 1;

				if (x == 0) break;
			}

			return '';
		},

		closeLoginModal(data, payload) {
			this.addCartId = '';
			data.isOpen = false;
			this.processes.orderItem = false;
		},

		/*
		 * [렌탈/구독 서비스][김재성]렌탈서비스위한 상품상세페이지 이동 추가
		 */
		loginModalsClick($event, target) {
			var joinReurl = '&prdView=/shop/goodsView?itemId=' + this.goodItems.IL_ITEM_ID;
			if(this.requests.viewItem.CHNL_CD != ''){
				joinReurl = '&prdView=/shop/goodsView?itemId=' + this.goodItems.IL_ITEM_ID+"&chnlCd="+this.requests.viewItem.CHNL_CD;
			}

			if (target == 'login') {
				// location.href = '/member/login?reurl=/shop/cart' + joinReurl;
				// 로그인 후 reurl로 상품상세 이동하도록 수정(prdView 사용 X)
				// prdView 파라미터로 인해 상품상세로 온 뒤 뒤로가기 누르면 장바구니로 이동되는 문제 조치
				location.href = '/member/login?reurl=/shop/goodsView?itemId=' + this.goodItems.IL_ITEM_ID + '&chnlCd=' + this.requests.viewItem.CHNL_CD;
				this.addCartId = '';
			} else if (target == 'noMember') {
				location.href = '/shop/infoinput?cartIds=' + this.addCartId;
				this.addCartId = '';
			} else if (target == 'svcOrder') {
				var locationUrl = '/member/login?reurl=/shop/goodsView?itemId=' + this.goodItems.IL_ITEM_ID;
				if(this.requests.viewItem.CHNL_CD != ''){
					locationUrl = '/member/login?reurl=/shop/goodsView?itemId=' + this.goodItems.IL_ITEM_ID+"&chnlCd="+this.requests.viewItem.CHNL_CD;
				}
				location.href = locationUrl;
				this.addCartId = '';
			}
		},

		async previewOpen(e, itemID) {
			try {
				const response = await this.$store.dispatch('network/request', {
					method: 'post',
					url: '/biz/shop/getGoodsView',
					data: {
						IL_ITEM_ID: itemID,
					},
				});

				const rows = response.rows;
				const banner = response.bannerList;

				if (rows) this.previewModal.goodItems = rows;
				if (banner) this.previewModal.goodBannerList = response.bannerList;

				this.previewModal.isOpen = true;
			} catch (ex) {
				console.error(ex);
			}
		},

		previewClose() {
			this.previewModal.isOpen = false;
			this.previewModal.goodItems = null;
			this.previewModal.goodBannerList = null;
		},

		unescapeHtml(str) {
			if (str == null) return '';

			return str
				.replace(/\n/g, '<br>')
				.replace(/&amp;/g, '&')
				.replace(/&lt;/g, '<')
				.replace(/&gt;/g, '>')
				.replace(/&quot;/g, '"')
				.replace(/&#039;/g, "'")
				.replace(/&#39;/g, "'");
		},

		goodAddItemChange() {
			this.totalAddItem.TOTAL_PAID_PRICE = 0;
			this.totalAddItem.TOTAL_DETL_OPTN_QTY = 0;

			for (let i = 0; i < this.goodsAddItemSave.length; i++) {
				this.totalAddItem.TOTAL_PAID_PRICE = parseInt(this.totalAddItem.TOTAL_PAID_PRICE) + parseInt(this.goodsAddItemSave[i].SALE_PRICE) * parseInt(this.goodsAddItemSave[i].QTY);

				if (this.goodsAddItemSave[i].OPTN_DETL_TYPE == 'B' || this.goodsAddItemSave[i].OPTN_DETL_TYPE == 'S') {
					//필수 선택 여부체크를위해
					this.totalAddItem.TOTAL_DETL_OPTN_QTY = parseInt(this.totalAddItem.TOTAL_DETL_OPTN_QTY) + parseInt(this.goodsAddItemSave[i].QTY);
				}
			}
		},

		deleteAddItem(idx) {
			if (idx >= 0 && this.goodsAddItemSave.length > 0) {
				var addOptionCnt = 1;
				var stopIdxYn = 'N';

				for (var i = idx + 1; i < this.goodsAddItemSave.length; i++) {
					if (stopIdxYn == 'N') {
						if (this.goodsAddItemSave[i].OPTN_DETL_TYPE == 'B' || this.goodsAddItemSave[i].OPTN_DETL_TYPE == 'S') {
							stopIdxYn = 'Y';
							break;
						} else {
							addOptionCnt++;
						}
					}
				}

				this.goodsAddItemSave.splice(idx, addOptionCnt);
			}
		},

		plusAddItemQty(idx) {
			if (idx < this.goodsAddItemSave.length) {
				if (this.goodsAddItemSave[idx].QTY >= this.goodsAddItemSave[idx].STOCK) {
					if (this.goodsAddItemSave[idx].STOC >= 1000) {
						this.goodsAddItemSave[idx].QTY = 999;
					} else {
						this.goodsAddItemSave[idx].QTY = this.goodsAddItemSave[idx].STOCK;
					}

					this.alert.message = '재고수량보다 많이 등록할 수 없습니다.';
					this.alert.isOpen = true;
				} else if (this.goodsAddItemSave[idx].QTY >= 1000) {
					this.goodsAddItemSave[idx].QTY = 999;
					this.alert.message = '1,000개 이상 구매할 수 없습니다.';
					this.alert.isOpen = true;
				} else {
					this.goodsAddItemSave[idx].QTY = parseInt(this.goodsAddItemSave[idx].QTY) + 1;
				}
			}
		},

		minusAddItemQty(idx) {
			if (idx < this.goodsAddItemSave.length) {
				if (this.goodsAddItemSave[idx].QTY > 1) {
					this.goodsAddItemSave[idx].QTY = parseInt(this.goodsAddItemSave[idx].QTY) - 1;
				}
			}
		},

		// 재입고 알림 신청
		restockApply(e, index) {
			const alert = this.alert;
			const confirm = this.confirm;
			const item = this.goodItemOptions[index];

			if (this.goodItemUser.UR_USER_ID != '') {
				if (item.INV_ALARM_CNT == 0) {
					this.requestRestockApply(item);
				} else {
					alert.message = '재입고 알림이 이미 신청되었습니다.';
					alert.isOpen = true;
				}
			} else {
				confirm.message = '로그인이 필요합니다.<br/>로그인 하시겠습니까?';
				confirm.model = 'login';
				confirm.isOpen = true;
			}
		},

		async requestRestockApply(item) {
			const alert = this.alert;

			try {
				const response = await this.$store.dispatch('network/request', {
					method: 'post',
					url: '/biz/shop/addStockAlarm',
					data: {
						UR_USER_ID: this.goodItemUser.UR_USER_ID,
						IL_ITEM_ID: item.IL_ITEM_ID,
						IL_ITEM_OPTN_DETL_ID: item.IL_ITEM_OPTN_DETL_ID,
					},
				});

				if (response.RETURN_CODE == '000000000') {
					item.INV_ALARM_CNT = 1;
					alert.message = '재입고 알림이 신청되었습니다.';
					alert.isOpen = true;
				}
			} catch (ex) {
				console.error('requestRestockApply error..', ex);
			}
		},
		getUrlParams: function() {
			var params = {};
			window.location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(str, key, value) {
				params[key] = value;
			});
			return params;
		},
		getUrlCheck: function() {
			let _this = this;
			let oParams = this.getUrlParams();
			if (oParams.itemId == '77806' || oParams.itemId == '77805' || oParams.itemId == '77764') {
				this.$refs.priceNum.style.display = 'none';
			} else {
				this.$refs.priceNum.style.display = 'block';
			}
		},

		async getMiniShopYn() {
			try {
				const parameter = this.requests.viewItem;
				const response = await this.$store.dispatch('network/request', {
					method: 'post',
					url: '/biz/shop/getMiniShopYn',
					data: parameter,
				});

				if (response.miniShopYn) {
					this.miniShopYn = true;
				}
			} catch (ex) {
				console.error('getMiniShopYn exception.. ', ex);
			}
		},

		async getBestReviewList() {
			try {
				const parameter = this.requests.viewItem;

				const response = await this.$store.dispatch('network/request', {
					method: 'post',
					url: '/biz/shop/getBestReviewList',
					data: parameter,
				});

				if (response) {
					let bestReviewList = response.getBestReviewList;

					let reviewCount = 0;
					for (let i = 0; i < bestReviewList.length; i++) {
						let isPhoto = true;
						if (bestReviewList[i].imgSrc.length === 0) {
							// bestReviewList[i].imgSrc[0] = undefined;
							// 베스트 리뷰에 사진이 없는 경우(텍스트리뷰) 상품이미지 노출
							bestReviewList[i].imgSrc[0] = this.goodItems.B_IMG;
							isPhoto = false;
						}
						for (let imgCnt = 0; imgCnt < bestReviewList[i].imgSrc.length; imgCnt++) {
							const el = {};

							el.reviewId = i;
							el.userId = bestReviewList[i].LOGIN_ID;
							el.date = bestReviewList[i].FB_FEEDBACK_DATE;
							el.isPhoto = isPhoto;
							// 베스트 리뷰에 사진이 없는 경우(텍스트리뷰) 상품이미지 노출
							if (isPhoto) {
								el.imgSrc = response.IMAGE_SERVER_HOST + '/FB/review/1/' + bestReviewList[i].imgSrc[imgCnt].REAL_ATTACHED;
							} else {
								el.imgSrc = bestReviewList[i].imgSrc[imgCnt];
							}
							el.desc = bestReviewList[i].COMMENT_CONTENTS;
							el.prdRate = bestReviewList[i].SCORE_1;
							el.drvRate = bestReviewList[i].SCORE_2;

							this.bestReview.list.data[reviewCount] = el;
							reviewCount++;
						}
					}
				}
			} catch (ex) {
				console.error('getBestReviewList exception.. ', ex);
			}

		},

		openBestReviewList() {
			this.bestReview.list.isOpen = true;
		},

		closeBestReviewList() {
			this.bestReview.list.isOpen = false;
		},

		openBestReviewView(index) {
			this.setBestReviewView(index);
			this.bestReview.view.isOpen = true;
		},

		closeBestReviewView() {
			this.bestReview.view.isOpen = false;
		},

		setBestReviewView(index) {
			let reviewList = this.bestReview.list.data;
			let pager = this.bestReview.view.pager;
			let pagerTotal = [];
			let pagerIndex = 0;

			for (let i = 0; i < reviewList.length; i++) {
				let pagerEl = { id: pagerIndex, data: [] };
				let reviewEl = {};

				reviewEl = reviewList[i];
				reviewEl['index'] = i;
				reviewEl['isActive'] = i === index ? true : false;

				if (reviewEl.isActive) {
					this.bestReview.view.data = reviewEl;
				}

				if (reviewList[i].reviewId === reviewList[index].reviewId && reviewList[i].isPhoto) {
					if (!pagerTotal[pagerIndex]) {
						pagerTotal[pagerIndex] = pagerEl;
					}

					pagerTotal[pagerIndex].data.push(reviewEl);

					if (pagerTotal[pagerIndex].data.length === 6) {
						pagerIndex++;
					}
				}
			}

			pager.total = pagerTotal;

			for (let i = 0; i < pager.total.length; i++) {
				if (pager.total[i].data.find((v) => v.isActive === true)) {
					pager.current = pager.total[i];
				}
			}
		},

		bestReviewViewPrev() {
			let index = this.bestReview.view.data.index;

			if (index > 0) {
				this.setBestReviewView(index - 1);
			}
		},

		bestReviewViewNext() {
			let index = this.bestReview.view.data.index;
			let maxIndex = this.bestReview.list.data.length - 1;

			if (index < maxIndex) {
				this.setBestReviewView(index + 1);
			}
		},

		bestReviewViewPagerPrev() {
			let pager = this.bestReview.view.pager;

			if (pager.current.id > 0) {
				for (let i = 0; i < pager.total.length; i++) {
					if (pager.total[i].id === pager.current.id - 1) {
						pager.current = pager.total[i];
					}
				}
			}
		},

		bestReviewViewPagerNext() {
			let pager = this.bestReview.view.pager;
			let maxIndex = pager.total.length - 1;

			if (pager.current.id < maxIndex) {
				for (let i = 0; i < pager.total.length; i++) {
					if (pager.total[i].id === pager.current.id + 1) {
						pager.current = pager.total[i];
					}
				}
			}
		},

		selectProductList(data) {
			//console.log('selectProductList', data);
			this.productList.selected.imgSrc = data.imgSrc;
			this.productList.selected.desc = data.desc;
			this.productList.selected.target = data.target;
			this.productList.isOpen = !this.productList.isOpen;

			this.getFeedBack(data.target);
		},
		/*
		 * [렌탈/구독 서비스][김재성]'장기할부플랜 신청하기' 닫기
		 */
		rentalClose(){
			const confirm = this.confirm;
			confirm.message = '신청을 취소하시겠습니까?';
			confirm.model = 'rental';
			confirm.isOpen = true;
		},
		/*
		 * [렌탈/구독 서비스][김재성]장기할부플랜 신청하기
		 */
		renatalApply(){
			if ($('#user-agree').is(':checked')){
				// 렌탈나우 페이지 호출
				this.isSvcOrder = true;
				this.checkOrderItem();
			}
			else{
				this.alert.message = '개인정보 제3자 정보제공 동의 후 서비스 신청이 가능합니다.';
				this.alert.isOpen = true;
			}
		},
		/*
		 * [렌탈/구독 서비스][김재성][렌탈주문] 클릭시 렌탈상세 변경
		 *  - 비회원 시 렌탈서비스 로그인 컨펌 및 상품상세페이지로 이동
		 *  - 특정옵션상품이 렌탈서비스에서 제외되는 경우, 분납금액으로 확인 및 아래 메시지 노출
		 * 	  '해당 상품은 장기페이플랜 신청이 불가한 상품입니다. 관리자에게 문의해 주시기 바랍니다.'
		 *  - [장기페이플랜 신청하기] 클릭 시 로그인 체크 이전에 재고(품절, 일시품절) 우선 체크로 변경
		 */
		svcOrderProc() {
			if (this.viewPriceInfo.viewStockStatus == 'ALLSTOP') {
				this.alert.message = '품절상품은 신청할 수 없습니다.';
				this.alert.isOpen = true;
			}
			else if (this.viewPriceInfo.viewStockStatus == 'TEMPSTOP') {
				this.alert.message = '일시품절 상품은 신청할 수 없습니다.';
				this.alert.isOpen = true;
			}
			// 회원주문만 가능함에따라 우선 로그인 체크
			else if (this.goodItemUser.UR_USER_ID != '') {
				const selectedQty = parseInt(this.totalSelectItem.TOTAL_DETL_OPTN_QTY);
				const selectedGroup = this.goodItemSelectOptions;

				if (selectedQty > 1) {
					this.alert.message = '장기페이플랜 상품 수량은 1개만 신청 가능합니다.';
					this.alert.isOpen = true;
				}
				else if (selectedGroup.length == 0) {
					this.alert.message = '신청할 상품을 선택해		주시기 바랍니다.';
					this.alert.isOpen = true;
				}
				else if (this.installment.prc1 == 0 || this.installment.prc2 == 0) {
					this.alert.message = '해당 상품은 장기페이플랜 신청이 불가한 상품입니다.<br/>관리자에게 문의해 주시기 바랍니다.';
					this.alert.isOpen = true;
				}
				else {
					// '장기할부플랜신청하기' 클릭 시에 분납기간, 모두렌탈가격정책번호 초기화
					this.installment.term = 12;
					this.installment.prcPlcNo = this.goodItemSelectOptions[0].PRC_PLC_NO1;
					// 렌탈상담신청 팝업(자사) - 분납기간 선택
					this.rentalPopup = true;
				}
			}
			else {
				// 렌탈 서비스 로그인 모달창
				this.modals.svcLoginModal.isOpen = true;
			}
		},
		/*
		 * [렌탈/구독 서비스][김재성]'예상 월 납입금액 선택', 가격정책번호 세팅
		 */
		setPrcPlcNo(term) {
			var that = this;
			var $rentalButt = $("#price_type_rental li");
			$rentalButt.each( function( idx ,obj ){
				if ($(obj).attr("installment-term") == term) {
					$(obj).addClass("on");
					that.installment.term = term;
					that.installment.prcPlcNo = (term == 12) ? that.goodItemSelectOptions[0].PRC_PLC_NO1 :
						that.goodItemSelectOptions[0].PRC_PLC_NO2;
				}
				else {
					$(obj).removeClass("on");
				}

			});
			//console.log(term + '::' + that.installment.term + '::' + that.installment.prcPlcNo);
		},
		//상품 정보 노출 유무
		isShowGoodItemSpecifics(options) {
			let isShow = false;

			// 주요소재
			if(options.IL_SPEC_FIELDS_ID == 10){
				// text 제외 - 상품상세 or 이미지 or 참조 (오픈 후 제외키워드 추가될 수 있음) & 공백 이면 '소재' 영역 비노출
				if(options.VAL != null && options.VAL != '' && options.VAL != '상품상세' && options.VAL != '이미지' && options.VAL != '참조'
					&& options.VAL != '상세페이지 참조' && options.VAL != '상세페이지참조') {
					isShow = true;
				}
			}
			return isShow;
		},
		checkLikeFeedback: function(feedbackId){
			return this.likeFeedbackList.indexOf(feedbackId) < 0 ? false : true ;
		},

		//좋아요 클릭
		chgLikeFeedback: function(divType, list){
			if(this.isSession != "Y") {
				const confirm = this.confirm;
				confirm.message = '로그인이 필요합니다.<br/>로그인 하시겠습니까?';
				confirm.model = 'feedbackLike';
				confirm.isOpen = true;
				return;
			}

			if(this.likeFeedbackList.indexOf(list.FB_FEEDBACK_ID)<0){
				//좋아요
				this.addLikeFeedback(divType, list);
			 }else{
				//좋아요 취소
				this.deleteLikeFeedback(divType, list);
			}

		},

		/*
		* 좋아요
		*/
		addLikeFeedback(divType, list){
			try {
				const response = this.$store.dispatch('network/request', {
					method: 'post',
					url: '/biz/mypage/community/MyFeedbackMgm/addLikeFeedback',
					data: { FB_FEEDBACK_ID: list.FB_FEEDBACK_ID },
				});

				if (response) {
					this.likeFeedbackList.push(list.FB_FEEDBACK_ID);

					list.LIKE_CNT++;

					if('P' == divType){
						for(var i=0; i<this.goodItemFeebackList.length; i++) {
							if(list.FB_FEEDBACK_ID == this.goodItemFeebackList[i].FB_FEEDBACK_ID){
								// 이미지 리뷰리스트 팝업 호출 시 좋아요 카운트 업데이트될 수 있음. 목록 카운트도 업데이트
								this.goodItemFeebackList[i].LIKE_CNT++;
								list.LIKE_CNT = this.goodItemFeebackList[i].LIKE_CNT;
							}
						}
					}
				}
			} catch (ex) {
				console.error('addLikeFeedback failed.. ', ex);
			}
		},

		/*
		* 좋아요 취소
		*/
		deleteLikeFeedback(divType, list){
			try {
				const response = this.$store.dispatch('network/request', {
					method: 'post',
					url: '/biz/mypage/community/MyFeedbackMgm/deleteLikeFeedback',
					data: { FB_FEEDBACK_ID: list.FB_FEEDBACK_ID },
				});

				if (response) {
					this.likeFeedbackList.splice(this.likeFeedbackList.indexOf(list.FB_FEEDBACK_ID),1);

					list.LIKE_CNT--;

					if('P' == divType){
						for(var i=0; i<this.goodItemFeebackList.length; i++) {
							if(list.FB_FEEDBACK_ID == this.goodItemFeebackList[i].FB_FEEDBACK_ID) {
								this.goodItemFeebackList[i].LIKE_CNT--;
								list.LIKE_CNT = this.goodItemFeebackList[i].LIKE_CNT;
							}
						}
					}
				}
			} catch (ex) {
				console.error('deleteLikeFeedback failed.. ', ex);
			}
		},

		/**
		* 좋아요한 피드백 리스트 가져오기
		*/
		async getLikeFeedback() {
			try {
				if(this.isSession != "Y") {
					return;
				}

				const parameters = this.requests.feedbackItem;
				const response = await this.$store.dispatch("network/request", {
					method: "post",
					url: "/biz/mypage/community/MyFeedbackMgm/getLikeFeedbackList",
					data: parameters
				});

				this.likeFeedbackList = [];
				if(response.rows != undefined && response.rows != null) {
					for(var i = 0; i < response.rows.length; i++) {
						 if("L" == response.rows[i].FEED_BACK_TYPE){
							if(this.likeFeedbackList.indexOf(response.rows[i].FB_FEEDBACK_ID)<0){
								this.likeFeedbackList.push(response.rows[i].FB_FEEDBACK_ID);
							}
						 }
					}
				}
			} catch (ex) {
				console.error('getLikeFeedback failed.. ', ex);
			}
		},

		viewOpenGoodInfo() { // 더보기버튼
			this.isInfoVisible = !this.isInfoVisible;
         	this.$refs['goodInfoLimited'].classList.toggle('limited');
			this.$refs['goodInfoOpend'].classList.toggle('fold');
		},

		dlvDateView(viewYn) {
			this.dlvDateModal.viewDlvDateYn = viewYn;
			if (viewYn == 'Y') {
				$('#defaultAddr').text(this.goodItemUser.RECIP_ADDR);
				$('.pika-single').remove();

				dlvdatePicker(this.goodItems.DELIVERY_ALLOW_DATE);
			} else {
				this.$refs['dlvDate'].classList.remove('modalWrap');
				$('#defaultAddr').text('');
			}
		},


		getGroobeeRecommend() {
			//찜상품추천
			var serviceKey_like = isPrd ? "RE3b96d182fbed4b38acc040f511f24045" : "REd1a3ccf3bffb4117aa317feaa42f7e03";
			var grbData_like;
			if(/(guud.com)/ig.test(window.location.href)) {
				grbData_like = groobee.getGroobeeRecommend(serviceKey_like);
			} else{
			    grbData_like = {"campaignKey":"RE8657f9ccac6d41818a5a74ab2e1dfc7d","algorithmCd":"ST05","goodsList":[{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" 우스터 1인 리클라이너_브라운","goodsCd":"155489","goodsImg":"https://imagestg2.guud.com//IL/item/202312/01/2F3909B171C9482287274DC2F0DDBB1F.jpg","lCd":"4014","lNm":"가구/인테리어","mCd":"4018","mNm":"수납용품","bCd":"227","bNm":"까사미아","plan":[],"goodsPrc":1010000,"goodsSalePrc":707000,"regDtm":[2023,11,21,13,54,26,678000000],"modDtm":[2023,12,6,14,46,11,129000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" [단독특가] 브람스 국내제작 전체 원목 침대(SS/Q) 5colors","goodsCd":"43582","goodsImg":"https://imagestg2.guud.com//IL/item/202008/06/B_3D6FED44ED204C388C557ABFCC25A270.jpg","goodsCateNm":"일반침대","goodsCate":"2873","lCd":"2624","lNm":"bedddd","mCd":"2635","mNm":"침대","sCd":"2689","sNm":"슈퍼/싱글침대","dCd":"2873","dNm":"일반침대","bCd":"230","bNm":"웨스트프롬","plan":[],"goodsPrc":698000,"goodsSalePrc":335000,"regDtm":[2023,12,6,13,51,55,476000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" 올루미 유니크 사각 장스탠드","goodsCd":"56350","goodsImg":"https://imagestg2.guud.com//IL/item/202009/15/B_29E0C3AD67B54A7FBA2CED154355B31D.jpg","goodsCateNm":"플로어조명","goodsCate":"2821","lCd":"2633","lNm":"홈인테리어","mCd":"2675","mNm":"조명","sCd":"2821","sNm":"플로어조명","bCd":"607","bNm":"올루미","plan":[],"goodsPrc":81800,"goodsSalePrc":80000,"regDtm":[2023,11,24,10,3,42,81000000],"modDtm":[2023,12,6,12,19,51,256000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" 번드 For casamiashop 우디 화이트 라탄 협탁","goodsCd":"44929","goodsImg":"https://imagestg2.guud.com//IL/item/202206/03/B_4A588974BB994752B7A96CB1E1E33EFB.jpg","goodsCateNm":"협탁","goodsCate":"2699","lCd":"2624","lNm":"bedddd","mCd":"2638","mNm":"서랍장/협탁","sCd":"2699","sNm":"협탁","bCd":"266","bNm":"번드","plan":[],"goodsPrc":160000,"goodsSalePrc":160000,"regDtm":[2023,11,21,12,14,15,73000000],"modDtm":[2023,12,7,12,15,55,622000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" 꾸미까 스텐 키친툴 조리도구 (8type)","goodsCd":"109262","goodsImg":"https://imagestg2.guud.com//IL/item/202108/25/B_F324FAAF9B1E499192EA67CA20DEC71D.jpg","goodsCateNm":" 조리도구기타","goodsCate":"3175","lCd":"2631","lNm":"주방용품","mCd":"3168","mNm":"도마/칼/조리도구","sCd":"3175","sNm":" 조리도구기타","bCd":"3361","bNm":"꾸미까","plan":[],"goodsPrc":3200,"goodsSalePrc":2700,"regDtm":[2023,11,28,14,53,52,369000000],"modDtm":[2023,12,7,14,18,29,28000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" 패키지4) 1차 행사할인 | 2차 패키지딜 [1]","goodsCd":"126637","goodsImg":"https://imagestg2.guud.com//IL/item/202112/06/B_86DF1D60EBD549C28E6B7D8413E04B3C.jpg","goodsCateNm":"러그/카페트","goodsCate":"2856","lCd":"2634","lNm":"패브릭","mCd":"2684","mNm":"러그/매트","sCd":"2856","sNm":"러그/카페트","bCd":"452","bNm":"한일카페트","plan":[],"goodsPrc":90000,"goodsSalePrc":90000,"regDtm":[2023,11,22,12,14,36,495000000],"modDtm":[2023,12,7,11,25,5,564000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" 캄포클래식 3인소파_아이보리","goodsCd":"155493","goodsImg":"https://imagestg2.guud.com//IL/item/202312/01/4DED28DDEDCE47B2BFE13C15AC51C2DE.jpg","goodsCateNm":"그림액자/포스터","goodsCate":"2833","lCd":"2633","lNm":"홈인테리어","mCd":"2679","mNm":"홈데코","sCd":"2833","sNm":"그림액자/포스터","bCd":"227","bNm":"까사미아","plan":[],"goodsPrc":2700000,"goodsSalePrc":1890000,"regDtm":[2023,11,21,11,49,37,857000000],"modDtm":[2023,12,7,14,18,10,449000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" 에디트 드레스룸 디바이더서랍장","goodsCd":"20966","goodsImg":"https://imagestg2.guud.com//IL/item/202105/27/B_C87A2CFCE7AB44FDA5E6ABAD339557B8.jpg","goodsCateNm":"드레스룸","goodsCate":"2494","lCd":"2430","lNm":"까사미아","mCd":"2431","mNm":"베드룸","sCd":"2445","sNm":"옷장/드레스룸","dCd":"2494","dNm":"드레스룸","bCd":"41","bNm":"어니언","plan":[],"goodsPrc":480000,"goodsSalePrc":480000,"regDtm":[2023,12,6,9,13,55,233000000],"modDtm":[2023,12,7,9,14,7,913000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" 패키지1) 1차 없음 | 패키지딜 [1]","goodsCd":"129564","goodsImg":"https://imagestg2.guud.com//IL/item/202201/06/B_7F6CECBA0CCE463BB2E4B70D39406871.jpg","goodsCateNm":"러그/카페트","goodsCate":"2856","lCd":"2634","lNm":"패브릭","mCd":"2684","mNm":"러그/매트","sCd":"2856","sNm":"러그/카페트","bCd":"1383","bNm":"아다마알마","plan":[],"goodsPrc":498000,"goodsSalePrc":498000,"regDtm":[2023,12,7,11,23,40,803000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" e스마트 코어 낮은 벙커침대 H1600 매트포함","goodsCd":"121319","goodsImg":"https://imagestg2.guud.com//IL/item/202111/04/B_8F78E23DCB614BB68F0FFBD1B1B957A8.jpg","lCd":"4050","lNm":"유아동가구","mCd":"4053","mNm":"유아동침대","bCd":"2064","bNm":"e스마트","plan":[],"goodsPrc":1600000,"goodsSalePrc":1146000,"regDtm":[2023,11,21,13,51,30,987000000],"modDtm":[2023,12,7,15,36,10,434000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" 올루미 코니아일랜드 장스탠드 (블랙)","goodsCd":"56097","goodsImg":"https://imagestg2.guud.com//IL/item/202009/15/B_12BDE11B28B74BD7AAFBBEF11CC236AA.jpg","goodsCateNm":"플로어조명","goodsCate":"2821","lCd":"2633","lNm":"홈인테리어","mCd":"2675","mNm":"조명","sCd":"2821","sNm":"플로어조명","bCd":"607","bNm":"올루미","plan":[],"goodsPrc":75300,"goodsSalePrc":75300,"regDtm":[2023,12,7,11,24,40,362000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" 패키지3) 1차 즉시적용쿠폰 | 2차 패키지딜 [1]","goodsCd":"130617","goodsImg":"https://imagestg2.guud.com//IL/item/202207/19/B_B2E902540D0741B1B9701B539ED3CD71.jpg","goodsCateNm":"러그/카페트","goodsCate":"2856","lCd":"2634","lNm":"패브릭","mCd":"2684","mNm":"러그/매트","sCd":"2856","sNm":"러그/카페트","bCd":"3465","bNm":"데이드리머","plan":[],"goodsPrc":211250,"goodsSalePrc":211250,"regDtm":[2023,11,22,16,40,31,718000000],"modDtm":[2023,12,7,11,24,20,514000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" 헤이즈 사이드테이블","goodsCd":"23010","goodsImg":"https://imagestg2.guud.com//IL/item/202112/08/B_30FDFE623B364828886281D3CB44F62A.jpg","goodsCateNm":"사이드테이블","goodsCate":"2489","lCd":"2430","lNm":"까사미아","mCd":"2431","mNm":"베드룸","sCd":"2443","sNm":"사이드테이블","dCd":"2489","dNm":"사이드테이블","bCd":"41","bNm":"어니언","plan":[],"goodsPrc":230000,"goodsSalePrc":230000,"regDtm":[2023,11,23,12,20,20,431000000],"modDtm":[2023,12,7,13,50,41,244000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" 에어코일 베개","goodsCd":"155496","goodsImg":"https://imagestg2.guud.com//IL/item/202312/01/B81ABADD01D542528B30E02363FDF4BA.jpg","goodsCateNm":"그림액자/포스터","goodsCate":"2833","lCd":"2633","lNm":"홈인테리어","mCd":"2679","mNm":"홈데코","sCd":"2833","sNm":"그림액자/포스터","bCd":"227","bNm":"까사미아","plan":[],"goodsPrc":39900,"goodsSalePrc":35900,"regDtm":[2023,11,21,13,49,17,699000000],"modDtm":[2023,12,7,14,30,38,2000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" 패키지2) 1차 임직원 | 2차 패키지딜 [1]","goodsCd":"151033","goodsImg":"https://imagestg2.guud.com//IL/item/202205/04/B_B3FC03BB51FA424896EFA993C7562307.jpg","goodsCateNm":"그림액자/포스터","goodsCate":"2833","lCd":"2633","lNm":"홈인테리어","mCd":"2679","mNm":"홈데코","sCd":"2833","sNm":"그림액자/포스터","bCd":"7061","bNm":"위아트","plan":[],"goodsPrc":38000,"goodsSalePrc":38000,"regDtm":[2023,12,7,11,24,8,823000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" 케이스1) 1차 없음 | 2차 없음","goodsCd":"24793","goodsImg":"https://imagestg2.guud.com//IL/item/202302/17/B_52D3717FF2BF442187BD0D79E8923B1E.jpg","goodsCateNm":"1인 리클라이너","goodsCate":"2504","lCd":"2430","lNm":"까사미아","mCd":"2432","mNm":"리빙룸","sCd":"2448","sNm":"리클라이너 소파","dCd":"2504","dNm":"1인 리클라이너","bCd":"227","bNm":"까사미아","plan":[],"goodsPrc":1010000,"goodsSalePrc":1010000,"regDtm":[2023,11,21,11,59,26,358000000],"modDtm":[2023,12,7,13,50,31,470000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" 노브 거실장_화이트","goodsCd":"35252","goodsImg":"https://imagestg2.guud.com//IL/item/202004/10/B_12E28377A0694B0DA66A5E80EFD3B49A.jpg","goodsCateNm":"TV/거실장","goodsCate":"2505","lCd":"2430","lNm":"까사미아","mCd":"2432","mNm":"리빙룸","sCd":"2449","sNm":"수납장","dCd":"2505","dNm":"TV/거실장","bCd":"41","bNm":"어니언","plan":[],"goodsPrc":200000,"goodsSalePrc":200000,"regDtm":[2023,11,28,14,11,25,499000000],"modDtm":[2023,12,7,13,57,14,676000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" 핏 드레스룸 1단행거장 800_브라운","goodsCd":"21718","goodsImg":"https://imagestg2.guud.com//IL/item/202106/07/B_E769F066EC334CB385C007B9D0B63EF3.jpg","goodsCateNm":"드레스룸","goodsCate":"2494","lCd":"2430","lNm":"까사미아","mCd":"2431","mNm":"베드룸","sCd":"2445","sNm":"옷장/드레스룸","dCd":"2494","dNm":"드레스룸","bCd":"41","bNm":"어니언","plan":[],"goodsPrc":240000,"goodsSalePrc":240000,"regDtm":[2023,12,7,9,14,17,899000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" [딜코드] onion 라임 3단서랍장 (컬러 택1)","goodsCd":"132966","goodsImg":"https://imagestg2.guud.com//IL/item/202201/24/B_24AFD29B1EA442998F5151A4A849B890.jpg","goodsCate":"2906","plan":[],"goodsPrc":340000,"goodsSalePrc":238000,"regDtm":[2023,11,21,13,54,1,135000000],"modDtm":[2023,12,7,11,23,8,737000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" 블룸 욕실슬리퍼 대형_그린","goodsCd":"61073","goodsImg":"https://imagestg2.guud.com//IL/item/202010/29/B_9EE00F7927C24ED38E662B7D304F705B.jpg","goodsCateNm":"기타(생활)","goodsCate":"2601","lCd":"2430","lNm":"까사미아","mCd":"2438","mNm":"수납/생활","sCd":"2474","sNm":"생활용품","dCd":"2601","dNm":"기타(생활)","bCd":"227","bNm":"까사미아","plan":[],"goodsPrc":11900,"goodsSalePrc":11900,"regDtm":[2023,11,21,13,53,38,32000000],"modDtm":[2023,12,7,14,39,41,567000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" 에어코일 매트리스 토퍼 Q","goodsCd":"155495","goodsImg":"https://imagestg2.guud.com//IL/item/202312/01/CF8F00FCD5CF48FB97D52E3416060921.jpg","goodsCateNm":"그림액자/포스터","goodsCate":"2833","lCd":"2633","lNm":"홈인테리어","mCd":"2679","mNm":"홈데코","sCd":"2833","sNm":"그림액자/포스터","bCd":"227","bNm":"까사미아","plan":[],"goodsPrc":319000,"goodsSalePrc":287000,"regDtm":[2023,11,21,13,54,18,143000000],"modDtm":[2023,12,7,13,56,45,280000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" 캄포클래식 4인소파_아이보리","goodsCd":"155491","goodsImg":"https://imagestg2.guud.com//IL/item/202312/01/6FF94C079FC34705B3BF6AB996D583C1.jpg","lCd":"4014","lNm":"가구/인테리어","mCd":"4018","mNm":"수납용품","bCd":"227","bNm":"까사미아","plan":[],"goodsPrc":3740000,"goodsSalePrc":2618000,"regDtm":[2023,11,22,9,24,17,958000000],"modDtm":[2023,12,7,14,43,8,533000000]}],"algorithmTypeCd":"GD"};
			}
			if (grbData_like && grbData_like.goodsList) {
				var gbn = "like";
				this.goPrdDtl(grbData_like, gbn);
			}

			//상단추천
			var serviceKey = isPrd ? "REd15b006189594f8c88a4bfb376da69d0" : "REa7cdf2ddf95b420ea08f9627f1f059ac";
			var grbData;
			if(/(guud.com)/ig.test(window.location.href)) {
				grbData = groobee.getGroobeeRecommend(serviceKey);
			} else{
			    grbData = {"campaignKey":"RE8657f9ccac6d41818a5a74ab2e1dfc7d","algorithmCd":"ST05","goodsList":[{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" 우스터 1인 리클라이너_브라운","goodsCd":"155489","goodsImg":"https://imagestg2.guud.com//IL/item/202312/01/2F3909B171C9482287274DC2F0DDBB1F.jpg","lCd":"4014","lNm":"가구/인테리어","mCd":"4018","mNm":"수납용품","bCd":"227","bNm":"까사미아","plan":[],"goodsPrc":1010000,"goodsSalePrc":707000,"regDtm":[2023,11,21,13,54,26,678000000],"modDtm":[2023,12,6,14,46,11,129000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" [단독특가] 브람스 국내제작 전체 원목 침대(SS/Q) 5colors","goodsCd":"43582","goodsImg":"https://imagestg2.guud.com//IL/item/202008/06/B_3D6FED44ED204C388C557ABFCC25A270.jpg","goodsCateNm":"일반침대","goodsCate":"2873","lCd":"2624","lNm":"bedddd","mCd":"2635","mNm":"침대","sCd":"2689","sNm":"슈퍼/싱글침대","dCd":"2873","dNm":"일반침대","bCd":"230","bNm":"웨스트프롬","plan":[],"goodsPrc":698000,"goodsSalePrc":335000,"regDtm":[2023,12,6,13,51,55,476000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" 올루미 유니크 사각 장스탠드","goodsCd":"56350","goodsImg":"https://imagestg2.guud.com//IL/item/202009/15/B_29E0C3AD67B54A7FBA2CED154355B31D.jpg","goodsCateNm":"플로어조명","goodsCate":"2821","lCd":"2633","lNm":"홈인테리어","mCd":"2675","mNm":"조명","sCd":"2821","sNm":"플로어조명","bCd":"607","bNm":"올루미","plan":[],"goodsPrc":81800,"goodsSalePrc":80000,"regDtm":[2023,11,24,10,3,42,81000000],"modDtm":[2023,12,6,12,19,51,256000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" 번드 For casamiashop 우디 화이트 라탄 협탁","goodsCd":"44929","goodsImg":"https://imagestg2.guud.com//IL/item/202206/03/B_4A588974BB994752B7A96CB1E1E33EFB.jpg","goodsCateNm":"협탁","goodsCate":"2699","lCd":"2624","lNm":"bedddd","mCd":"2638","mNm":"서랍장/협탁","sCd":"2699","sNm":"협탁","bCd":"266","bNm":"번드","plan":[],"goodsPrc":160000,"goodsSalePrc":160000,"regDtm":[2023,11,21,12,14,15,73000000],"modDtm":[2023,12,7,12,15,55,622000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" 꾸미까 스텐 키친툴 조리도구 (8type)","goodsCd":"109262","goodsImg":"https://imagestg2.guud.com//IL/item/202108/25/B_F324FAAF9B1E499192EA67CA20DEC71D.jpg","goodsCateNm":" 조리도구기타","goodsCate":"3175","lCd":"2631","lNm":"주방용품","mCd":"3168","mNm":"도마/칼/조리도구","sCd":"3175","sNm":" 조리도구기타","bCd":"3361","bNm":"꾸미까","plan":[],"goodsPrc":3200,"goodsSalePrc":2700,"regDtm":[2023,11,28,14,53,52,369000000],"modDtm":[2023,12,7,14,18,29,28000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" 패키지4) 1차 행사할인 | 2차 패키지딜 [1]","goodsCd":"126637","goodsImg":"https://imagestg2.guud.com//IL/item/202112/06/B_86DF1D60EBD549C28E6B7D8413E04B3C.jpg","goodsCateNm":"러그/카페트","goodsCate":"2856","lCd":"2634","lNm":"패브릭","mCd":"2684","mNm":"러그/매트","sCd":"2856","sNm":"러그/카페트","bCd":"452","bNm":"한일카페트","plan":[],"goodsPrc":90000,"goodsSalePrc":90000,"regDtm":[2023,11,22,12,14,36,495000000],"modDtm":[2023,12,7,11,25,5,564000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" 캄포클래식 3인소파_아이보리","goodsCd":"155493","goodsImg":"https://imagestg2.guud.com//IL/item/202312/01/4DED28DDEDCE47B2BFE13C15AC51C2DE.jpg","goodsCateNm":"그림액자/포스터","goodsCate":"2833","lCd":"2633","lNm":"홈인테리어","mCd":"2679","mNm":"홈데코","sCd":"2833","sNm":"그림액자/포스터","bCd":"227","bNm":"까사미아","plan":[],"goodsPrc":2700000,"goodsSalePrc":1890000,"regDtm":[2023,11,21,11,49,37,857000000],"modDtm":[2023,12,7,14,18,10,449000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" 에디트 드레스룸 디바이더서랍장","goodsCd":"20966","goodsImg":"https://imagestg2.guud.com//IL/item/202105/27/B_C87A2CFCE7AB44FDA5E6ABAD339557B8.jpg","goodsCateNm":"드레스룸","goodsCate":"2494","lCd":"2430","lNm":"까사미아","mCd":"2431","mNm":"베드룸","sCd":"2445","sNm":"옷장/드레스룸","dCd":"2494","dNm":"드레스룸","bCd":"41","bNm":"어니언","plan":[],"goodsPrc":480000,"goodsSalePrc":480000,"regDtm":[2023,12,6,9,13,55,233000000],"modDtm":[2023,12,7,9,14,7,913000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" 패키지1) 1차 없음 | 패키지딜 [1]","goodsCd":"129564","goodsImg":"https://imagestg2.guud.com//IL/item/202201/06/B_7F6CECBA0CCE463BB2E4B70D39406871.jpg","goodsCateNm":"러그/카페트","goodsCate":"2856","lCd":"2634","lNm":"패브릭","mCd":"2684","mNm":"러그/매트","sCd":"2856","sNm":"러그/카페트","bCd":"1383","bNm":"아다마알마","plan":[],"goodsPrc":498000,"goodsSalePrc":498000,"regDtm":[2023,12,7,11,23,40,803000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" e스마트 코어 낮은 벙커침대 H1600 매트포함","goodsCd":"121319","goodsImg":"https://imagestg2.guud.com//IL/item/202111/04/B_8F78E23DCB614BB68F0FFBD1B1B957A8.jpg","lCd":"4050","lNm":"유아동가구","mCd":"4053","mNm":"유아동침대","bCd":"2064","bNm":"e스마트","plan":[],"goodsPrc":1600000,"goodsSalePrc":1146000,"regDtm":[2023,11,21,13,51,30,987000000],"modDtm":[2023,12,7,15,36,10,434000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" 올루미 코니아일랜드 장스탠드 (블랙)","goodsCd":"56097","goodsImg":"https://imagestg2.guud.com//IL/item/202009/15/B_12BDE11B28B74BD7AAFBBEF11CC236AA.jpg","goodsCateNm":"플로어조명","goodsCate":"2821","lCd":"2633","lNm":"홈인테리어","mCd":"2675","mNm":"조명","sCd":"2821","sNm":"플로어조명","bCd":"607","bNm":"올루미","plan":[],"goodsPrc":75300,"goodsSalePrc":75300,"regDtm":[2023,12,7,11,24,40,362000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" 패키지3) 1차 즉시적용쿠폰 | 2차 패키지딜 [1]","goodsCd":"130617","goodsImg":"https://imagestg2.guud.com//IL/item/202207/19/B_B2E902540D0741B1B9701B539ED3CD71.jpg","goodsCateNm":"러그/카페트","goodsCate":"2856","lCd":"2634","lNm":"패브릭","mCd":"2684","mNm":"러그/매트","sCd":"2856","sNm":"러그/카페트","bCd":"3465","bNm":"데이드리머","plan":[],"goodsPrc":211250,"goodsSalePrc":211250,"regDtm":[2023,11,22,16,40,31,718000000],"modDtm":[2023,12,7,11,24,20,514000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" 헤이즈 사이드테이블","goodsCd":"23010","goodsImg":"https://imagestg2.guud.com//IL/item/202112/08/B_30FDFE623B364828886281D3CB44F62A.jpg","goodsCateNm":"사이드테이블","goodsCate":"2489","lCd":"2430","lNm":"까사미아","mCd":"2431","mNm":"베드룸","sCd":"2443","sNm":"사이드테이블","dCd":"2489","dNm":"사이드테이블","bCd":"41","bNm":"어니언","plan":[],"goodsPrc":230000,"goodsSalePrc":230000,"regDtm":[2023,11,23,12,20,20,431000000],"modDtm":[2023,12,7,13,50,41,244000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" 에어코일 베개","goodsCd":"155496","goodsImg":"https://imagestg2.guud.com//IL/item/202312/01/B81ABADD01D542528B30E02363FDF4BA.jpg","goodsCateNm":"그림액자/포스터","goodsCate":"2833","lCd":"2633","lNm":"홈인테리어","mCd":"2679","mNm":"홈데코","sCd":"2833","sNm":"그림액자/포스터","bCd":"227","bNm":"까사미아","plan":[],"goodsPrc":39900,"goodsSalePrc":35900,"regDtm":[2023,11,21,13,49,17,699000000],"modDtm":[2023,12,7,14,30,38,2000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" 패키지2) 1차 임직원 | 2차 패키지딜 [1]","goodsCd":"151033","goodsImg":"https://imagestg2.guud.com//IL/item/202205/04/B_B3FC03BB51FA424896EFA993C7562307.jpg","goodsCateNm":"그림액자/포스터","goodsCate":"2833","lCd":"2633","lNm":"홈인테리어","mCd":"2679","mNm":"홈데코","sCd":"2833","sNm":"그림액자/포스터","bCd":"7061","bNm":"위아트","plan":[],"goodsPrc":38000,"goodsSalePrc":38000,"regDtm":[2023,12,7,11,24,8,823000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" 케이스1) 1차 없음 | 2차 없음","goodsCd":"24793","goodsImg":"https://imagestg2.guud.com//IL/item/202302/17/B_52D3717FF2BF442187BD0D79E8923B1E.jpg","goodsCateNm":"1인 리클라이너","goodsCate":"2504","lCd":"2430","lNm":"까사미아","mCd":"2432","mNm":"리빙룸","sCd":"2448","sNm":"리클라이너 소파","dCd":"2504","dNm":"1인 리클라이너","bCd":"227","bNm":"까사미아","plan":[],"goodsPrc":1010000,"goodsSalePrc":1010000,"regDtm":[2023,11,21,11,59,26,358000000],"modDtm":[2023,12,7,13,50,31,470000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" 노브 거실장_화이트","goodsCd":"35252","goodsImg":"https://imagestg2.guud.com//IL/item/202004/10/B_12E28377A0694B0DA66A5E80EFD3B49A.jpg","goodsCateNm":"TV/거실장","goodsCate":"2505","lCd":"2430","lNm":"까사미아","mCd":"2432","mNm":"리빙룸","sCd":"2449","sNm":"수납장","dCd":"2505","dNm":"TV/거실장","bCd":"41","bNm":"어니언","plan":[],"goodsPrc":200000,"goodsSalePrc":200000,"regDtm":[2023,11,28,14,11,25,499000000],"modDtm":[2023,12,7,13,57,14,676000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" 핏 드레스룸 1단행거장 800_브라운","goodsCd":"21718","goodsImg":"https://imagestg2.guud.com//IL/item/202106/07/B_E769F066EC334CB385C007B9D0B63EF3.jpg","goodsCateNm":"드레스룸","goodsCate":"2494","lCd":"2430","lNm":"까사미아","mCd":"2431","mNm":"베드룸","sCd":"2445","sNm":"옷장/드레스룸","dCd":"2494","dNm":"드레스룸","bCd":"41","bNm":"어니언","plan":[],"goodsPrc":240000,"goodsSalePrc":240000,"regDtm":[2023,12,7,9,14,17,899000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" [딜코드] onion 라임 3단서랍장 (컬러 택1)","goodsCd":"132966","goodsImg":"https://imagestg2.guud.com//IL/item/202201/24/B_24AFD29B1EA442998F5151A4A849B890.jpg","goodsCate":"2906","plan":[],"goodsPrc":340000,"goodsSalePrc":238000,"regDtm":[2023,11,21,13,54,1,135000000],"modDtm":[2023,12,7,11,23,8,737000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" 블룸 욕실슬리퍼 대형_그린","goodsCd":"61073","goodsImg":"https://imagestg2.guud.com//IL/item/202010/29/B_9EE00F7927C24ED38E662B7D304F705B.jpg","goodsCateNm":"기타(생활)","goodsCate":"2601","lCd":"2430","lNm":"까사미아","mCd":"2438","mNm":"수납/생활","sCd":"2474","sNm":"생활용품","dCd":"2601","dNm":"기타(생활)","bCd":"227","bNm":"까사미아","plan":[],"goodsPrc":11900,"goodsSalePrc":11900,"regDtm":[2023,11,21,13,53,38,32000000],"modDtm":[2023,12,7,14,39,41,567000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" 에어코일 매트리스 토퍼 Q","goodsCd":"155495","goodsImg":"https://imagestg2.guud.com//IL/item/202312/01/CF8F00FCD5CF48FB97D52E3416060921.jpg","goodsCateNm":"그림액자/포스터","goodsCate":"2833","lCd":"2633","lNm":"홈인테리어","mCd":"2679","mNm":"홈데코","sCd":"2833","sNm":"그림액자/포스터","bCd":"227","bNm":"까사미아","plan":[],"goodsPrc":319000,"goodsSalePrc":287000,"regDtm":[2023,11,21,13,54,18,143000000],"modDtm":[2023,12,7,13,56,45,280000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" 캄포클래식 4인소파_아이보리","goodsCd":"155491","goodsImg":"https://imagestg2.guud.com//IL/item/202312/01/6FF94C079FC34705B3BF6AB996D583C1.jpg","lCd":"4014","lNm":"가구/인테리어","mCd":"4018","mNm":"수납용품","bCd":"227","bNm":"까사미아","plan":[],"goodsPrc":3740000,"goodsSalePrc":2618000,"regDtm":[2023,11,22,9,24,17,958000000],"modDtm":[2023,12,7,14,43,8,533000000]}],"algorithmTypeCd":"GD"};
			}
			if(grbData && grbData.goodsList){
				var gbn = "top";
				this.goPrdDtl(grbData, gbn);
			}

			//하단추천
			var serviceKey_b = isPrd ? "RE3c6899ddede7468ca8bda8ab0c6d1ff4" : "REfe3d16a0f8564a3687e67fca10cc6eed";
			var grbData_b;
			if(/(guud.com)/ig.test(window.location.href)) {
				grbData_b = groobee.getGroobeeRecommend(serviceKey_b);
			} else{
			    grbData_b = {"campaignKey":"RE8657f9ccac6d41818a5a74ab2e1dfc7d","algorithmCd":"ST05","goodsList":[{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" 우스터 1인 리클라이너_브라운","goodsCd":"155489","goodsImg":"https://imagestg2.guud.com//IL/item/202312/01/2F3909B171C9482287274DC2F0DDBB1F.jpg","lCd":"4014","lNm":"가구/인테리어","mCd":"4018","mNm":"수납용품","bCd":"227","bNm":"까사미아","plan":[],"goodsPrc":1010000,"goodsSalePrc":707000,"regDtm":[2023,11,21,13,54,26,678000000],"modDtm":[2023,12,6,14,46,11,129000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" [단독특가] 브람스 국내제작 전체 원목 침대(SS/Q) 5colors","goodsCd":"43582","goodsImg":"https://imagestg2.guud.com//IL/item/202008/06/B_3D6FED44ED204C388C557ABFCC25A270.jpg","goodsCateNm":"일반침대","goodsCate":"2873","lCd":"2624","lNm":"bedddd","mCd":"2635","mNm":"침대","sCd":"2689","sNm":"슈퍼/싱글침대","dCd":"2873","dNm":"일반침대","bCd":"230","bNm":"웨스트프롬","plan":[],"goodsPrc":698000,"goodsSalePrc":335000,"regDtm":[2023,12,6,13,51,55,476000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" 올루미 유니크 사각 장스탠드","goodsCd":"56350","goodsImg":"https://imagestg2.guud.com//IL/item/202009/15/B_29E0C3AD67B54A7FBA2CED154355B31D.jpg","goodsCateNm":"플로어조명","goodsCate":"2821","lCd":"2633","lNm":"홈인테리어","mCd":"2675","mNm":"조명","sCd":"2821","sNm":"플로어조명","bCd":"607","bNm":"올루미","plan":[],"goodsPrc":81800,"goodsSalePrc":80000,"regDtm":[2023,11,24,10,3,42,81000000],"modDtm":[2023,12,6,12,19,51,256000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" 번드 For casamiashop 우디 화이트 라탄 협탁","goodsCd":"44929","goodsImg":"https://imagestg2.guud.com//IL/item/202206/03/B_4A588974BB994752B7A96CB1E1E33EFB.jpg","goodsCateNm":"협탁","goodsCate":"2699","lCd":"2624","lNm":"bedddd","mCd":"2638","mNm":"서랍장/협탁","sCd":"2699","sNm":"협탁","bCd":"266","bNm":"번드","plan":[],"goodsPrc":160000,"goodsSalePrc":160000,"regDtm":[2023,11,21,12,14,15,73000000],"modDtm":[2023,12,7,12,15,55,622000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" 꾸미까 스텐 키친툴 조리도구 (8type)","goodsCd":"109262","goodsImg":"https://imagestg2.guud.com//IL/item/202108/25/B_F324FAAF9B1E499192EA67CA20DEC71D.jpg","goodsCateNm":" 조리도구기타","goodsCate":"3175","lCd":"2631","lNm":"주방용품","mCd":"3168","mNm":"도마/칼/조리도구","sCd":"3175","sNm":" 조리도구기타","bCd":"3361","bNm":"꾸미까","plan":[],"goodsPrc":3200,"goodsSalePrc":2700,"regDtm":[2023,11,28,14,53,52,369000000],"modDtm":[2023,12,7,14,18,29,28000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" 패키지4) 1차 행사할인 | 2차 패키지딜 [1]","goodsCd":"126637","goodsImg":"https://imagestg2.guud.com//IL/item/202112/06/B_86DF1D60EBD549C28E6B7D8413E04B3C.jpg","goodsCateNm":"러그/카페트","goodsCate":"2856","lCd":"2634","lNm":"패브릭","mCd":"2684","mNm":"러그/매트","sCd":"2856","sNm":"러그/카페트","bCd":"452","bNm":"한일카페트","plan":[],"goodsPrc":90000,"goodsSalePrc":90000,"regDtm":[2023,11,22,12,14,36,495000000],"modDtm":[2023,12,7,11,25,5,564000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" 캄포클래식 3인소파_아이보리","goodsCd":"155493","goodsImg":"https://imagestg2.guud.com//IL/item/202312/01/4DED28DDEDCE47B2BFE13C15AC51C2DE.jpg","goodsCateNm":"그림액자/포스터","goodsCate":"2833","lCd":"2633","lNm":"홈인테리어","mCd":"2679","mNm":"홈데코","sCd":"2833","sNm":"그림액자/포스터","bCd":"227","bNm":"까사미아","plan":[],"goodsPrc":2700000,"goodsSalePrc":1890000,"regDtm":[2023,11,21,11,49,37,857000000],"modDtm":[2023,12,7,14,18,10,449000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" 에디트 드레스룸 디바이더서랍장","goodsCd":"20966","goodsImg":"https://imagestg2.guud.com//IL/item/202105/27/B_C87A2CFCE7AB44FDA5E6ABAD339557B8.jpg","goodsCateNm":"드레스룸","goodsCate":"2494","lCd":"2430","lNm":"까사미아","mCd":"2431","mNm":"베드룸","sCd":"2445","sNm":"옷장/드레스룸","dCd":"2494","dNm":"드레스룸","bCd":"41","bNm":"어니언","plan":[],"goodsPrc":480000,"goodsSalePrc":480000,"regDtm":[2023,12,6,9,13,55,233000000],"modDtm":[2023,12,7,9,14,7,913000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" 패키지1) 1차 없음 | 패키지딜 [1]","goodsCd":"129564","goodsImg":"https://imagestg2.guud.com//IL/item/202201/06/B_7F6CECBA0CCE463BB2E4B70D39406871.jpg","goodsCateNm":"러그/카페트","goodsCate":"2856","lCd":"2634","lNm":"패브릭","mCd":"2684","mNm":"러그/매트","sCd":"2856","sNm":"러그/카페트","bCd":"1383","bNm":"아다마알마","plan":[],"goodsPrc":498000,"goodsSalePrc":498000,"regDtm":[2023,12,7,11,23,40,803000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" e스마트 코어 낮은 벙커침대 H1600 매트포함","goodsCd":"121319","goodsImg":"https://imagestg2.guud.com//IL/item/202111/04/B_8F78E23DCB614BB68F0FFBD1B1B957A8.jpg","lCd":"4050","lNm":"유아동가구","mCd":"4053","mNm":"유아동침대","bCd":"2064","bNm":"e스마트","plan":[],"goodsPrc":1600000,"goodsSalePrc":1146000,"regDtm":[2023,11,21,13,51,30,987000000],"modDtm":[2023,12,7,15,36,10,434000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" 올루미 코니아일랜드 장스탠드 (블랙)","goodsCd":"56097","goodsImg":"https://imagestg2.guud.com//IL/item/202009/15/B_12BDE11B28B74BD7AAFBBEF11CC236AA.jpg","goodsCateNm":"플로어조명","goodsCate":"2821","lCd":"2633","lNm":"홈인테리어","mCd":"2675","mNm":"조명","sCd":"2821","sNm":"플로어조명","bCd":"607","bNm":"올루미","plan":[],"goodsPrc":75300,"goodsSalePrc":75300,"regDtm":[2023,12,7,11,24,40,362000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" 패키지3) 1차 즉시적용쿠폰 | 2차 패키지딜 [1]","goodsCd":"130617","goodsImg":"https://imagestg2.guud.com//IL/item/202207/19/B_B2E902540D0741B1B9701B539ED3CD71.jpg","goodsCateNm":"러그/카페트","goodsCate":"2856","lCd":"2634","lNm":"패브릭","mCd":"2684","mNm":"러그/매트","sCd":"2856","sNm":"러그/카페트","bCd":"3465","bNm":"데이드리머","plan":[],"goodsPrc":211250,"goodsSalePrc":211250,"regDtm":[2023,11,22,16,40,31,718000000],"modDtm":[2023,12,7,11,24,20,514000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" 헤이즈 사이드테이블","goodsCd":"23010","goodsImg":"https://imagestg2.guud.com//IL/item/202112/08/B_30FDFE623B364828886281D3CB44F62A.jpg","goodsCateNm":"사이드테이블","goodsCate":"2489","lCd":"2430","lNm":"까사미아","mCd":"2431","mNm":"베드룸","sCd":"2443","sNm":"사이드테이블","dCd":"2489","dNm":"사이드테이블","bCd":"41","bNm":"어니언","plan":[],"goodsPrc":230000,"goodsSalePrc":230000,"regDtm":[2023,11,23,12,20,20,431000000],"modDtm":[2023,12,7,13,50,41,244000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" 에어코일 베개","goodsCd":"155496","goodsImg":"https://imagestg2.guud.com//IL/item/202312/01/B81ABADD01D542528B30E02363FDF4BA.jpg","goodsCateNm":"그림액자/포스터","goodsCate":"2833","lCd":"2633","lNm":"홈인테리어","mCd":"2679","mNm":"홈데코","sCd":"2833","sNm":"그림액자/포스터","bCd":"227","bNm":"까사미아","plan":[],"goodsPrc":39900,"goodsSalePrc":35900,"regDtm":[2023,11,21,13,49,17,699000000],"modDtm":[2023,12,7,14,30,38,2000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" 패키지2) 1차 임직원 | 2차 패키지딜 [1]","goodsCd":"151033","goodsImg":"https://imagestg2.guud.com//IL/item/202205/04/B_B3FC03BB51FA424896EFA993C7562307.jpg","goodsCateNm":"그림액자/포스터","goodsCate":"2833","lCd":"2633","lNm":"홈인테리어","mCd":"2679","mNm":"홈데코","sCd":"2833","sNm":"그림액자/포스터","bCd":"7061","bNm":"위아트","plan":[],"goodsPrc":38000,"goodsSalePrc":38000,"regDtm":[2023,12,7,11,24,8,823000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" 케이스1) 1차 없음 | 2차 없음","goodsCd":"24793","goodsImg":"https://imagestg2.guud.com//IL/item/202302/17/B_52D3717FF2BF442187BD0D79E8923B1E.jpg","goodsCateNm":"1인 리클라이너","goodsCate":"2504","lCd":"2430","lNm":"까사미아","mCd":"2432","mNm":"리빙룸","sCd":"2448","sNm":"리클라이너 소파","dCd":"2504","dNm":"1인 리클라이너","bCd":"227","bNm":"까사미아","plan":[],"goodsPrc":1010000,"goodsSalePrc":1010000,"regDtm":[2023,11,21,11,59,26,358000000],"modDtm":[2023,12,7,13,50,31,470000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" 노브 거실장_화이트","goodsCd":"35252","goodsImg":"https://imagestg2.guud.com//IL/item/202004/10/B_12E28377A0694B0DA66A5E80EFD3B49A.jpg","goodsCateNm":"TV/거실장","goodsCate":"2505","lCd":"2430","lNm":"까사미아","mCd":"2432","mNm":"리빙룸","sCd":"2449","sNm":"수납장","dCd":"2505","dNm":"TV/거실장","bCd":"41","bNm":"어니언","plan":[],"goodsPrc":200000,"goodsSalePrc":200000,"regDtm":[2023,11,28,14,11,25,499000000],"modDtm":[2023,12,7,13,57,14,676000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" 핏 드레스룸 1단행거장 800_브라운","goodsCd":"21718","goodsImg":"https://imagestg2.guud.com//IL/item/202106/07/B_E769F066EC334CB385C007B9D0B63EF3.jpg","goodsCateNm":"드레스룸","goodsCate":"2494","lCd":"2430","lNm":"까사미아","mCd":"2431","mNm":"베드룸","sCd":"2445","sNm":"옷장/드레스룸","dCd":"2494","dNm":"드레스룸","bCd":"41","bNm":"어니언","plan":[],"goodsPrc":240000,"goodsSalePrc":240000,"regDtm":[2023,12,7,9,14,17,899000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" [딜코드] onion 라임 3단서랍장 (컬러 택1)","goodsCd":"132966","goodsImg":"https://imagestg2.guud.com//IL/item/202201/24/B_24AFD29B1EA442998F5151A4A849B890.jpg","goodsCate":"2906","plan":[],"goodsPrc":340000,"goodsSalePrc":238000,"regDtm":[2023,11,21,13,54,1,135000000],"modDtm":[2023,12,7,11,23,8,737000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" 블룸 욕실슬리퍼 대형_그린","goodsCd":"61073","goodsImg":"https://imagestg2.guud.com//IL/item/202010/29/B_9EE00F7927C24ED38E662B7D304F705B.jpg","goodsCateNm":"기타(생활)","goodsCate":"2601","lCd":"2430","lNm":"까사미아","mCd":"2438","mNm":"수납/생활","sCd":"2474","sNm":"생활용품","dCd":"2601","dNm":"기타(생활)","bCd":"227","bNm":"까사미아","plan":[],"goodsPrc":11900,"goodsSalePrc":11900,"regDtm":[2023,11,21,13,53,38,32000000],"modDtm":[2023,12,7,14,39,41,567000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" 에어코일 매트리스 토퍼 Q","goodsCd":"155495","goodsImg":"https://imagestg2.guud.com//IL/item/202312/01/CF8F00FCD5CF48FB97D52E3416060921.jpg","goodsCateNm":"그림액자/포스터","goodsCate":"2833","lCd":"2633","lNm":"홈인테리어","mCd":"2679","mNm":"홈데코","sCd":"2833","sNm":"그림액자/포스터","bCd":"227","bNm":"까사미아","plan":[],"goodsPrc":319000,"goodsSalePrc":287000,"regDtm":[2023,11,21,13,54,18,143000000],"modDtm":[2023,12,7,13,56,45,280000000]},{"serviceKey":"d645d4a28740425e8623e19bf4248596","goodsNm":" 캄포클래식 4인소파_아이보리","goodsCd":"155491","goodsImg":"https://imagestg2.guud.com//IL/item/202312/01/6FF94C079FC34705B3BF6AB996D583C1.jpg","lCd":"4014","lNm":"가구/인테리어","mCd":"4018","mNm":"수납용품","bCd":"227","bNm":"까사미아","plan":[],"goodsPrc":3740000,"goodsSalePrc":2618000,"regDtm":[2023,11,22,9,24,17,958000000],"modDtm":[2023,12,7,14,43,8,533000000]}],"algorithmTypeCd":"GD"};
			}
			if(grbData_b && grbData_b.goodsList){
				var gbn = "bottom";
				this.goPrdDtl(grbData_b, gbn);
			}
		},

		async goPrdDtl(grbData, gbn){
			if(grbData.goodsList != null){
				var param = {
					"ID_LIST" : []
				};

				$.each(grbData.goodsList, function(idx, val){
					param["ID_LIST"].push(val.goodsCd);
				});

				var strIdList = param["ID_LIST"].toString();
				param["ID_LIST"] = strIdList;
				if(strIdList.length > 0){
					try {
						const response = await this.$store.dispatch("network/request", {
							method: "post",
							url: "/main/getRecPrdInfo",
							data: param
						});

						var showData = [], showRecGoods = [];

						if(response.RETURN_CODE) {
							$.each(response.recRows.data, function(idx, val) {
								if(val != undefined){
									if(showData.length == 12){
										return;
									}

									if(mainType == "H"){ //굳닷컴헤더면 굳,까사 12개 노출
										showData.push(val);
										showRecGoods.push({"goodsCd" : val.IL_ITEM_ID});
									}else if(mainType == "C"){ // 까사헤더면 까사것만 12개 노출
										if(val.MAIN_TYPE =="C"){
											showData.push(val);
											showRecGoods.push({"goodsCd" : val.IL_ITEM_ID});
										}
									}
								}
							});

							showData.push({
								algorithmCd : grbData.algorithmCd,
								campaignKey : grbData.campaignKey
							});

							var gbnCnt = 5;
							if(gbn == "top"){
								this.resRecPrdInfo = showData;
							}else if (gbn == "bottom"){
								this.resRecPrdInfo_b = showData;
							}else if (gbn == "like"){
								this.resRecPrdInfo_like = showData;
								gbnCnt = 6;
							}

							//노출된 추천상품을 그루비에 던진다.
							if(showRecGoods.length >= gbnCnt){
								var groobeeObj = {
									algorithmCd : grbData.algorithmCd,
									campaignKey : grbData.campaignKey,
									campaignTypeCd : "RE",
									goods: showRecGoods
								}
								if(/(guud.com)/ig.test(window.location.href)) {
									groobee.send("DI", groobeeObj);
								}
								this.$nextTick(() => {
									if (gbn != "like"){
										this.aiRecommandSlider(gbn);
									} else if(this.addWishGroobeePopOpenYn == "Y") {
										this.aiPopOpen();
										this.addWishGroobeePopOpenYn = "N";
									}
								});
							}
						}
					}
					catch(ex) {
						console.error("request getRecPrdInfo exception... ", ex);
					}
				}
			}
		},

		clickGroobeeProduct (goodsCd, algorithmCd, campaignKey ){
			var groobeeObj = {
				algorithmCd: algorithmCd,
				campaignKey: campaignKey,
				campaignTypeCd: "RE",
				goods: [
					{ goodsCd : goodsCd }
				]
			}
			groobee.send("CL", groobeeObj);
		},

		async requestAdultChk(value) {
			try {
				const response = await this.$store.dispatch("network/request", {
					method: "post",
					url: "/kmcis/verify",
				});

				if (response && response.RESULT !== 'F') {
					const result = response.EXPIRE_YN;
					if (result === 'Y') {
						await this.processKmc(); // kmc 호출
					} else {
						this.isAdult = true;
						if(value === "O") {
							this.checkOrderItem();
						} else {
							this.checkCartIn();
						}
					}
				} else if (response.RESULT === 'F') {
					console.log("Response indicates failure (RESULT = 'F')");
					await this.processKmc(); // 실패 시 kmc 호출
				} else {
					console.error('Unexpected response format:', response);
					this.isAdult = false;
				}
			} catch (ex) {
				console.error('requestAdultYn exception.. ', ex);
				this.isAdult = false;
			}
		},
		async processKmc() {
			//window.open("/kmcis/step1"+"?itemId="+this.goodItems.IL_ITEM_ID, "KMCISWindow", "width=600,height=400,resizable=1,scrollbars=1");
			this.openPopup();
		},

		// 리뷰이미지 디폴트 처리
		handleImageError324x324(event) {
			event.target.src = '/pc/assets/images/shop/img_deleted_thumbnail_324x324.png';
		},
		handleImageError670x834(event) {
			event.target.src = '/pc/assets/images/shop/img_deleted_thumbnail_670x834.png';
		},
	},

	filters: {
		parePriceFilter(data) {
			if (data.indexOf('%') >= 0) {
				return data.replace('%', '');
			} else {
				return data
					.replace('원', '')
					.toString()
					.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
			}
		},

		currency: (value) => {
			if (value == '' || value == null) {
				return '0';
			} else {
				let num = Number(value);

				if (num.toFixed(0) == 'NaN') return 0;
				else return num.toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,');
			}
		},
		/*
		 * [렌탈/구독 서비스][김재성] 렌트주문 '예상 월 납입금액' 표시
		 *  - 소수점 반올린 round 처리
		 */
		rentalType: function rentalType(value, term) {
			//console.log('rentalType :', value, term);
			if (value == '' || value == null) {
				return '0';
			} else {
				var num = Number(value);
				var installmentTerm = Number(term);
				var numPrice = Math.round(num / installmentTerm);

				if (numPrice.toFixed(0) == 'NaN') {
					return 0;
				} else {
					return numPrice.toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,');
				}
			}
		},



	},
});


//배송가능일자보기
function dlvdatePicker(disallowedDates){
	var dlvY;
	var dlvM;
	var dlvD;

	var picker = new Pikaday({
	field: document.getElementById("fb__date-picker"),
	minDate: moment().format("YYYY-MM-DD"),



	maxDate: moment().add(90,"days").format("YYYY-MM-DD"),
	bound: false,
	yearRange: [2020,2030],
	keyboardInput:false,
	i18n: {
		months: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
		weekdays: ['일요일', '월요일', '화요일', '수요일', '목요일', '금요일', '토요일'],
		weekdaysShort: ['일', '월', '화', '수', '목', '금', '토']
	},
	defaultDate : moment().format('YYYY-MM-DD'),
	onSelect: function onSelect(date) {
		dlvY = moment(date).format('YYYY');
		dlvM = moment(date).format('MM');
		dlvD = moment(date).format('DD');
		$('.dateChoice .date').text(dlvY+'년 '+dlvM+'월 '+dlvD+'일 배송일 지정');
	},
		disableDayFn:function(theDate){
			if (disallowedDates.indexOf(moment(theDate).format('YYYY-MM-DD')) != -1) {
				return false;
			} else {
				return true;
			}
		}
	});
}

/*window.onload = function () {
	// Vue 인스턴스의 calculateHeight 메서드 호출
	setTimeout(function(){
		goodsView.checkGoodsDetailHeight();
	},5000);
};*/
